// https://minify-js.com/
import {
  $4,
  $$4,
  $id4,
  isRTL,
  formatMoney,
  debounce,
  getterAdd,
  getterGet,
  getterRunFn,
  btnTooltip,
  Drawer,
  VariantChangeBase,
} from "global";

// WISHLIST
var $wishlist_list = $id4("hdt_wishlist_list"),
  $compare_list = $id4("hdt_compare_list"),
  nameCachedWishlist = "theme4:wishlist:id",
  nameCachedCompare = "theme4:compare:id";
// if exit $wishlist_list is use app wishlist the4
if ($wishlist_list) {
  var arr_wishlist_list = $wishlist_list.textContent
    ? $wishlist_list.textContent.split(" ")
    : [];
} else {
  var arr_wishlist_list = !localStorage.getItem(nameCachedWishlist)
    ? []
    : localStorage.getItem(nameCachedWishlist).split(","); // remove id: and conver array
}
if ($compare_list) {
  var arr_compare_list = $compare_list.textContent
    ? $compare_list.textContent.split(" ")
    : [];
} else {
  var arr_compare_list = !localStorage.getItem(nameCachedCompare)
    ? []
    : localStorage.getItem(nameCachedCompare).split(","); // remove id: and conver array
}
// arr_wishlist_list = [1234, 5678, 9011]
// arr_compare_list = [1234, 5678, 9011]

var linkWishlistApp = "/apps/ecomrise/wishlist",
  linkCompareApp = "/apps/ecomrise/compare",
  actionAfterWishlistAdded = themeHDN.extras.AddedWishlistRemove
    ? "remove"
    : "added",
  actionAfterCompareAdded = themeHDN.extras.AddedCompareRemove
    ? "remove"
    : "added",
  limitWishlist = $wishlist_list ? 100 : 50,
  limitCompare = 6,
  conver_to_link_fn = function (prefix = this.textFn, array = this.array) {
    const x = themeHDN.routes.search_url + `/?view=${prefix}`,
      y = x + "&type=product&options[unavailable_products]=last&q=";
    return array.length ? y + encodeURI(`id:${array.join(" OR id:")}`) : x;
  };
// Reset if limit change
if (arr_wishlist_list.length > limitWishlist) {
  arr_wishlist_list.splice(limitWishlist - 1, arr_wishlist_list.length - 1);
  localStorage.setItem(nameCachedWishlist, arr_wishlist_list.toString());
}
// Check is page has item but not show reload page
if (window.isPageWishlist) {
  if (arr_wishlist_list.length && !window.isWishlistPerformed) {
    window.location.href = conver_to_link_fn("wishlist", arr_wishlist_list);
  } else {
    window.history.replaceState(
      {},
      document.title,
      conver_to_link_fn("wishlist", []),
    );
  }
  themeHDN.wisHref = conver_to_link_fn("wishlist", arr_wishlist_list);
}

// Reset if limit change
if (arr_compare_list.length > limitCompare) {
  arr_compare_list.splice(limitCompare - 1, arr_compare_list.length - 1);
  localStorage.setItem(nameCachedCompare, arr_compare_list.toString());
}
// Check is page has item but not show reload page
if (window.isPageCompare) {
  if (arr_compare_list.length && !window.isComparePerformed) {
    window.location.href = conver_to_link_fn("compare", arr_compare_list);
  } else {
    window.history.replaceState(
      {},
      document.title,
      conver_to_link_fn("compare", []),
    );
  }
}
var _wishlist_id,
  _wishlist_handle,
  _update_wis_text,
  update_wis_text_fn,
  _update_wis_btns,
  update_wis_btns_fn,
  _click_wis,
  click_wis_fn,
  _add_wis,
  add_wis_fn,
  _remove_wis,
  remove_wis_fn,
  _action_after_remove_add,
  action_after_remove_add_fn,
  _show_popup_compare,
  show_popup_compare_fn,
  _conver_to_link;
class Wishlist extends btnTooltip {
  constructor() {
    super();
    getterAdd(_wishlist_id, this, this.dataset.id);
    getterAdd(_wishlist_handle, this, this.dataset.handle);
    getterAdd(_update_wis_text, this);
    getterAdd(_update_wis_btns, this);
    getterAdd(_click_wis, this);
    getterAdd(_add_wis, this);
    getterAdd(_remove_wis, this);
    getterAdd(_action_after_remove_add, this);
    getterAdd(_show_popup_compare, this);
    getterAdd(_conver_to_link, this);
    this.tabIndex = 0;
    this.addEventListener("click", () =>
      getterRunFn(_click_wis, this, click_wis_fn).call(this),
    );
    this.addEventListener("keydown", (event) => {
      if (event.key == "Enter")
        getterRunFn(_click_wis, this, click_wis_fn).call(this);
    });
  }
  static get observedAttributes() {
    return ["action"];
  }
  get isFnWishlist() {
    return true;
  }
  get textFn() {
    return "wishlist";
  }
  get isPageWishlistorCompare() {
    //add code check page
    return this.isFnWishlist ? window.isPageWishlist : window.isPageCompare;
  }
  get limit() {
    return this.isFnWishlist ? limitWishlist : limitCompare;
  }
  get nameCached() {
    return this.isFnWishlist ? nameCachedWishlist : nameCachedCompare;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get actionAfterAdded() {
    return this.isFnWishlist
      ? actionAfterWishlistAdded
      : actionAfterCompareAdded;
  }
  get action() {
    return this.getAttribute("action");
  }
  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue || (oldValue === null && newValue === "add"))
      return;
    getterRunFn(_update_wis_text, this, update_wis_text_fn).call(
      this,
      newValue,
    );
    super.attributeChangedCallback(name, oldValue, newValue);
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.array.indexOf(getterGet(_wishlist_id, this)) > -1) {
      if (this.hasAttribute("remove-on-page")) {
        return;
      }
      this.setAttribute("action", this.actionAfterAdded);
    }
  }
}
_wishlist_id = new WeakMap();
_wishlist_handle = new WeakMap();
_update_wis_text = new WeakSet();
_update_wis_btns = new WeakSet();
_click_wis = new WeakSet();
_add_wis = new WeakSet();
_remove_wis = new WeakSet();
_action_after_remove_add = new WeakSet();
_conver_to_link = new WeakSet();
_show_popup_compare = new WeakSet();
update_wis_text_fn = function (value) {
  if (this.hasAttribute("remove-on-page")) return;
  const text =
      themeHDN.extras[`text_${this.isFnWishlist ? "wis" : "cp"}_${value}`],
    icon = themeHDN.extras[`icon_${this.isFnWishlist ? "wis" : "cp"}_${value}`];
  if (icon)
    this.firstElementChild.replaceWith(
      document.createRange().createContextualFragment(icon),
    );
  if (text) {
    this.lastElementChild.textContent = text;
    this.setAttribute("data-txt-tt", text);
  }
};
update_wis_btns_fn = function (_action) {
  // Update Button
  $$4(`hdt-${this.textFn}[data-id="${getterGet(_wishlist_id, this)}"]`).forEach(
    (btn) => {
      btn.setAttribute("action", _action);
    },
  );
  // Update Count and link
  document.dispatchEvent(
    new CustomEvent(`theme4:${this.textFn}:update`, {
      bubbles: true,
      detail: "the4", // arr_wishlist_list
    }),
  );
  if (window.isPageWishlist)
    themeHDN.wisHref = conver_to_link_fn("wishlist", arr_wishlist_list);
};
click_wis_fn = function (e) {
  if (this.action == "add") {
    // ADD
    getterRunFn(_add_wis, this, add_wis_fn).call(this);
  } else if (this.action === "added") {
    // ADDED: go to page wishlist
    if (!this.isFnWishlist && themeHDN.extras.enableComparePopup) {
      getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
    } else {
      window.location.href = getterRunFn(
        _conver_to_link,
        this,
        conver_to_link_fn,
      ).call(this);
    }
  } else {
    // REMOVE
    getterRunFn(_remove_wis, this, remove_wis_fn).call(this);
  }
};
add_wis_fn = function (e) {
  if (
    ($wishlist_list && this.isFnWishlist) ||
    ($compare_list && !this.isFnWishlist)
  ) {
    // app wishlist
    this.setAttribute("aria-busy", true);
    fetch(this.isFnWishlist ? linkWishlistApp : linkCompareApp, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        product_id: getterGet(_wishlist_id, this),
        product_handle: getterGet(_wishlist_handle, this),
        action: "add",
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.status != "success") {
          console.error(data.message || "Unknow error");
          return;
        }
        if (this.isFnWishlist) {
          arr_wishlist_list = JSON.parse(
            data.response.metafield.value,
          ).ecomrise_ids;
          if (!Array.isArray(arr_wishlist_list)) {
            arr_wishlist_list = arr_wishlist_list.split(",");
          }
        }
        if (!this.isFnWishlist) {
          arr_compare_list = JSON.parse(
            data.response.metafield.value,
          ).ecomrise_ids;
          if (!Array.isArray(arr_compare_list)) {
            arr_compare_list = arr_compare_list.split(",");
          }
          getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(
            this,
          );
        }
        getterRunFn(
          _action_after_remove_add,
          this,
          action_after_remove_add_fn,
        ).call(this, this.actionAfterAdded);
      })
      .catch(function (error) {
        console.log("Error: " + error);
      })
      .finally(() => {
        this.setAttribute("aria-busy", false);
      });
  } else {
    // local wishlist
    // adds the specified elements to the beginning of an array
    this.array.unshift(getterGet(_wishlist_id, this));
    //console.log(this.array, getterGet(_wishlist_id, this))
    if (this.array.length > this.limit) {
      // if over limit remove element on last array
      let arraySplice = this.array.splice(this.limit, 1);
      // arraySplice: allway has 1 element
      $$4(`hdt-${this.textFn}[data-id="${arraySplice[0]}"]`).forEach((btn) => {
        btn.setAttribute("action", "add");
      });
    }
    if (!this.isFnWishlist)
      getterRunFn(_show_popup_compare, this, show_popup_compare_fn).call(this);
    getterRunFn(
      _action_after_remove_add,
      this,
      action_after_remove_add_fn,
    ).call(this, this.actionAfterAdded);
    localStorage.setItem(this.nameCached, this.array.toString());
  }
};
remove_wis_fn = function (e) {
  // REMOVE
  if (
    ($wishlist_list && this.isFnWishlist) ||
    ($compare_list && !this.isFnWishlist)
  ) {
    // app wishlist
    this.setAttribute("aria-busy", true);
    fetch(this.isFnWishlist ? linkWishlistApp : linkCompareApp, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        product_id: getterGet(_wishlist_id, this),
        product_handle: getterGet(_wishlist_handle, this),
        action: "add",
        _method: "DELETE",
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.status != "success") {
          console.error(data.message || "Unknow error");
          return;
        }
        arr_wishlist_list = JSON.parse(
          data.response.metafield.value,
        ).ecomrise_ids;
        if (!Array.isArray(arr_wishlist_list)) {
          arr_wishlist_list = arr_wishlist_list.split(",");
        }
        getterRunFn(
          _action_after_remove_add,
          this,
          action_after_remove_add_fn,
        ).call(this, "add");
      })
      .catch(function (error) {
        console.log("Error: " + error);
      })
      .finally(() => {
        this.setAttribute("aria-busy", false);
      });
  } else {
    // local wishlist
    this.array.splice(this.array.indexOf(getterGet(_wishlist_id, this)), 1);
    localStorage.setItem(this.nameCached, this.array.toString());

    getterRunFn(
      _action_after_remove_add,
      this,
      action_after_remove_add_fn,
    ).call(this, "add");
  }
};
action_after_remove_add_fn = function (action) {
  if (
    this.getAttribute("action") == "remove" &&
    this.hasAttribute("remove-on-page")
  ) {
    if (this.isFnWishlist) {
      this.closest(".hdt-card-product").remove();
    } else {
      $$4(`.hdt-compare-item-${getterGet(_wishlist_id, this)}`).forEach(
        (item) => {
          item.remove();
        },
      );
    }
    getterRunFn(_update_wis_btns, this, update_wis_btns_fn).call(this, action);
    if (this.array.length == 0) {
      $id4(`drawerCompare`)?.removeAttribute("open");
      if (this.isPageWishlistorCompare)
        window.location.href = getterRunFn(
          _conver_to_link,
          this,
          conver_to_link_fn,
        ).call(this);
    }
    //this.setAttribute('action', action);
  } else {
    getterRunFn(_update_wis_btns, this, update_wis_btns_fn).call(this, action);
    // is page wishlist or compare reload page
    if (this.isPageWishlistorCompare)
      window.location.href = getterRunFn(
        _conver_to_link,
        this,
        conver_to_link_fn,
      ).call(this);
  }
};
show_popup_compare_fn = function (event) {
  if (!themeHDN.extras.enableComparePopup || this.isPageWishlistorCompare)
    return;
  // add code if want show popup compare
  $id4(`drawerCompare`).setAttribute("open", "");
  fetch(
    conver_to_link_fn("compare", arr_compare_list) +
      "&section_id=compare-offcanvas",
  )
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const prds = html.querySelector("offcanvas-compare");

      if (prds && prds.innerHTML.trim().length) {
        $4("offcanvas-compare").innerHTML = prds.innerHTML;
      }
    })
    .catch((e) => {
      console.error(e);
    });
};
var _clear_all, clear_all_fn;
class ClearAll extends HTMLElement {
  constructor() {
    super();
    getterAdd(_clear_all, this);
    this.tabIndex = 0;
    this.addEventListener("click", getterRunFn(_clear_all, this, clear_all_fn));
    this.addEventListener("keydown", (event) => {
      if (event.key == "Enter")
        getterRunFn(_clear_all, this, clear_all_fn).call(this);
    });
  }
  get ofFn() {
    return this.getAttribute("of-fn"); //'compare', 'wishlist'
  }
  get nameCached() {
    return this.ofFn == "compare" ? nameCachedCompare : nameCachedWishlist;
  }
  set array(value) {
    this.ofFn == "compare"
      ? (arr_compare_list = value)
      : (arr_wishlist_list = value);
  }
}
_clear_all = new WeakSet();
clear_all_fn = function () {
  localStorage.removeItem(this.nameCached);
  // Update Buttons
  $$4(`hdt-${this.ofFn}[action="added"]`).forEach((btn) => {
    btn.setAttribute("action", "add");
  });
  // Update Count and link
  document.dispatchEvent(
    new CustomEvent(`theme4:${this.ofFn}:update`, {
      bubbles: true,
      detail: "the4",
    }),
  );
  this.array = [];
  $id4(`drawerCompare`)?.removeAttribute("open");
  if ($4(`#drawerCompare offcanvas-compare`)) {
    $4(`#drawerCompare offcanvas-compare`).innerHTML = "";
  }
};
customElements.define("hdt-clear-all", ClearAll);
// eg: <hdt-clear-all role="button" of-fn="compare">Clear All </hdt-clear-all>

// Update count
class WishlistCount extends HTMLElement {
  constructor() {
    super();
    this.textContent = this.array.length;
    document.addEventListener(`theme4:${this.prefix}:update`, (e) => {
      //console.log(this.prefix + ' count update.');
      this.textContent = this.array.length;
    });
  }
  get isFnWishlist() {
    return true;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get prefix() {
    return this.isFnWishlist ? "wishlist" : "compare";
  }
}
// Update link page
class WishlistLink extends HTMLElement {
  constructor() {
    super();
    $4("a", this).href = conver_to_link_fn(this.prefix, this.array);
    //console.log('WishlistLink', this.href)
    document.addEventListener(`theme4:${this.prefix}:update`, (e) => {
      $4("a", this).href = conver_to_link_fn(this.prefix, this.array);
    });
  }
  get isFnWishlist() {
    return true;
  }
  get array() {
    return this.isFnWishlist ? arr_wishlist_list : arr_compare_list;
  }
  get prefix() {
    return this.isFnWishlist ? "wishlist" : "compare";
  }
}
customElements.define("hdt-wishlist", Wishlist);
customElements.define("hdt-wishlist-count", WishlistCount);
customElements.define("hdt-wishlist-a", WishlistLink);

// COMPARE
class Compare extends Wishlist {
  get isFnWishlist() {
    return false;
  }
  get textFn() {
    return "compare";
  }
}
// Update count
class CompareCount extends WishlistCount {
  get isFnWishlist() {
    return false;
  }
}
// Update link page
class CompareLink extends WishlistLink {
  get isFnWishlist() {
    return false;
  }
}
customElements.define("hdt-compare", Compare);
customElements.define("hdt-compare-count", CompareCount);
customElements.define("hdt-compare-a", CompareLink);

// --------------------------
// Product Recommendations
// --------------------------
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          document.dispatchEvent(new CustomEvent("currency:update"));
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// --------------------------
// Product Recently
// --------------------------
class ProductRecently extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      let handleProducts = localStorage.getItem("theme4:recently:id");
      let prdId = this.dataset.id;

      if (handleProducts !== null) {
        let products = handleProducts.split(",");
        let url = this.dataset.url.replace(
          "q=",
          "q=id:" + products.join("%20OR%20id:"),
        );
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recently = html.querySelector("product-recently");

            if (recently && recently.innerHTML.trim().length) {
              this.innerHTML = recently.innerHTML;
            }
            document.dispatchEvent(new CustomEvent("currency:update"));
          })
          .catch((e) => {
            console.error(e);
          });
      }
      let arrayProducts =
        handleProducts !== null ? handleProducts.split(",") : new Array();
      if (!arrayProducts.includes(prdId + "")) {
        if (arrayProducts.length >= 10) {
          arrayProducts.pop();
        }
        function prepend(value, array) {
          var newArray = array.slice();
          newArray.unshift(value);
          return newArray;
        }
        arrayProducts = prepend(prdId, arrayProducts);
        arrayProducts = arrayProducts.toString();
        localStorage.setItem("theme4:recently:id", arrayProducts);
      }
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recently", ProductRecently);

// --------------------------
// Predictive Search
// --------------------------
class PredictiveSearch extends Drawer {
  constructor() {
    super();
    // console.log(!this.hasAttribute('enabled'))
    if (!this.hasAttribute("enabled")) return;
    this.cachedResults = {};
    this.predictiveSearchResults = $4("[data-results-search]", this);
    this.input = $4('input[type="search"]', this);
    this.sectionIdResults =
      this.getAttribute("data-section-id-results") || "hdt_predictive-search";
    this.allPredictiveSearchInstances = $$4("predictive-search");
    this.skeleton = $4("[data-skeleton-search]", this);
    this.noResults = $4(".hdt-cart-no-results", this);
    this.hideWrapper = $4(".hdt-cart-hide-has-results", this);
    this.showWrapper = $4(".hdt-cart-show-has-results", this);
    this.btn_viewall = $4(".hdt-view_all", this);
    this.href = this.btn_viewall?.getAttribute("href");
    this.isOpen = false;
    this.abortController2 = new AbortController();
    this.searchTerm = "";
    if (this.input) {
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this),
      );
    }

    const formData = new FormData(this.input.form);
    this.params = "";
    for (const [key, value] of formData) {
      if (key === "q") break;
      this.params += `${key}=${value}&`;
    }

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));

    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    //this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      // this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;
    this.btn_viewall?.setAttribute(
      "href",
      this.href.replace(/\/search\?q=.*/g, "/search?q=" + this.searchTerm),
    );

    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }

  onFormSubmit(event) {
    if (
      !this.getQuery().length ||
      this.querySelector('[aria-selected="true"] a')
    )
      event.preventDefault();
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();
    if (!currentSearchTerm.length) return;
    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.openSearch();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    // switch (event.code) {
    //   case 'ArrowUp':
    //     this.switchOption('up');
    //     break;
    //   case 'ArrowDown':
    //     this.switchOption('down');
    //     break;
    //   case 'Enter':
    //     this.selectOption();
    //     break;
    // }
  }

  // onKeydown(event) {
  //   // Prevent the cursor from moving in the input when using the up and down arrow keys
  //   if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
  //     event.preventDefault();
  //   }
  // }
  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector(
      "[data-predictive-search-search-for-text]",
    );
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, "g")).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(
      `${themeHDN.routes.predictive_search_url}?q=${encodeURIComponent(
        searchTerm,
      )}&${this.params}section_id=${this.sectionIdResults}`,
      {
        signal: this.abortController2.signal,
      },
    )
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-" + this.sectionIdResults).innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach(
          (predictiveSearchInstance) => {
            this.cachedResults[queryKey] = resultsMarkup;
          },
        );
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }

  setLiveRegionLoadingState() {
    this.hideWrapper.style.cssText = "display: none;";
    this.showWrapper.style.cssText = "display: block;";
    this.skeleton.classList.remove("hdt-hidden");

    this.setAttribute("loading", true);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute("results", true);

    this.setLiveRegionResults();
    this.openSearch();
    document.dispatchEvent(new CustomEvent("currency:update"));
  }

  setLiveRegionResults() {
    this.removeAttribute("loading");
  }

  openSearch() {
    //this.setAttribute('open', true);
    this.input.setAttribute("aria-expanded", true);
    this.skeleton.classList.add("hdt-hidden");
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = "";
      this.removeAttribute("results");
      this.hideWrapper.style.cssText = "display: block;";
      this.showWrapper.style.cssText = "display: none;";
      this.predictiveSearchResults.innerHTML = "";
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute("aria-selected", false);

    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    //this.removeAttribute('open');
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}

customElements.define("hdt-predictive-search", PredictiveSearch);
// bundle product

const bundleProduct = () => {
  if (window.innerWidth < 768) {
    return;
  }
  let arrBundle = $$4("[data-bundle-pin]");
  if (!arrBundle) {
    return;
  }
  arrBundle.forEach((el) => {
    if (!el.dataset.trigger) {
      return;
    } else {
      el.onmouseover = () => {
        $4(el.dataset.trigger).classList.add("is--hover");
        $4(el.dataset.trigger)
          .closest("[data-bundle-parent]")
          .classList.add("has--hover");
      };
      el.onmouseleave = () => {
        $4(el.dataset.trigger).classList.remove("is--hover");
        $4(el.dataset.trigger)
          .closest("[data-bundle-parent]")
          .classList.remove("has--hover");
      };
    }
  });
};
bundleProduct();

// --------------------------
// Back to top
// --------------------------
class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute("config"));
    if (window.innerWidth < 768 && this.config.hiddenMobile) return;
    this.debounce_timer = 0;
    this.debounce_timer2 = 0;
    this.circlechart = this.querySelector(".hdt-circle-css");
    this.addEventListener("click", this.goTop.bind(this));
    window.addEventListener("scroll", this.backToTop.bind(this));
  }
  goTop() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  backToTop() {
    let self = this;
    if (this.debounce_timer) {
      clearTimeout(this.debounce_timer);
    }
    this.debounce_timer = setTimeout(function () {
      if (window.scrollY > self.config.scrollTop) {
        self.classList.add("is--show");
      } else {
        self.classList.remove("is--show");
      }
    }, 40);

    if (!this.circlechart) return;

    if (this.debounce_timer2) {
      clearTimeout(this.debounce_timer2);
    }

    this.debounce_timer2 = setTimeout(function () {
      let scrollTop2 = window.scrollY,
        docHeight = document.body.offsetHeight,
        winHeight = window.innerHeight,
        scrollPercent = scrollTop2 / (docHeight - winHeight),
        degrees = scrollPercent * 360;
      self.circlechart.style.setProperty("--cricle-degrees", degrees + "deg");
    }, 6);
  }
}

customElements.define("back-to-top", BackToTop);

// --------------------------
// numberRandom
// --------------------------
class numberRandom extends HTMLElement {
  constructor() {
    super();
    let config = JSON.parse(this.getAttribute("config"));
    this.min = config.min;
    this.max = config.max;
    this.interval = config.interval;
    this.number =
      Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    this.ofset = ["1", "2", "4", "3", "6", "10", "-1", "-3", "-2", "-4", "-6"];
    this.prioritize = ["10", "20", "15"];
    this.h = "";
    this.e = "";
    this.M = "";
    this.liveViewInt();
    setInterval(this.liveViewInt.bind(this), this.interval);
  }

  liveViewInt() {
    if (
      ((this.h = Math.floor(Math.random() * this.ofset.length)),
      (this.e = this.ofset[this.h]),
      (this.number = parseInt(this.number) + parseInt(this.e)),
      this.min >= this.number)
    ) {
      this.M = Math.floor(Math.random() * this.prioritize.length);
      var a = this.prioritize[this.M];
      this.number += a;
    }
    if (this.number < this.min || this.number > this.max) {
      this.number =
        Math.floor(Math.random() * (this.max - this.min + 1)) + this.min;
    }
    this.innerHTML = parseInt(this.number);
  }
}

customElements.define("number-random", numberRandom);

// --------------------------
// Lookbook product carousel
// --------------------------

class LookbookProductCarousel extends HTMLElement {
  constructor() {
    super();
    if (window.innerWidth > 767) {
      return;
    }
    this.lookbookMobile();
  }
  lookbookMobile() {
    let self = this;
    const el = self.querySelector("[lookbook-product-wrap]");
    const controls = self.querySelector("[hdt-slider-controls]");
    const btn_close = self.querySelector("button.hdt-close");
    const isToolBar = document.querySelector(".hdt-toolbar-mobile");
    let toolBarH = 0;
    if (!el | !controls | !btn_close) return;
    if (isToolBar) {
      toolBarH += isToolBar.offsetHeight;
    }

    self.querySelector("[lookbook-product-wrap]").style.bottom = `${
      toolBarH / 10
    }rem`;
    controls.addEventListener("click", () => {
      el.classList.add("hdt-open");
    });
    btn_close.addEventListener("click", () => {
      el.classList.remove("hdt-open");
    });
  }
}
customElements.define("lookbook-product-carousel", LookbookProductCarousel);

/**
 * Cookies
 * https://help.shopify.com/en/manual/your-account/privacy/cookies
 * https://shopify.dev/themes/trust-security/cookie-banner#create-a-snippet-to-host-the-banner
 * https://help.shopify.com/en/manual/your-account/privacy/privacy-preferences-manager?shpxid=965d0d2a-08E2-4654-4A13-D3F38646AC5D
 * https://shopify.dev/api/consent-tracking
 */

function convertNameCookies(name) {
  return name.replace(/=/g, "_");
}
function setCookie(name, value, days, hours) {
  var expires = "";
  if (days || hours) {
    var date = new Date();
    date.setTime(
      date.getTime() +
        (days ? days * 24 * 60 * 60 * 1000 : hours * 60 * 60 * 1000),
    );
    expires = "; expires=" + date.toString();
  }
  document.cookie =
    convertNameCookies(name) + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = convertNameCookies(name) + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = convertNameCookies(name) + "=; Max-Age=-99999999;";
}

class cookiesBar extends HTMLElement {
  constructor() {
    super();
    this.cookies = JSON.parse(this.getAttribute("configs"));
    this.cookies.cookiesName = "theme4:cookies";
    this.cookies.drawer = this.querySelector("#drawerCookies");
    this.isShowCookiesAll = this.cookies.show == "1";
    this.acceptBtn = this.cookies.drawer.querySelector(
      ".hdt-pp_cookies__accept-btn",
    );
    this.declineBtn = this.cookies.drawer.querySelector(
      ".hdt-pp_cookies__decline-btn",
    );
    this.loadCookieBanner(this);
    let self = this;
    this.acceptBtn?.addEventListener("click", this.handleAccept.bind(this));
    this.declineBtn?.addEventListener("click", this.handleDecline.bind(this));
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", (event) => {
        const cookiesSelect = event.target.classList.contains("sys-cookies");
        if (!cookiesSelect) return;
        self.showCookiesBanner();
      });
      document.addEventListener("shopify:section:deselect", (event) => {
        const cookiesSelect = event.target.classList.contains("sys-cookies");
        if (!cookiesSelect) return;
        self.hideCookiesBanner();
      });
    }
  }
  handleAccept() {
    if (this.isShowCookiesAll) {
      setCookie(
        this.cookies.cookiesName,
        "accepted",
        parseInt(this.cookies.day_next),
      );
    }
    window.Shopify.customerPrivacy.setTrackingConsent(
      true,
      this.hideCookiesBanner.bind(this),
    );
  }

  handleDecline() {
    if (this.isShowCookiesAll) {
      setCookie(
        this.cookies.cookiesName,
        "accepted",
        parseInt(this.cookies.day_next),
      );
    }
    window.Shopify.customerPrivacy.setTrackingConsent(
      false,
      this.hideCookiesBanner.bind(this),
    );
  }

  showCookiesBanner() {
    this.cookies.drawer.setAttribute("open", "");
    $4("html").classList.remove("no-scroll");
  }

  hideCookiesBanner() {
    this.cookies.drawer.removeAttribute("open");
  }

  initCookieBanner() {
    const userCanBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
    const userTrackingConsent =
      window.Shopify.customerPrivacy.getTrackingConsent();

    if (
      (!userCanBeTracked && userTrackingConsent === "no_interaction") ||
      this.isShowCookiesAll
    ) {
      if (!Shopify.designMode) {
        this.showCookiesBanner();
      }
    }
  }

  loadCookieBanner() {
    let self = this;
    if (this.cookies.drawer.length == 0) return;
    this.cookies.day_next = this.cookies.day_next || 60;
    this.isShowCookiesAll = this.cookies.show == "1";
    if (
      getCookie(this.cookies.cookiesName) == "accepted" ||
      this.cookies.drawer.getAttribute("open") !== null
    )
      return;

    window.Shopify.loadFeatures(
      [
        {
          name: "consent-tracking-api",
          version: "0.1",
        },
      ],
      function (error) {
        if (error) {
          throw error;
        }
        self.initCookieBanner();
      },
    );
  }
}

customElements.define("sys-cookies", cookiesBar);

// --------------------------
// Newsletter
// --------------------------

class newsletterModal extends HTMLElement {
  constructor() {
    super();
    this.configs = JSON.parse(this.getAttribute("configs"));
    if (
      !Shopify.designMode &&
      getCookie("theme4:newsletter:" + this.configs.id) == "shown"
    )
      return;
    this.modal = this.querySelector("#modalNewsletter-" + this.configs.id);
    this.action_close = this.querySelector("[action-close]");
    this.time_delay = this.configs.time_delay;
    this.day_next = this.configs.day_next;
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", (event) => {
        const newsletterSelect =
          event.target.classList.contains("sys-newsletter");
        if (!newsletterSelect) return;
        this.modal.setAttribute("open", "");
      });
      document.addEventListener("shopify:section:deselect", (event) => {
        const newsletterSelect =
          event.target.classList.contains("sys-newsletter");
        if (!newsletterSelect) return;
        this.modal.removeAttribute("open");
      });
    } else {
      const fnShow = this.showModal.bind(this);
      const fnShowScroll = this.showModalScroll.bind(this);
      if (this.configs.after === "time") {
        let tm = setTimeout(fnShow, this.configs.time_delay * 1000);
        this.modal.addEventListener("dialog:afterClose", () => {
          clearTimeout(tm);
          this.hideModal(false, true);
        });
      } else {
        window.addEventListener("scroll", fnShowScroll);
        this.modal.addEventListener("dialog:afterClose", () => {
          window.removeEventListener("scroll", fnShowScroll);
          this.hideModal(false, true);
        });
      }
      this.actionClose();
    }
  }

  showModal() {
    this.modal.setAttribute("open", "");
  }
  showModalScroll() {
    if (window.scrollY > this.configs.scroll_delay) {
      this.modal.setAttribute("open", "");
    }
  }
  hideModal(pause, off) {
    if (pause) {
    }
    if (off) {
      setCookie("theme4:newsletter:" + this.configs.id, "shown", this.day_next);
    }
  }
  actionClose() {
    let self = this;
    if (self.action_close) {
      self.action_close.addEventListener("click", function () {
        self.modal.removeAttribute("open", "");
        self.hideModal(false, true);
      });
    }
  }
}
customElements.define("sys-newsletter", newsletterModal);

// --------------------------
// Exit
// --------------------------

class exitModal extends HTMLElement {
  constructor() {
    super();
    this.configs = JSON.parse(this.getAttribute("configs"));
    if (
      !Shopify.designMode &&
      getCookie("theme4:exit:" + this.configs.id) == "shown"
    )
      return;
    this.modal = this.querySelector("#modalExit-" + this.configs.id);
    this.day_next = this.configs.day_next;
    this.btn_copy = this.querySelector('button[is="discount_copy"]');
    this.discount = this.querySelector('[is="discount"]');
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", (event) => {
        const exitSelect = event.target.classList.contains("sys-exit");
        if (!exitSelect) return;
        this.showModal();
      });
      document.addEventListener("shopify:section:deselect", (event) => {
        const exitSelect = event.target.classList.contains("sys-exit");
        if (!exitSelect) return;
        this.modal.removeAttribute("open");
      });
    } else {
      if (this.configs.after === "move_cursor") {
        if (window.innerWidth > 1150) {
          this.moveCursor();
        } else {
          this.scrollPage();
        }
      } else if (this.configs.after === "scroll") {
        this.scrollPage();
        console.log();
      } else {
        this.amountTime();
      }
    }
  }
  // Move cursor out screen
  moveCursor() {
    const fnShow = this.showModal.bind(this);
    document.querySelector("body").addEventListener("mouseleave", fnShow);
    this.modal.addEventListener("dialog:afterClose", () => {
      document.querySelector("body").removeEventListener("mouseleave", fnShow);
      this.hideModal(false, true);
    });
  }
  //  scroll page
  scrollPage() {
    const fnShow = this.showModal.bind(this);
    let docHeight =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight -
      500;
    let scroll = () => {
      if (window.scrollY >= docHeight) {
        fnShow();
      }
    };
    window.addEventListener("scroll", scroll);
    this.modal.addEventListener("dialog:afterClose", () => {
      window.removeEventListener("scroll", scroll);
      this.hideModal(false, true);
    });
  }
  // countdown time to show exit popup
  amountTime() {
    const fnShow = this.showModal.bind(this);
    let tm = setTimeout(fnShow, this.configs.time_delay * 1000);
    this.modal.addEventListener("dialog:afterClose", () => {
      clearTimeout(tm);
      this.hideModal(false, true);
    });
  }
  showModal() {
    let self = this;
    this.modal.setAttribute("open", "");
    if (self.btn_copy && self.discount) {
      self.btn_copy.addEventListener("click", function () {
        self.discount.select();
        self.discount.setSelectionRange(0, 99999);
        document.execCommand("copy");
        self.btn_copy.querySelector(".hdt-tooltip-text").innerText =
          `${themeHDN.extras.exit_popup.copied}: ${self.discount.value}`;
      });
      self.btn_copy.addEventListener("mouseleave", function () {
        self.btn_copy.querySelector(".hdt-tooltip-text").innerText =
          themeHDN.extras.exit_popup.copy;
      });
    }
  }
  hideModal(pause, off) {
    if (pause) {
    }
    if (off) {
      setCookie("theme4:exit:" + this.configs.id, "shown", this.day_next);
    }
  }
}
customElements.define("sys-exit", exitModal);

// --------------------------
// Countdown Cart
// --------------------------

class cartCountdown extends HTMLElement {
  constructor() {
    super();
    let settMinutes = 60 * this.getAttribute("time"),
      time = parseInt(sessionStorage.getItem("cartTime")),
      display = this.querySelector("#timer_count");
    this.config = JSON.parse(this.getAttribute("config"));
    var self = this;
    function startTimer(duration, display) {
      let timer = duration,
        minutes,
        seconds;
      let countdown = setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);
        minutes = minutes < 10 ? minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        display.textContent =
          minutes + self.config.labelm + " : " + seconds + self.config.labels;
        let calc = 60 * parseInt(timer / 60, 10) + parseInt(timer % 60, 10);
        if (!Shopify.designMode) {
          sessionStorage.setItem("cartTime", calc);
        }
        if (--timer < 0) {
          window.clearInterval(countdown);
          display.textContent =
            0 + self.config.labelm + " : " + 0 + self.config.labels;
          fetch(Shopify.routes.root + "cart/clear.js")
            .then((response) => response.text())
            .then((text) => {
              console.log("Clear cart");
              window.location.href = `${Shopify.routes.root}cart`;
            })
            .catch((e) => {
              console.error(e);
            });
        }
      }, 1000);
    }
    if (time > 0) {
      startTimer(time, display);
    } else {
      startTimer(settMinutes, display);
    }
  }
}
customElements.define("cart-countdown", cartCountdown);

// --------------------------
// Form status
// --------------------------

const contactForm = $$4('form[action^="/contact"]');
contactForm.forEach(function (form) {
  form.addEventListener("submit", function (event) {
    sessionStorage.setItem("the4:recentform", this.getAttribute("id"));
  });
});
var recentform = sessionStorage.getItem("the4:recentform") || "";

if (location.href.indexOf("contact_posted=true") > 0 && recentform !== "") {
  document.dispatchEvent(
    new CustomEvent("the4:recentform", {
      detail: { recentform: recentform },
      bubbles: true,
      cancelable: true,
    }),
  );
  $id4(recentform)?.classList.add("on-live");
  if ($4(".form-status-mirror-" + recentform)) {
    $4(".form-status-mirror-" + recentform).style.cssText = "display: block;";
  }
} else if (
  location.href.indexOf("customer_posted=true") > 0 &&
  recentform !== ""
) {
  document.addEventListener("the4:recentform", (event) => {
    let modal_id = document
      .getElementById(event.detail.recentform)
      .getAttribute("data-id");
    document.getElementById(modal_id).setAttribute("open", "");
  });
  document.dispatchEvent(
    new CustomEvent("the4:recentform", {
      detail: { recentform: recentform },
      bubbles: true,
      cancelable: true,
    }),
  );
  $id4(recentform)?.classList.add("on-live");
} else if (
  location.href.indexOf("contact_posted=true") > 0 &&
  location.href.indexOf("#") > 0
) {
  var recentform = location.href.split("#")[1];
  if ($id4(recentform).length > 0) {
    sessionStorage.setItem("the4:recentform", recentform);
    $id4(recentform).classList.add("on-live");
    if ($4(".form-status-mirror-" + recentform)) {
      $4(".form-status-mirror-" + recentform).style.cssText = "display: block;";
    }
  }
}

// --------------------------
// Total sold flash
// --------------------------
class flashSold extends VariantChangeBase {
  constructor() {
    super();
    var self = this;
    this.time = this.getAttribute("time");
    this.config = JSON.parse(this.getAttribute("flash-sold"));
    this.mins = this.config.mins;
    this.maxs = this.config.maxs;
    this.mint = this.config.mint;
    this.maxt = this.config.maxt;
    this.dataID = this.config.id;
    this.getS =
      sessionStorage.getItem("soldS" + this.dataID) ||
      this.getRandomInt(this.mins, this.maxs);
    this.getT =
      sessionStorage.getItem("soldT" + this.dataID) ||
      this.getRandomInt(this.mint, this.maxt);
    this.numS = parseInt(this.getS);
    this.numT = parseInt(this.getT);
    this.intervalTime = parseInt(this.config.time);
    this.$sold = this.querySelector("[data-sold]");
    this.$hour = this.querySelector("[data-hour]");
    this.limitMinMax();
    this.updateSold(this.numS, this.numT);
    setInterval(function () {
      this.numS = this.numS + self.getRandomInt(1, 4);
      this.numT =
        this.numT + (Math.random() * (0.8 - 0.1) + 0.1).toFixed(1) * 1;
      self.limitMinMax();
      self.updateSold(self.numS, self.numT);
    }, this.intervalTime);
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  updateSold(num1, num2) {
    this.$sold.innerHTML = num1;
    this.$hour.innerHTML = Math.floor(this.numT);
    sessionStorage.setItem("soldS" + this.dataID, num1);
    sessionStorage.setItem("soldT" + this.dataID, num2);
  }
  limitMinMax() {
    if (this.numS > this.maxs)
      this.numS = self.getRandomInt(this.mins, this.maxs);
    if (this.numT > this.maxt)
      this.numT = self.getRandomInt(this.mins, this.maxt);
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if (variant.available) {
        this.closest(".hdt-product-info__item").style.display = "";
      } else {
        this.closest(".hdt-product-info__item").style.display = "none";
      }
    }
  }
}
customElements.define("flash-sold", flashSold);

// --------------------------
// Multi brands
// --------------------------
var hdtNavLoading = true;
class multiBrands extends HTMLElement {
  constructor() {
    super();
    if ($id4("hdt-nav-ul").classList.value.includes("hdt-nav-loading") < 0) {
      return false;
    }
    this.item = $$4("[item-brand]", this);
    // this.section_id = this.getAttribute("s_id");
    // this.url = "";
    if (this.item.length) {
      // for(var i=0; i < this.item.length; i++) {
      //   if (this.item[i].parentElement.classList.value.includes("is--active")) {
      //     this.url = this.item[i].getAttribute("href");
      //     const lazyMb = $4('hdt-lazy-submenu#sub-hdt-nav-mb');
      //     if (lazyMb) {
      //       lazyMb.addEventListener('lazyhtml:added', () => $4(`#hdt-nav-ul-mb summary[data-url="${this.url}"]`)?.parentElement.setAttribute("open",""));
      //     } else {
      //       $4(`#hdt-nav-ul-mb summary[data-url="${this.url}"]`)?.parentElement.setAttribute("open","");
      //     }
      //     // localStorage.setItem("the4:brand:url", this.url);
      //     break;
      //   }
      // }
      // if(this.url === "") {
      //   this.url = localStorage.getItem("the4:brand:url") || Shopify.routes.root;
      //   for(var i=0; i < this.item.length; i++) {
      //     if (this.item[i].getAttribute("href") === this.url) {
      //       this.item[i].parentElement.classList.add("is--active");
      //       $4("#hdt-nav-ul-mb summary[data-url=\""+ this.url +"\"]").parentElement.setAttribute("open","");
      //       if (i > 0) {
      //         this._init();
      //       }
      //       break;
      //     }
      //   }
      // }
    }
  }
  // _init(){
  //   var nameStorage = "the4:brand:nav" + this.url.replace(/\//g,'-');
  //   if(!Shopify.designMode && sessionStorage.getItem(nameStorage) !== null){
  //     $id4("hdt-nav-ul").innerHTML = sessionStorage.getItem(nameStorage);
  //     $id4("hdt-nav-ul").classList.remove("hdt-nav-loading");
  //     return;
  //   }
  //   if (!hdtNavLoading) {
  //     return;
  //   }
  //   fetch(this.url + "?section_id=" + this.section_id)
  //     .then((response) => response.text())
  //     .then((text) => {
  //       const html = document.createElement('div');
  //       html.innerHTML = text;
  //       const nav = html.querySelector('#hdt-nav-ul');
  //       if (nav && nav.innerHTML.trim().length) {
  //         $id4("hdt-nav-ul").innerHTML = nav.innerHTML;
  //         $id4("hdt-nav-ul").classList.remove("hdt-nav-loading");
  //         sessionStorage.setItem(nameStorage, nav.innerHTML.trim().replace(/^\s+|\s+$|\n/gm,''));
  //       }
  //     })
  //     .catch((e) => {
  //       console.error(e);
  //     });
  //   hdtNavLoading = false;
  // }
}

customElements.define("multi-brands", multiBrands);

// footer accodion
function handleAccordionClick() {
  let accordion = this.parentElement;
  accordion.classList.toggle("open");
  if (window.innerWidth < 768) {
    let content = accordion.querySelector(".hdt-collapse-content");
    if (accordion.classList.contains("open")) {
      content.style.height = "auto";
    } else {
      content.style.height = "0";
    }
  }
}
function updateMaxHeight() {
  if (window.innerWidth >= 768) {
    document
      .querySelectorAll(".hdt-footer-section .hdt-collapse-content")
      .forEach(function (content) {
        content.style.height = "";
      });
  }
}
document
  .querySelectorAll(".hdt-footer-section .hdt-heading-f")
  .forEach(function (element) {
    element.addEventListener("click", handleAccordionClick);
  });
window.addEventListener("resize", function () {
  if (window.innerWidth < 768) {
    document
      .querySelectorAll(".hdt-footer-section .hdt-heading-f")
      .forEach(function (element) {
        element.removeEventListener("click", handleAccordionClick);
        element.addEventListener("click", handleAccordionClick);
      });
  } else {
    document
      .querySelectorAll(".hdt-footer-section .hdt-heading-f")
      .forEach(function (element) {
        element.removeEventListener("click", handleAccordionClick);
      });
    updateMaxHeight();
  }
});

// --------------------------
// Delivery Time
// --------------------------
// https://unpkg.com/dayjs@1.11.10/dayjs.min.js
import dayjs from "dayjs";
dayjs.locale("en"); // use locale globally
class orderDelivery extends VariantChangeBase {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute("config"));
    this.offDays = this.config.off_day.replace(/ /g, "").split(",");
    this.nowDay = dayjs();
    var format_day = this.config.format_day,
      time = this.config.time.replace("24:00:00", "23:59:59"),
      arrDayWeek = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      dateStart = this.config.estimateStartDate || 0,
      dateEnd = this.config.estimateEndDate || 0,
      excludeDays = this.config.cut_day.replace(/ /g, "").split(","),
      startDay = dayjs(),
      i = 0,
      endDay = dayjs(),
      j = 0,
      nowTime = this.nowDay.format("HHmmss"),
      timeint = time.replace(/ /g, "").replace(/:/g, ""),
      arrDay = themeHDN.extras.order.dayNames.replace(/ /g, "").split(","),
      arrMth = themeHDN.extras.order.monthNames.replace(/ /g, "").split(",");

    /**
     * Check Time, if nowTime >=  timeint +1 day
     */
    if (parseInt(nowTime) >= parseInt(timeint)) {
      this.nowDay = this.nowDay.add(1, "day");
      startDay = startDay.add(1, "day");
      endDay = endDay.add(1, "day");
    }

    /**
     * Mode: 2 - Shipping + delivery
     * Mode: 1 - Only delivery
     */

    if (this.config.mode == "2") {
      // START DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (
        excludeDays.indexOf(arrDayWeek[startDay.format("d")]) > -1 ||
        this.offDays.indexOf(startDay.format("DD/MM/****")) > -1 ||
        this.offDays.indexOf(startDay.format("DD/MM/YYYY")) > -1
      ) {
        startDay = startDay.add(1, "day");
      }
      while (i < dateStart) {
        i++;
        startDay = startDay.add(1, "day");
        if (
          excludeDays.indexOf(arrDayWeek[startDay.format("d")]) > -1 ||
          this.offDays.indexOf(startDay.format("DD/MM/****")) > -1 ||
          this.offDays.indexOf(startDay.format("DD/MM/YYYY")) > -1
        ) {
          i--;
        }
      }

      // END DATE
      // if ngay khach mua trung voi ngay loai tru tang 1 ngay
      while (
        excludeDays.indexOf(arrDayWeek[endDay.format("d")]) > -1 ||
        this.offDays.indexOf(endDay.format("DD/MM/****")) > -1 ||
        this.offDays.indexOf(endDay.format("DD/MM/YYYY")) > -1
      ) {
        endDay = endDay.add(1, "day");
      }

      while (j < dateEnd) {
        j++;
        endDay = endDay.add(1, "day");
        if (
          excludeDays.indexOf(arrDayWeek[endDay.format("d")]) > -1 ||
          this.offDays.indexOf(endDay.format("DD/MM/****")) > -1 ||
          this.offDays.indexOf(endDay.format("DD/MM/YYYY")) > -1
        ) {
          j--;
        }
      }
    } else {
      // START DATE
      startDay = startDay.add(dateStart, "day");
      while (
        excludeDays.indexOf(arrDayWeek[startDay.format("d")]) > -1 ||
        this.offDays.indexOf(startDay.format("DD/MM/****")) > -1 ||
        this.offDays.indexOf(startDay.format("DD/MM/YYYY")) > -1
      ) {
        startDay = startDay.add(1, "day");
      }

      // END DATE
      endDay = endDay.add(dateEnd, "day");
      while (
        excludeDays.indexOf(arrDayWeek[endDay.format("d")]) > -1 ||
        this.offDays.indexOf(endDay.format("DD/MM/****")) > -1 ||
        this.offDays.indexOf(endDay.format("DD/MM/YYYY")) > -1
      ) {
        endDay = endDay.add(1, "day");
      }
      // endDay = endDay.add(this.offDaysf(endDay), 'day');
    }

    /**
     * Translate day, month
     * https://day.js.org/docs/en/display/format
     */
    arrDay = this.ArrUnique(arrDay);
    arrMth = this.ArrUnique(arrMth);

    var startDayDInt = parseInt(startDay.format("D")),
      daystStart = startDayDInt + this.nth(startDayDInt),
      MntStart = arrMth[parseInt(startDay.format("M")) - 1],
      dayStart = arrDay[parseInt(startDay.format("d"))],
      EndDayDInt = parseInt(endDay.format("D")),
      daystEnd = EndDayDInt + this.nth(EndDayDInt),
      MntEnd = arrMth[parseInt(endDay.format("M")) - 1],
      dayEnd = arrDay[parseInt(endDay.format("d"))];

    //console.log( startDayDInt, EndDayDInt )
    if ($4("[data-start-delivery]", this))
      $4("[data-start-delivery]", this).innerHTML = startDay
        .format(format_day)
        .replace("t44", dayStart)
        .replace("t45", daystStart)
        .replace("t46", MntStart);
    if ($4("[data-end-delivery]", this))
      $4("[data-end-delivery]", this).innerHTML = endDay
        .format(format_day)
        .replace("t44", dayEnd)
        .replace("t45", daystEnd)
        .replace("t46", MntEnd);
  }

  ArrUnique(arr) {
    var onlyUnique = function (value, index, self) {
      return self.indexOf(value) === index;
    };
    return arr.filter(onlyUnique);
  }

  nth(d) {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if (variant.available) {
        this.closest(".hdt-product-info__item").style.display = "";
        if (variant.variant_state.pre_order) {
          this.closest(".hdt-product-info__item").style.display = "none";
        }
      } else {
        this.closest(".hdt-product-info__item").style.display = "none";
      }
    }
  }
}
customElements.define("order-delivery", orderDelivery);
class countdownSimple extends HTMLElement {
  x = 0;
  constructor() {
    super();

    /** Countdown
     * [days] [hours] [mins] [secs]
     */

    this.config = JSON.parse(this.getAttribute("config"));
    const time = this.config.time.replace("24:00:00", "23:59:59");

    if (time == "19041994") return;
    this.textTemp = $4("template", this).innerHTML;
    this.notHasDay = !this.textTemp.includes("[days]");
    let today = dayjs();

    const nowTime = today.format("HHmmss"),
      configTime = time.replace(/ /g, "").replace(/:/g, "");

    if (parseInt(nowTime) >= parseInt(configTime)) {
      today = today.add(1, "day");
    }
    // Set the date we're counting down to
    // "2030-01-05 15:37:25"
    this.countDownDate = new Date(
      `${today.format("YYYY-MM-DD")} ${time}`,
    ).getTime();

    // Update the count down every 1 second
    this.#update();
    this.x = setInterval(
      this.#update.bind(this),
      this.textTemp.includes("[secs]") ? 1000 : 60000,
    );
  }
  #update() {
    // Get today's date and time
    const now = new Date().getTime();

    // Find the distance between now and the count down date
    const distance = this.countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    if (this.notHasDay) hours = days * 24 + hours;

    // Display the result in the element
    this.innerHTML = this.textTemp
      .replace("[days]", String(days).padStart(2, "0"))
      .replace("[hours]", String(hours).padStart(2, "0"))
      .replace("[mins]", String(minutes).padStart(2, "0"))
      .replace("[secs]", String(seconds).padStart(2, "0"));

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(this.x);
      // EXPIRED
      this.hidden = true;
    }
  }
  disconnectedCallback() {
    clearInterval(this.x);
  }
}
customElements.define("hdt-countdown-simple", countdownSimple);

class countdownTimer extends VariantChangeBase {
  constructor() {
    super();
  }
  #preVariantId;
  onVariantChanged(event) {
    const variant = event.detail.variant;
    if (variant && this.#preVariantId != variant.id) {
      if (variant.available) {
        this.style.display = "";
      } else {
        this.style.display = "none";
      }
    }
  }
}
customElements.define("countdown-timer", countdownTimer);

// quick order list

var createCartPromise = (force = false) => {
  if (typeof window.createCartPromise === "function") {
    return window.createCartPromise(force);
  }
  return fetch(`${Shopify.routes.root}cart.js`, {
    headers: { "X-Requested-With": "XMLHttpRequest" },
  }).then((response) => response.json());
};
var _upate_qty, upate_qty_fn;
class QuickOrderList extends HTMLElement {
  constructor() {
    super();
    const ON_CHANGE_DEBOUNCE_TIMER = 300;
    this.actions = {
      add: "ADD",
      update: "UPDATE",
    };
    this.quickOrderListId = "#" + this.id;
    this.sectionId = this.dataset.sectionId;
    this.updateThink();

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
    getterAdd(_upate_qty, this);
    document.addEventListener("cart:push:section.id", (event) =>
      event.detail.sections.push(this.sectionId),
    );
  }
  onSubmit(event) {
    event.preventDefault();
  }

  connectedCallback() {
    document.addEventListener(
      $4("hdt-cart-drawer") ? "cart:drawer:change" : "variant:add",
      this.fetchQuickOrder.bind(this),
    );
  }
  //disconnectedCallback() {}

  updateThink() {
    this.items_in_cart = $4("[update_items_in_cart]", this);
    this.items_price_in_cart = $4("[update_items_price_in_cart]", this);
    $4("form#QuickOrderList", this).addEventListener(
      "submit",
      this.onSubmit.bind(this),
    );
  }
  fetchQuickOrder(event) {
    const html = new DOMParser().parseFromString(
      event.detail.sections[this.sectionId],
      "text/html",
    );
    const sourceQty = html.querySelector(this.quickOrderListId);
    $4("form#QuickOrderList", this).removeEventListener(
      "submit",
      this.onSubmit.bind(this),
    );
    this.innerHTML = sourceQty.innerHTML;
    document.dispatchEvent(new CustomEvent("currency:update"));
    this.updateThink();
    // fetch(`${window.location.pathname}?section_id=${this.sectionId}`)
    //   .then((response) => response.text())
    //   .then((responseText) => {
    //     const html = new DOMParser().parseFromString(responseText, 'text/html');
    //     const sourceQty = html.querySelector(this.quickOrderListId);
    //     this.innerHTML = sourceQty.innerHTML;
    //   })
    //   .catch((e) => { console.error(e); });
  }
  onChange(event) {
    const inputValue = parseInt(event.target.value);
    const cartQuantity = parseInt(event.target.dataset.cartQuantity);
    const index = event.target.dataset.index;
    const quantity = inputValue - cartQuantity;

    if (cartQuantity > 0) {
      this.updateQuantity(index, inputValue, this.actions.update);
    } else {
      this.updateQuantity(index, quantity, this.actions.add);
    }
  }
  onLoading(id) {
    $4(`#Variant-${id} [price_loading]`, this)?.setAttribute("aria-busy", true);
    $$4("#hdt-quick-order-list-total .hdt-btn-loading__svg", this).forEach(
      (el) => el.setAttribute("aria-busy", true),
    );
  }
  deLoading(id) {
    $4(`#Variant-${id} [price_loading]`, this)?.setAttribute(
      "aria-busy",
      false,
    );
    $$4("#hdt-quick-order-list-total .hdt-btn-loading__svg", this).forEach(
      (el) => el.setAttribute("aria-busy", false),
    );
  }
  removeButton(id, quantity) {
    quantity !== 0
      ? $4(
          `#Variant-${id} hdt-quick-order-list-remove-button`,
          this,
        ).removeAttribute("hidden")
      : $4(
          `#Variant-${id} hdt-quick-order-list-remove-button`,
          this,
        ).setAttribute("hidden", "");
  }
  updateInCart(id, variant_in_cart) {
    //  label
    $4(`#Variant-${id} .hdt-quantity__rules-cart`, this).removeAttribute(
      "hidden",
    );
    let variant_qty_cart = $4(`#Variant-${id} .hdt-quantity-cart`, this);

    //  totals
    let variant_total = $4(`#Variant-${id} [variant_update_price]`, this);

    // update
    if (variant_in_cart?.length !== 0 && variant_in_cart) {
      let variant_total_price = parseFloat(variant_in_cart.original_line_price);
      variant_qty_cart.innerText = variant_in_cart.quantity;
      variant_total.innerText = formatMoney(
        variant_total_price,
        themeHDN.settings.currencyFormat,
      );
      variant_total.setAttribute("data-variant-price", variant_total_price);
    } else {
      variant_qty_cart.innerText = 0;
      variant_total.innerText = formatMoney(
        0,
        themeHDN.settings.currencyFormat,
      );
      variant_total.setAttribute("data-variant-price", 0);
      $4(`#Variant-${id} .hdt-quantity__rules-cart`, this).setAttribute(
        "hidden",
        "",
      );
    }
    this.removeT4CrurrencyData(variant_total);
  }
  removeT4CrurrencyData(el, dataset = el.dataset) {
    for (const [key, value] of Object.entries(dataset)) {
      if (key.toLowerCase().indexOf("currency") >= 0) delete el.dataset[key];
    }
  }
  updateTotalInCart() {
    let items_total = 0;
    let items_price = 0;

    // update items_total
    let items = $$4("[data-cart-quantity]", this);
    items.forEach((item) => {
      return (items_total += parseInt(item.getAttribute("data-cart-quantity")));
    });
    this.items_in_cart.innerText = items_total;

    // update items_price
    let prices = $$4("[data-variant-price]", this);
    prices.forEach((price) => {
      return (items_price += parseFloat(
        price.getAttribute("data-variant-price"),
      ));
    });
    this.items_price_in_cart.innerText = formatMoney(
      items_price,
      themeHDN.settings.currencyFormat,
    );
    this.removeT4CrurrencyData(this.items_price_in_cart);
    document.dispatchEvent(new CustomEvent("currency:update"));
  }

  fetchConfig(type = "json") {
    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: `application/${type}`,
      },
    };
  }
  // update quantity product
  updateQuantity(id, quantity, action) {
    document.dispatchEvent(
      new CustomEvent("theme:loading:doing", { bubbles: !0 }),
    );
    this.removeButton(id, quantity);
    this.onLoading(id);
    let bundleSections = [];
    document.dispatchEvent(
      new CustomEvent("cart:push:section.id", {
        bubbles: true,
        detail: { sections: bundleSections },
      }),
    );
    let routeUrl = `${Shopify.routes.root}cart/change.js`;
    let body = JSON.stringify({
      quantity,
      id,
      sections_url: window.location.pathname,
      sections: bundleSections.join(","),
    });
    let fetchConfigType;

    if (action === this.actions.add) {
      fetchConfigType = "javascript";
      routeUrl = `${Shopify.routes.root}cart/add.js`;
      body = JSON.stringify({
        items: [
          {
            quantity: parseInt(quantity),
            id: parseInt(id),
          },
        ],
        sections_url: window.location.pathname,
        sections: bundleSections.join(","),
      });
    }

    fetch(`${routeUrl}`, { ...this.fetchConfig(fetchConfigType), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        let cartContent = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${id}`);

        if (quantity === 0) {
          this.resetQuantityInput(id, quantityElement, true);
        }
        quantityElement.setAttribute("data-cart-quantity", quantity);
        getterRunFn(_upate_qty, this, upate_qty_fn).call(
          this,
          cartContent,
          parseInt(id),
          action,
          bundleSections,
        );
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.updateTotalInCart();
        document.dispatchEvent(new CustomEvent("currency:update"));
        document.dispatchEvent(
          new CustomEvent("theme:loading:done", { bubbles: !0 }),
        );
        this.deLoading(id);
      });
  }
  resetQuantityInput(id, quantityElement, resetValue) {
    const input = quantityElement ?? document.getElementById(`Quantity-${id}`);
    input.value = input.getAttribute("value");
    resetValue
      ? (input.value = 0)
      : (input.value = input.getAttribute("value"));
  }
  updateError(updatedValue, id) {
    let message = "";
    if (typeof updatedValue === "undefined") {
      message = window.cartStrings.error;
    } else {
      message = window.cartStrings.quantityError.replace(
        "[quantity]",
        updatedValue,
      );
    }
    this.updateLiveRegions(id, message);
  }

  updateLiveRegions(id, message) {
    const variantItemError = this.getElementById("Quick-order-list-item-error");
    if (variantItemError) {
      $4(".hdt-variant-item__error-text", variantItemError).innerHTML = message;
      variantItemError.removeAttribute("hidden");
    }
  }
}
_upate_qty = new WeakSet();
upate_qty_fn = async function (cartContent, id, action) {
  const variant_in_cart = cartContent.items.find(
    (item) => item.variant_id === id,
  );
  this.updateInCart(id, variant_in_cart);
  this.dispatchEvent(new CustomEvent("quickOrder:change", { bubbles: false }));
  //document.dispatchEvent(new CustomEvent("cart:refresh"));
  let cart = cartContent;
  console.log("cart", cart);
  if (action === this.actions.add) {
    try {
      cart = await createCartPromise();
      if (cart && cartContent) {
        cart.sections = cartContent.sections;
      }
    } catch (error) {
      console.error("Error fetching cart after add:", error);
      // Fallback to cartContent if fetch fails
      cart = cartContent;
    }
  }
  // Only dispatch cart:change if cart is valid to prevent undefined issues
  if (cart && typeof cart === "object" && cart.item_count !== undefined) {
    document.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "line-item:change",
          cart,
          disabledDrawerChange: true,
        },
      }),
    );
  }
};

customElements.define("hdt-quick-order-list", QuickOrderList);

// remove variant in cart
class QuickOrderListRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const quickOrderList = this.closest("hdt-quick-order-list");
      quickOrderList.updateQuantity(this.dataset.index, 0);
      this.setAttribute("hidden", "");
    });
  }
}

customElements.define(
  "hdt-quick-order-list-remove-button",
  QuickOrderListRemoveButton,
);

// remove all variant in cart
class QuickOrderListRemoveAllButton extends HTMLElement {
  constructor() {
    super();
    this.quickOrderList = this.closest("hdt-quick-order-list");
    const allVariants = Array.from(
      this.quickOrderList.querySelectorAll("[data-variant-id]"),
    );
    const items = {};
    const list_variants = [];
    let hasVariantsInCart = false;

    allVariants.forEach((variant) => {
      const cartQty = parseInt(variant.dataset.cartQty);
      if (cartQty > 0) {
        hasVariantsInCart = true;
        items[parseInt(variant.dataset.variantId)] = 0;
        list_variants.push(variant.dataset.variantId);
      }
    });

    if (!hasVariantsInCart) {
      this.setAttribute("hidden", "");
    }

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.quickOrderList.updateMultipleQty(items, list_variants);
      this.setAttribute("hidden", "");
    });
  }
}

customElements.define(
  "hdt-quick-order-list-remove-all-button",
  QuickOrderListRemoveAllButton,
);

// Begin instagram feed api
const dataInstagramCache = {};
class instagramFeedAPI extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute("config"));
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", (event) => {
        this.refresh_ins();
      });
      document.addEventListener("shopify:section:deselect", (event) => {
        const { acc, id } = this.config;
        var data = sessionStorage.getItem("hdt_ins" + acc + id);
        if (data != null && data != "") {
          sessionStorage.removeItem("hdt_ins" + acc + id);
        }
      });
    }
  }
  connectedCallback() {
    this.refresh_ins();
  }
  refresh_ins() {
    const { acc, id } = this.config;

    if (acc == "") return;

    var data = sessionStorage.getItem("hdt_ins" + acc + id);

    if (data != null && data != "") {
      // calculate expiration time for content,
      // to force periodic refresh after 30 minutes
      var now = new Date(),
        expiration = new Date(JSON.parse(data).timestamp);

      expiration.setMinutes(expiration.getMinutes() + 30);

      // ditch the content if too old
      if (now.getTime() > expiration.getTime()) {
        data = null;
        sessionStorage.removeItem("hdt_ins" + acc + id);
      }
    }
    if (data != null && data != "") {
      this.instagramHTML(JSON.parse(data).content, false);
    } else {
      if (dataInstagramCache[acc]) {
        $4(".hdt-slider__container", this).innerHTML = dataInstagramCache[acc];
        $4(".hdt-ins-loading", this)?.remove();
        const lazySlider = $4("hdt-slider-lazy", this);
        if (lazySlider) {
          lazySlider.hidden = false;
          lazySlider.InitLazy();
        }
        return;
      }

      fetch(
        "https://graph.instagram.com/me/media?fields=id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token=" +
          atob(acc),
      )
        .then((response) => {
          if (!response.ok) {
            throw new Error("not ok");
          }
          return response.json();
        })
        //.then(function(res)
        .then((res) => {
          //console.log('Success:', res);
          this.instagramHTML(res.data, true);
        })
        .catch(() => {
          $4(".hdt-ins-loading", this)?.remove();
          console.error("Instagram Feed:error fetch");
        });
    }
  }
  instagramHTML(data, saveSessionStorageIns) {
    const arrIcons = ($4(".hdt-icons-ins-svg", this).innerHTML || "").split(
        "[hdtplit]",
      ),
      icons = {
        image: arrIcons[0],
        video: arrIcons[1],
        carousel_album: arrIcons[2],
      },
      { id, acc, target, limit } = this.config;
    let html = "";

    data.forEach((el, index) => {
      if (index >= limit) return 0;
      const media_type = el.media_type.toLowerCase();
      html += `<div class="hdt-slider__slide hdt-ins-type-${media_type}"><a calc-nav data-no-instant rel="nofollow" class="hdt-ins-inner hdt-block hdt-relative hdt-oh hdt-rounded" href="${
        el.permalink
      }" target="${target}"><div class="hdt-ratio"><img src="${
        el.thumbnail_url || el.media_url
      }" class="hdt-ins-img" loading="lazy"></div><div class="hdt-ins-icon">${
        icons[media_type]
      }</div></a></div>`;
    });
    dataInstagramCache[acc] = html;
    $4(".hdt-slider__container", this).innerHTML = html;
    $4(".hdt-ins-loading", this)?.remove();
    const lazySlider = $4("hdt-slider-lazy", this);
    if (lazySlider) {
      lazySlider.hidden = false;
      lazySlider.InitLazy();
    }

    if (saveSessionStorageIns) {
      sessionStorage.setItem(
        "hdt_ins" + acc + id,
        JSON.stringify({
          timestamp: new Date(),
          content: data,
        }),
      );
    }
  }
}
customElements.define("ins-feed-api", instagramFeedAPI);

// End instagram feed api

// Tab main-brands //
class TabsBrands extends HTMLElement {
  constructor() {
    super();
    this.links = this.querySelectorAll(".hdt-tab-link");
    this.tabs = this.querySelectorAll(".hdt-tab-content");
    this.addAllListeners();
  }

  addAllListeners() {
    this.links.forEach((link) => {
      link.addEventListener("click", () => {
        const tabName = link.getAttribute("data-filter");
        if (tabName === "all") {
          this.openAllTabs();
        } else {
          this.openTab(tabName);
        }
        this.links.forEach((item) => {
          item.classList.remove("is--active");
        });
        if (!link.classList.contains("is--active")) {
          link.classList.add("is--active");
        }
      });
    });
  }

  openAllTabs() {
    this.tabs.forEach((content) => {
      content.style.display = "block";
      content.style.height = "auto";
    });
    this.querySelector('[data-filter="all"]').classList.add("is--active");
  }

  openTab(tabName) {
    this.tabs.forEach((content) => {
      if (content.id === tabName) {
        content.style.display = "block";
        content.classList.add("slideInRight");
      } else {
        content.style.display = "none";
        content.classList.remove("slideInRight");
      }
    });
  }

  connectedCallback() {
    this.addAllListeners();
  }
  disconnectedCallback() {}
}

customElements.define("tabs-brands", TabsBrands);

//  //

class countryFilter extends HTMLElement {
  constructor() {
    super();
    this.search = $4("[name=country_filter]", this);
    this.reset = $4(".hdt-country_filter__reset", this);
    if (this.search) {
      this.search.addEventListener(
        "input",
        debounce((event) => {
          this.filterCountries();
        }, 200).bind(this),
      );
    }
    this.search.addEventListener("keydown", this.onSearchKeyDown.bind(this));
  }
  filterCountries() {
    const searchValue = this.search.value.toLowerCase();
    const allCountries = this.closest("hdt-popover").querySelectorAll(
      "hdt-richlist button",
    );
    let visibleCountries = allCountries.length;
    allCountries.forEach((item) => {
      const countryName = item.getAttribute("data-name").toLowerCase();
      if (countryName.indexOf(searchValue) > -1) {
        item.classList.remove("hdt-d-none");
        visibleCountries++;
      } else {
        item.classList.add("hdt-d-none");
        visibleCountries--;
      }
    });
    this.closest("hdt-popover").updatePos();
    this.closest("hdt-popover").shadowRoot.querySelector(
      ".hdt-current-scrollbar",
    ).scrollTop = 0;
  }

  onSearchKeyDown(event) {
    if (event.code.toUpperCase() === "ENTER") {
      event.preventDefault();
    }
  }
}

customElements.define("country-filter", countryFilter);

// check purchase code
if (Shopify.designMode) {
  /**
   * If it's a global variable then window[variableName] or in your case window["onlyVideo"] should do the trick.
   * https://stackoverflow.com/questions/5613834/convert-string-to-variable-name-in-javascript
   */

  var ThemeCode = atob(window[atob("Y0hWeVkyaGg=")]),
    ThemeName_base64 = window[atob("VkdobGJXVk9ZVzFsVkRR")],
    ThemeName = atob(ThemeName_base64),
    CookieName = "SXNBY3RpdmVUaGVtZQ==" + ThemeName_base64,
    ShopEmail = atob(window[atob("VTJodmNFMWxiMVEw")]),
    isTrueSet = sessionStorage.getItem(CookieName) === "true",
    str_temp_active = atob("I3Q0cy10ZW1wLWtleS1hY3RpdmU="), // #t4s-temp-key-active
    str_purchase = atob("cHVyY2hhc2VfY29kZXQ0"); // purchase_codet4;

  // console.log(ThemeCode,ThemeName,ShopEmail,CookieName,str_temp_active,str_purchase)
  function alert_active_html() {
    return `<section id="${str_purchase}" style="display: flex !important">${
      $4(str_temp_active).innerHTML
    }</section>`;
  }

  // console.log('ThemeCode', ThemeCode, isTrueSet)

  if (ThemeCode == "") {
    let dom1 = new DOMParser().parseFromString(
      alert_active_html(),
      "text/html",
    );
    document.body.append(dom1.body.firstElementChild);
    let dom2 = new DOMParser().parseFromString(
      '<div id="luffyabc194"><style>body>*:not(#purchase_codet4) {opacity: 0;pointer-events: none;</style></div>',
      "text/html",
    );
    document.body.prepend(dom2.body.firstElementChild);
    sessionStorage.removeItem(CookieName);
    localStorage.removeItem(CookieName);
  } else if (!isTrueSet) {
    //console.log(ShopEmail, ThemeName, ThemeCode);

    var domain = window.location.hostname,
      mix = [
        "4",
        "t",
        "h",
        "e",
        "p",
        "l",
        "i",
        "c",
        "o",
        "/",
        ".",
        ":",
        "n",
        "s",
      ],
      mix_domain =
        mix[2] +
        mix[1] +
        mix[1] +
        mix[4] +
        mix[13] +
        mix[11] +
        mix[9] +
        mix[9] +
        mix[5] +
        mix[6] +
        mix[7] +
        mix[10] +
        mix[1] +
        mix[2] +
        mix[3] +
        mix[0] +
        mix[10] +
        mix[7] +
        mix[8] +
        mix[9] +
        mix[5] +
        mix[6] +
        mix[7] +
        mix[3] +
        mix[12] +
        mix[13] +
        mix[3] +
        mix[9] +
        mix[7] +
        mix[2] +
        mix[3] +
        mix[7] +
        "k",
      data = {
        shopify_domain: domain,
        email: ShopEmail,
        theme: ThemeName,
        purchase_code: ThemeCode,
      };

    fetch(mix_domain, {
      headers: {
        accept: "*/*",
        "cache-control": "no-cache",
        "x-requested-with": "XMLHttpRequest",
      },
      body: btoa(encodeURIComponent(JSON.stringify(data))),
      method: "POST",
      mode: "cors",
    })
      .then(function (response) {
        if (response.ok) {
          return response.json();
        }
        throw "";
      })
      .then(function (response) {
        let dom = new DOMParser().parseFromString(
          alert_active_html(),
          "text/html",
        );

        if (response.status == 1) {
          dom.body.firstElementChild.innerHTML =
            "<p>ACTIVATED SUCCESSFULLY. Thanks for buying my theme!</p>";
          document.body.append(dom.body.firstElementChild);

          // Set a cookie to expire in 1 hour in Javascript
          var isActived = localStorage.getItem(CookieName);
          sessionStorage.setItem(CookieName, "true");

          if (isActived === "true") {
            $4(atob("I3B1cmNoYXNlX2NvZGV0NA==")).remove(); // #purchase_codet4
            // $4(atob('I2x1ZmZ5YWJjMTk0'))?.remove(); //#luffyabc194
          } else {
            localStorage.setItem(CookieName, "true");
            setTimeout(function () {
              $4(atob("I3B1cmNoYXNlX2NvZGV0NA==")).remove(); // #purchase_codet4
              // $4(atob('I2x1ZmZ5YWJjMTk0'))?.remove(); //#luffyabc194
            }, 1000);
          }
        } else {
          var mess = response.message;
          if (
            mess == "No sale belonging to the current user found with that code"
          ) {
            dom.body.firstElementChild.innerHTML =
              "<p>Purchase code error. It is a sales reversal or a refund. :(((</p>";
          } else if (mess.length == 58 || mess.length == 101) {
            dom.body.firstElementChild.innerHTML =
              "<p>That license key doesn't appear to be valid. Please check your purchase code again!<br>Please open a ticket at <a href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> if you have any question.</p>";
          } else if (mess.length == 104) {
            dom.body.firstElementChild.innerHTML =
              "<p>The license not match with current theme.!<br>Please open a ticket at <a href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> if you have any question.</p>";
          } else {
            try {
              var mess = mess.split("active domain `")[1].split("`. ")[0];
            } catch (err) {
              //var mess = mess;
            }
            dom.body.firstElementChild.innerHTML =
              "<p>Your purchase code is invalided since it is being activated at another store " +
              mess +
              ".<br> Please open a ticket at <a class='cg' href='https://support.the4.co' target='_blank'><span>support.the4.co</span></a> to get quick assistance.</p>";
          }
          document.body.append(dom.body.firstElementChild);
        }
      })
      .catch(function (e) {
        //}).catch((e)=>{
        console.error(e);
      });
  }
}
// end check purchase code

// readmore collection description
class DescriptionShort extends HTMLElement {
  constructor() {
    super();
    this.button_readmore = $4("[data-read-more]", this);
    this.button_readless = $4("[data-read-less]", this);
    this.short_des = $4(".hdt-collection-description-short", this);
    this.full_des = $4(".hdt-collection-description-full", this);
    if (
      !this.button_readmore ||
      !this.button_readless ||
      !this.short_des ||
      !this.full_des
    ) {
      return;
    }
    this.button_readmore.addEventListener("click", (e) => {
      // console.log(this);
      e.preventDefault();
      this.short_des.classList.add("hdt-hidden");
      this.full_des.classList.remove("hdt-hidden");
    });
    this.button_readless.addEventListener("click", (e) => {
      // console.log(this);
      e.preventDefault();
      this.short_des.classList.remove("hdt-hidden");
      this.full_des.classList.add("hdt-hidden");
    });
  }
}
customElements.define("description-short", DescriptionShort);

// video popup
class popupVideo extends HTMLElement {
  constructor() {
    super();
    this.modal = $4("hdt-modal", this);
    this.video = $4("hdt-video-player", this);
    this.modal.addEventListener("dialog:afterOpen", (e) => {
      this.video.play();
    });
    this.modal.addEventListener("dialog:beforeClose", (e) => {
      this.video.pause();
    });
  }
}
customElements.define("button-popup-video", popupVideo);

// product description - readmore
class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.lm_btn = this.querySelector(".hdt-pr-des-rm");
    if (!this.lm_btn) return;

    this.lm_btn.addEventListener("click", () => {
      this.classList.toggle("is--less");
    });
  }
}
customElements.define("product-description", ProductDescription);

// tabHover
class tabHover extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("mouseenter", (event) => {
      this.closest("hdt-tab")
        .querySelector('button[aria-current="true"]')
        ?.setAttribute("aria-current", false);
      this.parentElement.click();
    });
  }
}
customElements.define("tab-hover", tabHover);

let cartNotificationShowTimer;
let cartNotificationHideTimer;
const CART_NOTIFICATION_DEFAULT_MSG = "Item added to your cart";
const SESSION_CART_ITEMS_NOTIFICATION_KEY =
  "tdc_session_cart_items_notification_shown";

Shopify.usesMobileCartNotification = function () {
  return (
    window.matchMedia("(max-width: 1149px)").matches &&
    !!document.querySelector(".hdt-section-toolbar-mobile-cart")
  );
};

Shopify.hasBottomCartWidget = function () {
  if (Shopify.usesMobileCartNotification()) return true;
  return (
    window.matchMedia("(max-width: 767px)").matches &&
    !!document.getElementById("custom-sticky-cart")
  );
};

function setCartNotificationMessage(message) {
  const text = message || CART_NOTIFICATION_DEFAULT_MSG;
  const mobileText = document.querySelector(
    ".cart-notification-wrapper--mobile .cart-notification--mobile",
  );
  if (mobileText) mobileText.textContent = text;

  const heading = document.querySelector(
    ".cart-notification-wrapper--desktop .cart-notification__heading",
  );
  if (heading) {
    const icon = heading.querySelector("svg");
    heading.textContent = "";
    if (icon) heading.appendChild(icon);
    heading.append(" " + text);
  }
}

Shopify.cartNotification = function (message) {
  const useMobile = Shopify.usesMobileCartNotification();
  const desktop = document.querySelector(
    ".cart-notification-wrapper--desktop",
  );
  const mobile = document.querySelector(".cart-notification-wrapper--mobile");
  const notification = useMobile ? mobile : desktop;

  if (!notification) {
    console.warn("Cart notification element not found.");
    return;
  }

  setCartNotificationMessage(message);

  const delay = useMobile ? 1250 : 0;

  window.clearTimeout(cartNotificationShowTimer);
  window.clearTimeout(cartNotificationHideTimer);
  desktop?.classList.remove("open");
  mobile?.classList.remove("open");

  cartNotificationShowTimer = window.setTimeout(() => {
    notification.classList.add("open");
    cartNotificationHideTimer = window.setTimeout(() => {
      notification.classList.remove("open");
      setCartNotificationMessage();
    }, 3000);
  }, delay);
};

Shopify.maybeShowSessionCartNotification = function (cart) {
  if (!cart || cart.item_count < 1) return;
  if (sessionStorage.getItem(SESSION_CART_ITEMS_NOTIFICATION_KEY)) return;

  window.setTimeout(() => {
    if (!Shopify.hasBottomCartWidget()) return;

    sessionStorage.setItem(SESSION_CART_ITEMS_NOTIFICATION_KEY, "1");
    const plural = cart.item_count === 1 ? "" : "s";
    Shopify.cartNotification(
      `${cart.item_count} item${plural} in your cart`,
    );
  }, 150);
};
document.addEventListener("DOMContentLoaded", () => {
  function syncCartFooterHeight() {
    if (window.location.pathname !== "/cart" || window.innerWidth > 768) return;

    const footer = document.querySelector(".hdt-page-cart__footer");
    if (!footer) return;

    const footerHeight = Math.ceil(footer.getBoundingClientRect().height) || 140;
    document.documentElement.style.setProperty(
      "--hdt-cart-footer-height",
      footerHeight + "px"
    );
  }

  // Function to handle footer and copyCodeDiv logic
  function handleCartPageAdjustments() {
    const isCartPage = window.location.pathname === "/cart";
    const cartWrap = document.querySelector(".hdt-page-cart__wrap");
    const copyCodeDiv = document.querySelector(".hdt-cart-copyCode");

    if (!isCartPage) return;

    // Keep offers above items inside the cart wrap (not outside the container).
    if (copyCodeDiv && cartWrap && copyCodeDiv.parentElement !== cartWrap) {
      const offersAnchor =
        cartWrap.querySelector(".hdt-page-cart__header-saving") ||
        cartWrap.querySelector(".hdt-page-cart__wrap-items");
      if (offersAnchor) {
        cartWrap.insertBefore(copyCodeDiv, offersAnchor);
      } else {
        cartWrap.prepend(copyCodeDiv);
      }
    }

    syncCartFooterHeight();
  }

  // Initial run on page load
  handleCartPageAdjustments();

  // Re-run after cart section AJAX refresh
  document.addEventListener("cart:change", () => {
    if (window.location.pathname === "/cart") {
      requestAnimationFrame(handleCartPageAdjustments);
    }
  });

  // Cart page: "To Pay" scrolls to price summary (drawer opens a sheet)
  document.addEventListener("click", (event) => {
    const payBtn = event.target.closest("[data-scroll-cart-price-summary]");
    if (!payBtn || window.location.pathname !== "/cart") return;
    const summary =
      document.getElementById("cart-page-price-summary-desktop") ||
      document.getElementById("cart-page-price-summary") ||
      document.getElementById("cart-drawer-price-summary");
    if (summary) {
      summary.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });

  // Run the logic on screen resize
  window.addEventListener("resize", handleCartPageAdjustments);
});

Shopify.cartCongrats = function (cart, pageLoad) {
  let next_message = document.querySelector(".cart-progressBar .next-message");
  let offerData = next_message.getAttribute("compare_at_price");
  let final_Offer = next_message.getAttribute("data-final_Offer");
  let oldOfferData = sessionStorage.getItem("offerData");
  if (
    (oldOfferData !== null &&
      next_message.getAttribute("data-congrats") == "true" &&
      parseInt(offerData) > parseInt(oldOfferData)) ||
    (final_Offer == "true" && sessionStorage.getItem("final_Offer") == null)
  ) {
    let div = document.querySelector(".ConfettiImage_container");
    div.innerHTML = `<img class="ConfettiImage" src="https://images.mamaearth.in/gif/tierDiscount/confetti.gif" alt="Confetti">`;
    next_message.append(div);
    setTimeout(function () {
      if (final_Offer && final_Offer == "false") {
        let messageElement = document.querySelector(
          ".sticky-cart-notification .message",
        );
        messageElement.innerHTML = messageElement.getAttribute(
          "data-conditionMessage",
        );
      }
    }, 3000);
    setTimeout(function () {
      next_message.querySelector(".ConfettiImage").remove();
    }, 5000);
  }

  if (final_Offer == "true") {
    sessionStorage.setItem("final_Offer", final_Offer);
  } else {
    sessionStorage.removeItem("final_Offer");
  }
  sessionStorage.setItem("offerData", offerData);
};

Shopify.cartContractualProgress = function () {
  let next_message = document.querySelector(".cart-progressBar .next-message");
  let offerData = next_message.getAttribute("compare_at_price");
  let oldOfferData = sessionStorage.getItem("offerData");
  let final_Offer = next_message.getAttribute("data-final_Offer");
  if (
    parseInt(offerData) <= parseInt(oldOfferData) &&
    final_Offer &&
    final_Offer == "false"
  ) {
    let messageElement = document.querySelector(".message");
    messageElement.innerHTML = messageElement.getAttribute(
      "data-conditionMessage",
    );
  }
};

Shopify.cartContractual = function (cart) {
  console.log(cart, "cart");
  fetch(window.origin + "/?sections=sticky-cart-notification")
    .then((res) => res.json())
    .then((data) => {
      let stickyCartNotification = data["sticky-cart-notification"];
      const div = document.createElement("div");
      div.innerHTML = stickyCartNotification;
      let next_message = div.querySelector(".cart-progressBar .next-message");
      let offerData = next_message.getAttribute("compare_at_price");
      let oldOfferData = sessionStorage.getItem("offerData");
      let final_Offer = next_message.getAttribute("data-final_Offer");
      if (
        parseInt(offerData) <= parseInt(oldOfferData) &&
        final_Offer &&
        final_Offer == "false"
      ) {
        let messageElement = div.querySelector(".message");
        messageElement.innerHTML = messageElement.getAttribute(
          "data-conditionMessage",
        );
        document.getElementsByClassName(
          "sticky-cart-notification",
        )[0].innerHTML = div.innerHTML;
      } else {
        document.getElementsByClassName(
          "sticky-cart-notification",
        )[0].innerHTML = stickyCartNotification;
      }
      setTimeout(function () {
        Shopify.cartCongrats(cart, true);
      }, 300);
    })
    .catch((e) => {
      console.error(e);
    });
};

window.addEventListener("message", function (e) {
  if (e.data && e.data.name === "quantity_change") {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // If cart is empty, exit early
        Shopify.cartContractualProgress();
        Shopify.cartContractual(cart);
      });
  }
});

Shopify.cartStickyUpdate = function (cart) {
  // Get the most recent (first) item
  // Check if cart and cart.items exist and have items
  if (
    !cart ||
    !cart.items ||
    !Array.isArray(cart.items) ||
    cart.items.length === 0
  )
    return;

  const recentItem = cart.items[0];
  if (!recentItem || !recentItem.image) return;

  // Create new image element
  const img = document.createElement("img");
  img.src = recentItem.image;
  img.alt = recentItem.title;
  img.classList.add("recent-cart-item-image", "drop-in-image");
  img.style.transition = "transform 0.6s ease, opacity 0.6s ease";
  img.style.transform = "translateY(-40px)";
  img.style.opacity = "0";

  // Helper function to append new image
  function tryAppend() {
    const shadowHost = document.querySelector("shadow-dom-container");
    if (!shadowHost || !shadowHost.shadowRoot) return false;

    const target = shadowHost.shadowRoot.querySelector(".total-price-wrap");

    if (!target) return false;
    // if (cart.items.length >= 2 ) {target.style.width = '60px'; }
    // Remove duplicate of same image (avoid re-adding same)
    const exists = Array.from(
      target.querySelectorAll(".recent-cart-item-image"),
    ).some((el) => el.src === img.src);
    if (exists) return true;

    // Append new image at start
    target.append(img);

    // Keep only max 2 images
    const allImgs = target.querySelectorAll(".recent-cart-item-image");
    console.log("allImgs", allImgs);
    if (allImgs.length > 2) {
      allImgs[0].remove();
    }

    // const stickyCart = shadowHost.shadowRoot.querySelector(".sticky-cart");

    // if (stickyCart) {
    //   if (allImgs.length > 1) {
    //     // Apply padding-left ONLY on mobile devices
    //     if (window.innerWidth <= 767) {
    //       stickyCart.style.setProperty("padding", "4px 4px 4px 10px", "important");
    //     }
    //   } else {
    //     // Reset padding when only 1 image remains
    //     stickyCart.style.setProperty("padding-left", "0px", "important");
    //     stickyCart.style.setProperty("padding", "4px", "important");
    //   }
    // }
    if (target) {
      if (allImgs.length === 1) {
        target.style.setProperty("right", "12px", "important");
      } else if (allImgs.length > 1) {
        target.style.setProperty("right", "8px", "important");
      }
    }

    // Trigger animation (drop effect)
    requestAnimationFrame(() => {
      img.style.transform = "translateY(0)";
      img.style.opacity = "1";
    });

    const targetButton = shadowHost.shadowRoot.querySelector("button");

    if (!targetButton) return false;
    const plural = cart.item_count === 1 ? "" : "s";
    const cartCounter = `
        <div class="gk-cart-counter">
          <div class="gk-cart-count-text">View cart</div>
          <div class="gk-cart-count">${cart.item_count} Item${plural}</div>
        </div>
      `;

    // Update button contents
    targetButton.innerHTML = cartCounter;

    return true;
  }

  // Try immediately
  if (tryAppend()) return;

  // If not found yet, observe until element is ready
  const observer = new MutationObserver((mutations, obs) => {
    if (tryAppend()) {
      obs.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
};

Shopify.cartStickyHydrate = function (cart) {
  if (!cart.items?.length) return;

  const itemsToShow = cart.items.slice(0, 2);

  function tryAppend() {
    const shadowHost = document.querySelector("shadow-dom-container");
    if (!shadowHost?.shadowRoot) return false;

    const target = shadowHost.shadowRoot.querySelector(".total-price-wrap");
    if (!target) return false;

    // Clear existing
    target
      .querySelectorAll(".recent-cart-item-image")
      .forEach((el) => el.remove());

    itemsToShow.forEach((item, index) => {
      const img = document.createElement("img");
      img.src = item.image;
      img.classList.add("recent-cart-item-image");
      img.style.transform = `translateX(${index * 10}px)`;
      target.append(img);
    });

    // Update button text with item count
    const targetButton = shadowHost.shadowRoot.querySelector("button");
    if (targetButton) {
      const plural = cart.item_count === 1 ? "" : "s";
      const cartCounter = `
        <div class="gk-cart-counter">
          <div class="gk-cart-count-text">View cart</div>
          <div class="gk-cart-count">${cart.item_count} Item${plural}</div>
        </div>
      `;
      targetButton.innerHTML = cartCounter;
    }

    // Update positioning based on number of images
    if (target) {
      if (itemsToShow.length === 1) {
        target.style.setProperty("right", "12px", "important");
      } else if (itemsToShow.length > 1) {
        target.style.setProperty("right", "8px", "important");
      }
    }

    return true;
  }

  if (tryAppend()) return;

  const observer = new MutationObserver((_, obs) => {
    if (tryAppend()) obs.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
};

// Optional: Add CSS drop animation (if you can inject CSS)
const style = document.createElement("style");
style.textContent = `
  .drop-in-image {
    animation: dropIn 0.6s ease forwards;
  }

  @keyframes dropIn {
    0% {
      transform: translateY(-40px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;
document.head.appendChild(style);

if (document.querySelector(".cart-progressBar") !== null) {
  Shopify.cartContractualProgress();
}

/**
 * Brand impact odometer: must live in custom.js (not inline in the section) because
 * homepage lazy-load injects HTML via innerHTML — browsers do not run <script> tags from that HTML.
 */
function brandImpactRunForRoot(root) {
  if (!root || root.getAttribute("data-brand-impact-wired") === "1") return;
  root.setAttribute("data-brand-impact-wired", "1");

  const targetAttr = root.getAttribute("data-target") || "";
  let raw = String(targetAttr).replace(/\D/g, "");
  if (!raw.length) raw = "29987";

  const reducedMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const cycles = 2;

  function buildStrip(targetDigit) {
    const strip = document.createElement("div");
    strip.className = "brand-impact-section__digit-strip";
    if (reducedMotion) strip.classList.add("is-static");

    const chars = [];
    for (let c = 0; c < cycles; c++) {
      for (let j = 0; j <= 9; j++) chars.push(j);
    }
    for (let j = 0; j <= targetDigit; j++) chars.push(j);

    chars.forEach((n) => {
      const span = document.createElement("span");
      span.className = "brand-impact-section__digit-char";
      span.textContent = String(n);
      strip.appendChild(span);
    });

    return { strip, finalIndex: chars.length - 1 };
  }

  function layoutAndRun() {
    root.innerHTML = "";
    const windows = [];

    for (let i = 0; i < raw.length; i++) {
      const d = parseInt(raw.charAt(i), 10);
      if (Number.isNaN(d)) continue;

      const win = document.createElement("div");
      win.className = "brand-impact-section__digit-window";
      const built = buildStrip(d);
      win.appendChild(built.strip);
      root.appendChild(win);
      windows.push({ strip: built.strip, finalIndex: built.finalIndex });
    }

    if (!windows.length) return;

    function digitHeightPx() {
      const firstChar = windows[0].strip.querySelector(
        ".brand-impact-section__digit-char",
      );
      if (!firstChar) return 0;
      // Prefer sub-pixel measurements so strip translate aligns exactly.
      let h = firstChar.getBoundingClientRect().height;
      if (!h) h = firstChar.offsetHeight;
      return h;
    }

    function play(digitHeight) {
      windows.forEach((w, idx) => {
        const delay = reducedMotion ? 0 : idx * 100;
        const y = -w.finalIndex * digitHeight;
        window.setTimeout(() => {
          w.strip.style.transform = `translate3d(0,${y}px,0)`;
        }, delay);
      });
    }

    let measureTries = 0;
    function measureAndAnimate() {
      const digitHeight = digitHeightPx();
      if (!digitHeight) {
        measureTries += 1;
        if (measureTries < 40) {
          window.setTimeout(measureAndAnimate, 50);
        } else {
          play(48);
          root.setAttribute("data-brand-impact-done", "1");
        }
        return;
      }

      windows.forEach((w) => {
        w.strip.style.transform = "translate3d(0,0,0)";
      });
      void root.offsetHeight;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          play(digitHeight);
          root.setAttribute("data-brand-impact-done", "1");
        });
      });
    }

    if (reducedMotion) {
      let h0 = digitHeightPx();
      if (!h0) h0 = 48;
      windows.forEach((w) => {
        w.strip.style.transform = `translate3d(0,${-w.finalIndex * h0}px,0)`;
      });
      root.setAttribute("data-brand-impact-done", "1");
      return;
    }

    requestAnimationFrame(() => {
      requestAnimationFrame(measureAndAnimate);
    });
  }

  let started = false;
  function start() {
    if (started) return;
    started = true;
    layoutAndRun();
  }

  if ("IntersectionObserver" in window) {
    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return;
          obs.disconnect();
          start();
        });
      },
      { rootMargin: "120px 0px 120px 0px", threshold: 0 },
    );
    obs.observe(root);
    window.setTimeout(() => {
      if (!started && root.getAttribute("data-brand-impact-done") !== "1") {
        const r = root.getBoundingClientRect();
        if (r.top < window.innerHeight + 200 && r.bottom > -200) {
          obs.disconnect();
          start();
        }
      }
    }, 400);
  } else {
    start();
  }
}

window.initBrandImpactOdometers = function initBrandImpactOdometers(scope) {
  const rootEl = scope || document;
  rootEl.querySelectorAll("[data-brand-impact-odometer]").forEach((root) => {
    if (root.getAttribute("data-brand-impact-wired") === "1") return;
    brandImpactRunForRoot(root);
  });
};

document.addEventListener("shopify:section:load", (ev) => {
  const sec = ev.target;
  if (!sec || !sec.classList.contains("shopify-section")) return;
  sec.querySelectorAll("[data-brand-impact-odometer]").forEach((root) => {
    root.removeAttribute("data-brand-impact-wired");
    root.removeAttribute("data-brand-impact-done");
    brandImpactRunForRoot(root);
  });
});

function bootBrandImpactOdometers() {
  if (typeof window.initBrandImpactOdometers === "function") {
    window.initBrandImpactOdometers(document);
  }
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootBrandImpactOdometers);
} else {
  bootBrandImpactOdometers();
}

let lazyLoaded = false; // Prevent multiple fetch calls

const loadLazyContent = async () => {
  if (lazyLoaded) return;
  lazyLoaded = true; // Mark as loaded

  try {
    const res = await fetch(window.Shopify.routes.root + "pages/lazyload");
    const html = await res.text();

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;

    const lazyContent = tempDiv.querySelector(".lazyload-content");
    const target = document.querySelector(".lazy-loaded-sections");

    if (lazyContent && target) {
      target.innerHTML = lazyContent.innerHTML;
      target.classList.add("fade-in"); // Trigger animation

      // Initialize quantity controls for lazy-loaded products immediately
      if (typeof window.initProductQuantityControls === "function") {
        window.initProductQuantityControls();
      }

      // Section scripts are stripped from innerHTML; init odometer from bundle
      if (typeof window.initBrandImpactOdometers === "function") {
        window.initBrandImpactOdometers(target);
      }

      // Dispatch custom event
      document.dispatchEvent(
        new CustomEvent("lazyload:complete", { bubbles: true }),
      );
    }
  } catch (err) {
    console.error("Error loading lazy content:", err);
  }
};

// Detect user interaction: scroll, mouse move, or touch
// const interactionHandler = () => {
//   loadLazyContent();
//   window.removeEventListener("scroll", interactionHandler);
//   window.removeEventListener("mousemove", interactionHandler);
//   window.removeEventListener("touchstart", interactionHandler);
// };

// window.addEventListener("scroll", interactionHandler);
// window.addEventListener("mousemove", interactionHandler);
// window.addEventListener("touchstart", interactionHandler);
if (!window.navigator.userAgent.includes("Googlebot")) {
  document.addEventListener("DOMContentLoaded", () => {
    const lazyElements = document.querySelectorAll(".lazy-loaded-sections");
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadLazyContent();
          observer.unobserve(entry.target);
        }
      });
    });
    lazyElements.forEach((el) => observer.observe(el));
  });
}

// Detect customers pages via body classes injected by theme
const isCustomersPage = Array.from(document.body.classList || []).some((c) =>
  c.startsWith("hdt-page-type-customers"),
);
// Detect specific pages by URL path (works even behind password page)
const isOrdersPage =
  typeof location !== "undefined" &&
  location.pathname.indexOf("/pages/orders") === 0;
const isSkinAssessmentPage =
  typeof location !== "undefined" &&
  location.pathname.indexOf("/pages/skin-assessment") === 0;
const isSkinAssessmentEboPage =
  typeof location !== "undefined" &&
  location.pathname.indexOf("/pages/skin-assessment-ebo") === 0 ||
  location.pathname.indexOf("/pages/skin-assessment-demo") === 0;
const isMyAssessmentsPage =
  typeof location !== "undefined" &&
  location.pathname.indexOf("/pages/my-assessments") === 0;
const isReferPage =
  typeof location !== "undefined" &&
  location.pathname.indexOf("/pages/refer") === 0;
const isWalletPage =
  typeof location !== "undefined" &&
  location.pathname.indexOf("/pages/wallet") === 0;

// Hide GoKwik sticky cart globally (replaced by custom-sticky-cart section)
const hideGokwikStickyCart = () => {
  document.querySelectorAll("shadow-dom-container").forEach((container) => {
    if (container.shadowRoot) {
      const stickyCart = container.shadowRoot.querySelector(".sticky-cart");
      if (stickyCart) {
        stickyCart.style.setProperty("display", "none", "important");
      }

      if (!container.dataset.stickyCartObserved) {
        container.dataset.stickyCartObserved = "true";
        const shadowObserver = new MutationObserver(() => {
          const stickyCart = container.shadowRoot.querySelector(".sticky-cart");
          if (stickyCart && stickyCart.style.display !== "none") {
            stickyCart.style.setProperty("display", "none", "important");
          }
        });
        shadowObserver.observe(container.shadowRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["style", "class"],
        });
      }
    }
  });
};
hideGokwikStickyCart();
const gokwikStickyBlocker = new MutationObserver(hideGokwikStickyCart);
gokwikStickyBlocker.observe(document.body, { childList: true, subtree: true });

if (isWalletPage) {
  const observer = new MutationObserver(() => {
    const shadowHostNector = document.querySelector(
      "#nector-reward-page-container",
    );
    if (shadowHostNector && shadowHostNector.shadowRoot) {
      const ncInfoBtns = shadowHostNector.shadowRoot.querySelectorAll(
        ".nector-user-info-btns [role='button']",
      );
      ncInfoBtns.forEach((ele) => {
        if (
          ele.textContent.toLowerCase().includes("redeem dermacash") ||
          ele.textContent.toLowerCase().includes("your coupons")
        ) {
          ele.remove();
        }
      });
      const waystoearnSec =
        shadowHostNector.shadowRoot.querySelector("#waystoearn");
      waystoearnSec?.remove();
      const waystoredeemSec =
        shadowHostNector.shadowRoot.querySelector("#waystoredeem");
      waystoredeemSec?.remove();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}

// kwik cart script

function injectShadowStyles() {
  const shadowHost = document.querySelector("shadow-dom-container");
  if (!shadowHost || !shadowHost.shadowRoot) return;

  const style = document.createElement("style");
  style.textContent = `
    /* Desktop styles */
  @media (min-width: 768px) {


  .sticky-cart {
    width: max-content !important;
    border-radius: 50px !important;
    margin: auto !important;
    padding: 8px !important;
    bottom: 12% !important;
  }

  .sticky-cart .total-price {
    display: none !important;
  }

  .sticky-cart button {
    background-color: transparent !important;
    color: #fff !important;
    font-size: 14px !important;
    font-weight: 600 !important;
  }

  .gokwik-sidecart-container .toast.success {
    top: 4% !important;
    bottom: unset !important;
  }
}

/* Mobile styles */
@media (max-width: 767px) {

  .sticky-cart {
    width: max-content !important;
    border-radius: 50px !important;
    margin: auto !important;
    padding: 4px !important;
    bottom: 125px !important;
  }

  .sticky-cart .total-price {
    display: none !important;
  }

  .sticky-cart button {
    background-color: transparent !important;
    color: #fff !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    position: relative !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    gap: 1rem !important;

  }

  .total-price-wrap{
    right:8px;
  }

  .gk-cart-count {
    font-weight: 400;

  }

  .sticky-cart button::after {
    content: "";
    font-size: 0.9em;
    border-radius: 50%;
    color: white;
    background: rgb(0, 139, 119);
    -webkit-box-align: center;
    align-items: center;
    width: 3.5rem;
    height: 3.5rem;
    background-image: url(https://cdn.shopify.com/s/files/1/0888/8057/8807/files/right-white-arrow.svg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 10px;
    display: grid;
    opacity: 0.7;
    visibility: visible;
  }


  .sticky-cart .total-price-wrap {
    border: 0 !important;
    border-radius: 50% !important;
    width: 50px;
    height: 40px;
    padding: 0 !important;
  }

  .sticky-cart .total-price-wrap img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 50%;
    transition: transform 0.6s, opacity 0.6s;
    transform: translateY(0px);
    opacity: 1;
    position: absolute;
    border: 2px solid rgb(33, 122, 110);
  }

  .sticky-cart .total-price-wrap img:last-child {
    transform: translateX(10px) !important;
  }

  .sticky-cart .total-price-wrap img:first-child {
    transform: translateX(0px);
  }

  .sticky-cart .total-price-wrap svg,
  .sticky-cart .total-price-wrap span {
    display: none !important;
  }

  .gokwik-sidecart-container .toast.success {
    top: 10% !important;
    bottom: unset !important;
  }

  .sticky-cart .item-count {
    width: 1.5rem !important;
    height: 1.5rem !important;
    display: flex !important;
    padding: unset !important;
    border-radius: 50px !important;
    justify-content: center !important;
    align-items: center !important;
  }
}
  `;
  shadowHost.shadowRoot.appendChild(style);
}

// Skip shadow styling/observer on customers pages
if (!isCustomersPage) {
  // Wait for the shadow host to be added
  const observer = new MutationObserver((mutations, obs) => {
    const shadowHost = document.querySelector("shadow-dom-container");
    if (shadowHost && shadowHost.shadowRoot) {
      injectShadowStyles();
      obs.disconnect(); // Stop observing once done
      setTimeout(function () {
        fetch("/cart.js")
          .then((response) => response.json())
          .then((cart) => {
            // If cart is empty, exit early
            if (!cart.items || cart.items.length === 0) {
              return;
            }
            Shopify.cartStickyHydrate(cart);
          });
      }, 2000);
    }
  });

  window.addEventListener("message", function (e) {
    // OPTIONAL: lock down origin in production
    // if (e.origin !== window.location.origin) return;
    if (e.data && e.data.name === "close_sc") {
      fetch("/cart.js")
        .then((response) => response.json())
        .then((cart) => {
          // If cart is empty, exit early
          if (!cart.items || cart.items.length === 0) {
            return;
          }
          Shopify.cartStickyHydrate(cart);
        });
    }

    // Handle view_cart_clicked - click LimeChat CTA button
    if (e.data && e.data.name === "view_cart_clicked") {
      // Close LimeChat widget if it's open to avoid overlap
      (function closeLimechatIfOpen() {
        if (!window.$chatwoot) return;
        if (typeof window.$chatwoot.hide === "function") {
          window.$chatwoot.hide();
          return;
        }
        var holder = document.querySelector(".woot-widget-holder");
        var isHidden = holder && holder.classList.contains("woot--hide");
        if (!isHidden) {
          window.$chatwoot.toggle();
        }
      })();

      // Attempt to click LimeChat CTA (e.g., "View cart" button inside widget)
      (function clickLimechatCTA() {
        var tries = 0;
        var timer = setInterval(function () {
          var btn = document.querySelector(".action-button.with-text");
          if (btn) {
            btn.click();
            clearInterval(timer);
            return;
          }
          if (tries++ > 10) {
            clearInterval(timer);
          }
        }, 200);
      })();
    }
  });

  // Start observing the document for added nodes
  observer.observe(document.body, { childList: true, subtree: true });
}

// // Get the raw cart cookie
// function getCartCookie() {
//     const name = "cart=";
//     const decodedCookie = decodeURIComponent(document.cookie);
//     const parts = decodedCookie.split('; ').find(c => c.startsWith(name));
//     return parts ? parts.substring(name.length) : null;
// }

// function applyCoupon(coupon) {
//   try {
//     const rawCart = getCartCookie();

//     const response = await fetch("http://localhost:9001/apply-coupon", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify({ rawCart, coupon }),
//     });

//     if (!response.ok) {
//       throw new Error(`HTTP error! Status: ${response.status}`);
//     }

//     const data = await response.json();
//     return data; // This contains the cart info and discountCodes
//   } catch (error) {
//     console.error("Error applying coupon:", error);
//     return null;
//   }
// }

document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".how-works-btn");
  const container = document.getElementById("howItWorksContainer");
  const iconContainer = btn?.querySelector(".chevron-icon");
  if (btn) {
    btn.addEventListener("click", () => {
      container.style.display =
        container.style.display === "flex" ? "none" : "flex";
      iconContainer.classList.toggle("expanded");
      console.log("Checking the button", iconContainer);
    });
  }
  createCartPromise().then((cart) => {
    // If cart is empty, exit early
    if (!cart.items || cart.items.length === 0) {
      console.log("🛒 Cart is empty.");
      return;
    }
    console.log("cart on refresh", cart);
    Shopify.cartStickyHydrate(cart);
    Shopify.maybeShowSessionCartNotification(cart);
    // Shopify.cartStickyUpdate(cart);
    // Shopify.cartContractual(cart);
    // Get the most recent items (up to 2)
    // const itemsToShow = cart.items.slice(0, 2);
    // console.log("itemsToShow on refresh", itemsToShow);
    // // Create image elements for each item
    // const imgs = itemsToShow.map((item, index) => {
    //   const img = document.createElement("img");
    //   img.src = item.image;
    //   img.alt = item.title;
    //   img.classList.add("recent-cart-item-image", "drop-in-image");
    //   img.style.transform = `translateY(0px) translateX(${index * 10}px)`;
    //   img.style.opacity = "1";
    //   img.style.width = "40px";
    //   img.style.height = "40px";
    //   img.style.objectFit = "cover";
    //   img.style.borderRadius = "50%";
    //   img.style.position = "absolute";
    //   img.style.border = "2px solid rgb(33, 122, 110)";
    //   return img;
    // });
    // console.log("imgs on refresh", imgs);
    // // Helper function to append images
    // function tryAppend() {
    //   const shadowHost = document.querySelector("shadow-dom-container");
    //   if (!shadowHost || !shadowHost.shadowRoot) return false;

    //   const target = shadowHost.shadowRoot.querySelector(".total-price-wrap");

    //   if (!target) return false;

    //   // Remove existing images
    //   target.querySelectorAll(".recent-cart-item-image").forEach(img => img.remove());

    //   // Append new images
    //   imgs.forEach(img => target.append(img));

    //   // Set positioning based on number of images
    //   if (target) {
    //     if (imgs.length === 1) {
    //       target.style.setProperty("right", "12px", "important");
    //     } else if (imgs.length > 1) {
    //       target.style.setProperty("right", "8px", "important");
    //     }
    //   }

    //   const targetButton = shadowHost.shadowRoot.querySelector("button");

    //   if (!targetButton) return false;
    //   const plural = cart.item_count === 1 ? "" : "s";
    //   const cartCounter = `
    //       <div class="gk-cart-counter">
    //         <div class="gk-cart-count-text">View cart</div>
    //         <div class="gk-cart-count">${cart.item_count} Item${plural}</div>
    //       </div>
    //     `;

    //   // Update button contents
    //   targetButton.innerHTML = cartCounter;

    //   return true;
    // }

    // // Try immediately
    // if (tryAppend()) return;

    // // If not found yet, observe until element is ready
    // const observer = new MutationObserver((mutations, obs) => {
    //   if (tryAppend()) {
    //     obs.disconnect();
    //   }
    // });
    // observer.observe(document.body, { childList: true, subtree: true });
  });
});

Shopify.shareReferral = async function () {
  // const customerId = window.NectorService.getCustomerId();
  // const referralCode = await window.NectorService.getReferralCode();
  // let referralLink = referralCode ? `${Shopify.storeDomain}/?referral_code=${window.nector_data.lead.referral_code}`:`${Shopify.storeDomain}/?referral_code=${referralCode}`;
  let referralLink = `${Shopify.storeDomain}/?referral_code=${window.nector_data.lead.referral_code}`;
  let shareText = `The Derma Co.
*Claim Your ₹100 Gift at The Derma Co!* 
I am gifting you ₹100 to try out science-backed skincare from The Derma Co. Plus, with every order you place, a portion goes towards funding a science scholarship for an underprivileged child.
Join now and experience the benefits.
*Don’t forget!*
Use the link ${referralLink} to claim your ₹100 bonus!`;

  const shareButton = event?.currentTarget || null;
  // Moengage.track_event("Refferal_Link_Share", { source: "More" });
  if (navigator.share) {
    try {
      if (shareButton) shareButton.disabled = true;
      // Moengage.track_event("Refferal_Invite_Shared");

      await navigator.share({
        title: "Refer Friends",
        text: shareText,
        url: `/?referral_code=${window.nector_data.lead.referral_code}`,
      });

      console.log("Share successful");
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Share canceled by user.");
      } else {
        console.error("Error sharing:", error);
      }
    } finally {
      if (shareButton) shareButton.disabled = false;
    }
  } else {
    alert("Sharing not supported in this browser");
  }
};

Shopify.shareOnWhatsApp = async function (event) {
  event.preventDefault();
  try {
    // Moengage.track_event("Refferal_Link_Share", { source: "whatsapp" });
  } catch (e) {
    console.warn("MoEngage tracking failed", e);
  }
  const referralLink = `${Shopify.storeDomain}/?referral_code=${window.nector_data.lead.referral_code}`;
  const message = `The Derma Co.
*Claim Your ₹100 Gift at The Derma Co!* 
I am gifting you ₹100 to try out science-backed skincare from The Derma Co. Plus, with every order you place, a portion goes towards funding a science scholarship for an underprivileged child.
Join now and experience the benefits.
*Don’t forget!*
Use the link ${referralLink} to claim your ₹100 bonus!`;
  window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank");
};

Shopify.copyReferralLink = async function () {
  // Moengage.track_event("Refferal_Link_Copy");
  const link = document.getElementById("referral-link");
  link.select();
  link.setSelectionRange(0, 99999);
  document.execCommand("copy");
};

Shopify.shareReferralLogin = async function (event) {
  window.location = window.origin + "/account/";
};

Shopify.shareOnWhatsAppLogin = async function (event) {
  window.location = window.origin + "/account/";
};

// Track Order Popup Functions
window.openTrackOrderPopup = function () {
  console.log("openTrackOrderPopup called");
  let popup = document.getElementById("trackOrderPopup");
  console.log("Popup element:", popup);

  // Create popup if it doesn't exist
  if (!popup) {
    console.log("Popup not found, creating it now");
    var popupHTML = `
      <div id="trackOrderPopup" class="hdt-track-order-popup-overlay" style="display: none;">
        <div class="hdt-track-order-popup-backdrop" onclick="window.closeTrackOrderPopup()"></div>
        <div class="hdt-track-order-popup-content">
          <div class="hdt-track-order-popup-close-btn" onclick="window.closeTrackOrderPopup()">
            <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 1.4L14.6 0L8 6.6L1.4 0L0 1.4L6.6 8L0 14.6L1.4 16L8 9.4L14.6 16L16 14.6L9.4 8L16 1.4Z" fill="currentColor"/>
            </svg>
          </div>
          <div class="hdt-track-order-popup-header">
            <h3>Track Order</h3>
          </div>
          <div class="hdt-track-order-popup-body">
            <div class="hdt-track-order-field">
              <label for="awbNumber">AWB Number</label>
              <input
                type="text"
                id="awbNumber"
                name="awbNumber"
                placeholder="Please enter your AWB number here"
                oninput="window.handleTrackOrderInput('awb')"
              >
            </div>
            <button type="button" class="hdt-track-order-submit" id="trackOrderSubmitBtn" onclick="window.handleTrackOrder()" disabled>Track Order</button>
          </div>
        </div>
      </div>
    `;

    var tempDiv = document.createElement("div");
    tempDiv.innerHTML = popupHTML;
    document.body.appendChild(tempDiv.firstElementChild);
    popup = document.getElementById("trackOrderPopup");
    console.log("Track order popup created and appended to body");
  }

  if (popup) {
    // Show popup first
    popup.style.display = "flex";
    document.body.classList.add("track-order-popup-open");

    // Trigger animation on next frame
    requestAnimationFrame(() => {
      popup.classList.add("active");
    });

    console.log("Popup opened");

    // Clear previous values
    const awbInput = document.getElementById("awbNumber");
    if (awbInput) awbInput.value = "";

    // Enable field initially
    if (awbInput) {
      awbInput.disabled = false;
      awbInput.style.opacity = "1";
    }
  } else {
    console.error("Track order popup element could not be created!");
  }
};

window.closeTrackOrderPopup = function () {
  console.log("closeTrackOrderPopup called");
  const popup = document.getElementById("trackOrderPopup");

  if (popup) {
    popup.classList.remove("active");
    // Wait for animation to complete before hiding
    setTimeout(() => {
      popup.style.display = "none";
    }, 300);
    document.body.classList.remove("track-order-popup-open");
    console.log("Popup closed");
  }
};

// Validate that only numbers are entered
window.validateNumberInput = function (event) {
  const charCode = event.which ? event.which : event.keyCode;
  // Allow only numbers (0-9)
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
    return false;
  }
  return true;
};

// Update button state based on input
window.updateTrackOrderButton = function () {
  const awbInput = document.getElementById("awbNumber");
  const submitBtn = document.getElementById("trackOrderSubmitBtn");

  const awbValue = awbInput?.value.trim();

  // Enable button only if AWB field has a value
  if (submitBtn) {
    if (awbValue) {
      submitBtn.disabled = false;
    } else {
      submitBtn.disabled = true;
    }
  }
};

// Handle input field
window.handleTrackOrderInput = function (fieldType) {
  const awbInput = document.getElementById("awbNumber");

  // Remove any non-alphanumeric characters (keep only letters and numbers)
  if (fieldType === "awb" && awbInput) {
    awbInput.value = awbInput.value.replace(/[^a-zA-Z0-9]/g, "");
  }

  // Update button state
  window.updateTrackOrderButton();
};

window.handleTrackOrder = function () {
  console.log("handleTrackOrder called");

  const submitBtn = document.getElementById("trackOrderSubmitBtn");

  // Don't proceed if button is disabled
  if (submitBtn?.disabled) {
    console.log("Button is disabled, not proceeding");
    return;
  }

  const awbInput = document.getElementById("awbNumber");

  const awbNumber = awbInput?.value.trim();

  if (!awbNumber) {
    alert("Please enter AWB Number");
    return;
  }

  // Validate that the input contains only alphanumeric characters
  if (!/^[a-zA-Z0-9]+$/.test(awbNumber)) {
    alert("AWB Number must contain only letters and numbers");
    return;
  }

  // Build the tracking URL with AWB number (alphanumeric only)
  const trackingUrl = `https://shiprocket.co/tracking/${awbNumber}`;

  console.log("Redirecting to:", trackingUrl);

  // Close the popup
  window.closeTrackOrderPopup();

  // Redirect to tracking page
  window.location.href = trackingUrl;
};

// Close popup on Escape key
document.addEventListener("keydown", function (e) {
  if (e.key === "Escape") {
    const popup = document.getElementById("trackOrderPopup");
    if (popup && popup.classList.contains("active")) {
      window.closeTrackOrderPopup();
    }
  }
});

// Debug: Log when functions are loaded
console.log("Track order functions loaded:", {
  openTrackOrderPopup: typeof window.openTrackOrderPopup,
  closeTrackOrderPopup: typeof window.closeTrackOrderPopup,
  handleTrackOrder: typeof window.handleTrackOrder,
});

// Prevent menu from closing on click when it's already open via hover (desktop only)
(function () {
  // Only run on desktop
  function isDesktop() {
    return window.innerWidth >= 768;
  }

  // Store which menus were open before click
  const openMenusBeforeClick = new WeakSet();

  // Handle clicks on menu items with submenus
  document.addEventListener(
    "click",
    function (e) {
      if (!isDesktop()) return;

      // Find the summary element that was clicked
      const summary = e.target.closest("hdt-header-menu summary");
      if (!summary) return;

      const headerMenu = summary.closest("hdt-header-menu");
      if (!headerMenu) return;

      // Check if menu is in hover mode
      const eventType = headerMenu.getAttribute("event");
      if (eventType !== "hover") return;

      // Check if menu item has children (has submenu)
      const menuItem = summary.closest(".hdt-has-children");
      if (!menuItem) return;

      // Check if menu is already open
      const details = summary.closest("details");
      if (!details) return;

      const isOpen = details.hasAttribute("open");

      // If menu is open and has children, mark it and prevent closing
      if (isOpen) {
        openMenusBeforeClick.add(details);

        // Prevent the default toggle behavior
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        return false;
      }
    },
    true,
  ); // Use capture phase to catch the event early

  // Use MutationObserver to watch for changes to the open attribute
  const observer = new MutationObserver(function (mutations) {
    if (!isDesktop()) return;

    mutations.forEach(function (mutation) {
      if (mutation.type === "attributes" && mutation.attributeName === "open") {
        const details = mutation.target;

        // If this menu was open before click and is being closed, prevent it
        if (
          openMenusBeforeClick.has(details) &&
          !details.hasAttribute("open")
        ) {
          // Reopen the menu
          details.setAttribute("open", "");
          const summary = details.querySelector("summary");
          if (summary) {
            summary.setAttribute("aria-expanded", "true");
          }

          // Remove from set after a short delay
          setTimeout(function () {
            openMenusBeforeClick.delete(details);
          }, 100);
        } else if (details.hasAttribute("open")) {
          // Menu opened, remove from tracking after delay
          setTimeout(function () {
            openMenusBeforeClick.delete(details);
          }, 100);
        }
      }
    });
  });

  // Observe all hdt-header-menu details elements
  function observeMenus() {
    if (!isDesktop()) return;

    const menuDetails = document.querySelectorAll("hdt-header-menu details");
    menuDetails.forEach(function (details) {
      observer.observe(details, {
        attributes: true,
        attributeFilter: ["open"],
      });
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeMenus);
  } else {
    observeMenus();
  }

  // Re-observe when new content is added (for dynamic menus)
  const initObserver = new MutationObserver(function () {
    observeMenus();
  });

  if (document.body) {
    initObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
})();

// Fallback: ensure view_cart tracking is available on PDP
(() => {
  if (window.__pdpViewCartFallbackBound) return;
  if (typeof window.fireViewCart === "function") return;
  window.__pdpViewCartFallbackBound = true;

  function getPageName() {
    const bodyClass = document.body && document.body.className ? document.body.className : "";
    const templateMatch = bodyClass.match(/\btemplate-([a-zA-Z0-9_-]+)/);
    if (!templateMatch) return "";
    return templateMatch[1] === "index" ? "home" : templateMatch[1];
  }

  function calculateGrandTotal(cart) {
    if (window.updatedCartToPayAmount !== null && window.updatedCartToPayAmount !== undefined) {
      return window.updatedCartToPayAmount;
    }
    if (cart.total_discount > 0) {
      return cart.total_price > 37490
        ? (cart.original_total_price - cart.total_discount) / 100
        : ((cart.original_total_price - cart.total_discount) + 4000) / 100;
    }
    return cart.total_price > 37490
      ? cart.original_total_price / 100
      : (cart.total_price + 4000) / 100;
  }

  function fireViewCartFallback(clickFrom) {
    fetch("/cart.js", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    })
      .then((response) => {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then((cart) => {
        if (!cart || !Array.isArray(cart.items)) return;
        const items = cart.items.map((item) => ({
          item_id: item.sku,
          product_id: item.product_id,
          item_name: item.product_title,
          item_variant: item.variant_id,
          quantity: item.quantity,
          price: item.price / 100,
        }));

        const orderTotal =
          cart.total_discount > 0 ? cart.original_total_price / 100 : cart.total_price / 100;
        const grandTotal = calculateGrandTotal(cart);
        const pageName = getPageName();

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "view_cart",
          ecommerce: {
            page_name: pageName,
            currency: "INR",
            value: grandTotal,
            click_from: clickFrom,
            cart_value_order_total: orderTotal,
            cart_value_grand_total: grandTotal,
            items: items,
          },
        });

        if (window.Moengage && typeof window.Moengage.track_event === "function") {
          const isLoggedInValue = localStorage.getItem("isLoggedIn") === "true";
          window.Moengage.track_event("viewCart", {
            value: grandTotal,
            currency: "INR",
            page: pageName,
            click_from: clickFrom,
            isLoggedIn: isLoggedInValue,
          });
        }
      })
      .catch((error) => {
        console.error("view_cart fallback error:", error);
      });
  }

  window.fireViewCart = fireViewCartFallback;

  // Sticky cart is tracked in custom-sticky-cart.js — do not listen for it here
  // or view_cart would fire twice (capture listener + sticky handleClick).
  document.addEventListener(
    "click",
    (e) => {
      const target = e.target;
      if (!target || !target.closest) return;
      if (target.closest("[data-custom-sticky-cart-trigger]")) {
        return;
      }
      if (target.closest("#cart-icon-bubble") || target.closest(".hdt-site-nav_cart")) {
        fireViewCartFallback("cart_icon");
        return;
      }
      if (target.closest(".hdt-toolbart-cart")) {
        fireViewCartFallback("bottom_toolbar");
      }
    },
    true,
  );
})();

Shopify.getMaxAddToCartQty = function (contextEl = null) {
  const scopedEl =
    contextEl &&
    (contextEl.closest?.("[data-atc-max]") ||
      (contextEl.matches?.("[data-atc-max]") ? contextEl : null));
  const nestedScopedEl =
    !scopedEl && contextEl?.querySelector
      ? contextEl.querySelector("[data-atc-max]")
      : null;
  const scopedMax =
    scopedEl?.getAttribute?.("data-atc-max") ||
    nestedScopedEl?.getAttribute?.("data-atc-max");
  const scopedNum = parseInt(scopedMax, 10);
  if (!isNaN(scopedNum) && scopedNum > 0) return scopedNum;
  return parseInt(window.themeHDN?.extras?.maxAddToCartQty, 10) || 14;
};

Shopify.validateAddToCartQty = async function (variantId, requestQty, contextEl = null) {
  const maxQty = Shopify.getMaxAddToCartQty(contextEl);
  const qty = parseInt(requestQty, 10) || 1;
  const idNum = parseInt(variantId, 10);
  if (isNaN(idNum)) return { allowed: true };
  try {
    let cart = null;
    if (typeof window.createCartPromise === "function") {
      cart = await window.createCartPromise();
    } else {
      const cartRes = await fetch(`${Shopify.routes.root}cart.js`, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      if (cartRes.ok) cart = await cartRes.json();
    }
    if (!cart || !Array.isArray(cart.items)) return { allowed: true };
    const cartItem = cart.items.find(
      (item) => parseInt(item.variant_id, 10) === idNum,
    );
    const currentQty = cartItem ? parseInt(cartItem.quantity, 10) || 0 : 0;
    if (currentQty + qty > maxQty) {
      return {
        allowed: false,
        message: `You can't add more than ${maxQty} items`,
      };
    }
    return { allowed: true };
  } catch {
    return { allowed: true };
  }
};

// =====================================
// Quantity Controls for Product Cards (ATC Inc/Dec)
// =====================================
(function () {
  // Store initialized wrappers to avoid re-initialization
  const initializedWrappers = new WeakSet();
  // Cache cart data to avoid multiple fetches
  let cachedCart = null;
  let cartFetchPromise = null;
  // Sequence so only the latest cart update wins when multiple removals happen (avoids UI/count mismatch)
  let cartUpdateSequence = 0;

  // Persist variant→qty so sticky/card steppers can paint on reload without waiting for cart.js
  const CART_QTY_CACHE_KEY = "tdc_cart_variant_qty_v1";

  function persistCartQtyCache(cart) {
    if (!cart || !Array.isArray(cart.items)) return;
    try {
      const map = {};
      cart.items.forEach((item) => {
        const id = String(item.variant_id);
        map[id] = (map[id] || 0) + (parseInt(item.quantity, 10) || 0);
      });
      sessionStorage.setItem(CART_QTY_CACHE_KEY, JSON.stringify(map));
    } catch (_) {
      /* private mode / quota */
    }
  }

  function getCachedVariantQty(variantId) {
    if (!variantId) return 0;
    try {
      const raw = sessionStorage.getItem(CART_QTY_CACHE_KEY);
      if (!raw) return 0;
      const map = JSON.parse(raw);
      return parseInt(map[String(variantId)], 10) || 0;
    } catch (_) {
      return 0;
    }
  }

  function bumpCachedVariantQty(variantId, qty) {
    if (!variantId) return;
    try {
      const map = JSON.parse(sessionStorage.getItem(CART_QTY_CACHE_KEY) || "{}");
      const n = parseInt(qty, 10) || 0;
      if (n > 0) map[String(variantId)] = n;
      else delete map[String(variantId)];
      sessionStorage.setItem(CART_QTY_CACHE_KEY, JSON.stringify(map));
    } catch (_) {
      /* private mode / quota */
    }
  }

  // Get cart data (cached or fetch) — prefer theme's in-flight cart.js to avoid duplicate waits
  function getCart(forceRefresh) {
    if (!forceRefresh && cachedCart) {
      return Promise.resolve(cachedCart);
    }
    if (!forceRefresh && cartFetchPromise) {
      return cartFetchPromise;
    }

    // Reuse theme createCartPromise / fetchCart when available (same cart.js request)
    if (
      !forceRefresh &&
      typeof window.createCartPromise === "function"
    ) {
      cartFetchPromise = Promise.resolve(window.createCartPromise(false))
        .then((cart) => {
          if (cart && typeof cart === "object" && Array.isArray(cart.items)) {
            cachedCart = cart;
            persistCartQtyCache(cart);
          }
          cartFetchPromise = null;
          return cachedCart || cart;
        })
        .catch((err) => {
          cartFetchPromise = null;
          throw err;
        });
      return cartFetchPromise;
    }

    if (!forceRefresh && window.fetchCart) {
      cartFetchPromise = Promise.resolve(window.fetchCart)
        .then((cart) => {
          if (cart && typeof cart === "object" && Array.isArray(cart.items)) {
            cachedCart = cart;
            persistCartQtyCache(cart);
          }
          cartFetchPromise = null;
          return cachedCart || cart;
        })
        .catch((err) => {
          cartFetchPromise = null;
          throw err;
        });
      return cartFetchPromise;
    }

    cartFetchPromise = fetch(`${window.Shopify.routes.root}cart.js`)
      .then((res) => res.json())
      .then((cart) => {
        cachedCart = cart;
        persistCartQtyCache(cart);
        cartFetchPromise = null;
        return cart;
      })
      .catch((err) => {
        cartFetchPromise = null;
        throw err;
      });
    return cartFetchPromise;
  }

  // Max add-to-cart quantity with per-product override from data-atc-max
  const getMaxAddToCartQty = (contextEl = null) =>
    Shopify.getMaxAddToCartQty(contextEl);

  // Debounce function for cart updates (reuse if available globally, otherwise define)
  const debounceCartUpdate =
    (typeof debounce !== "undefined" && debounce) ||
    function (func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    };

  // Invalidate cache on cart changes (immediate for cache, debounced for UI updates)
  document.addEventListener("cart:change", function (event) {
    if (event.detail && event.detail.cart) {
      cachedCart = event.detail.cart; // Update cache immediately
      persistCartQtyCache(event.detail.cart);
    }
  });

  document.addEventListener("variant:add", function (event) {
    if (event.detail && event.detail.cart) {
      persistCartQtyCache(event.detail.cart);
    }
  });

  // Collect bundled section IDs (cart drawer, cart page, etc.) for Shopify section rendering API
  function collectCartSectionIds() {
    const sections = [];
    document.dispatchEvent(
      new CustomEvent("cart:push:section.id", {
        bubbles: true,
        detail: { sections },
      }),
    );
    return sections;
  }

  function getCartItemQuantity(cart, variantId) {
    if (!cart || !cart.items || !Array.isArray(cart.items)) return 0;
    const numericVariantId = parseInt(variantId, 10);
    const cartItem = cart.items.find((item) => {
      const itemVariantId = parseInt(item.variant_id, 10);
      return (
        itemVariantId === numericVariantId ||
        String(item.variant_id) === String(variantId)
      );
    });
    return cartItem ? parseInt(cartItem.quantity, 10) || 0 : 0;
  }

  function applyWrapperQtyUi(wrapper, qty) {
    if (!wrapper) return;

    const qtyDisplay = wrapper.querySelector(".hdt-quantity-control-qty");
    const addToCartBtn =
      wrapper.querySelector(".hdt-add-to-cart-btn") ||
      wrapper.querySelector(".hdt-sticky-atc__submit:not(.hdt-sticky-atc__submit--notifyme)");
    const tooltipWrapper = addToCartBtn
      ? addToCartBtn.closest("hdt-tooltip")
      : null;
    const quantityControls = wrapper.querySelector(
      ".hdt-card-product__quantity-controls",
    );
    const minusBtn = wrapper.querySelector(
      ".hdt-quantity-control-btn--minus",
    );
    const plusBtn = wrapper.querySelector(".hdt-quantity-control-btn--plus");

    if (!qtyDisplay || !quantityControls || !minusBtn || !plusBtn) {
      return;
    }

    const numericQty = parseInt(qty, 10) || 0;
    // In-flight lock only applies to the variant it was started for (card variant selector can switch mid-request)
    const updatingAction =
      wrapper.dataset.qtyUpdatingVariant === wrapper.dataset.variantId
        ? wrapper.dataset.qtyUpdating
        : undefined; // "plus" | "minus" | undefined
    const isSoldOut = wrapper.dataset.soldOut === "true";

    // Card size selector: a sold-out size shows this View product link (to that size's PDP) instead of ATC / stepper
    const soldOutBtn = wrapper.querySelector(".hdt-card-product__btn-sold-out");

    // Sold-out / notify-me: always show CTA, never the cart qty stepper
    if (isSoldOut || !addToCartBtn) {
      wrapper.dataset.currentQuantity = "0";
      const showSoldOutBtn = isSoldOut && Boolean(soldOutBtn);
      if (soldOutBtn) soldOutBtn.style.display = showSoldOutBtn ? "" : "none";
      if (tooltipWrapper) tooltipWrapper.style.display = showSoldOutBtn ? "none" : "";
      if (addToCartBtn) addToCartBtn.style.display = showSoldOutBtn ? "none" : "";
      quantityControls.style.display = "none";
      return;
    }
    if (soldOutBtn) soldOutBtn.style.display = "none";

    if (numericQty > 0) {
      const maxQty = getMaxAddToCartQty(wrapper);
      const displayQty = Math.min(numericQty, maxQty);
      wrapper.dataset.currentQuantity = String(displayQty);
      bumpCachedVariantQty(wrapper.dataset.variantId, displayQty);
      if (tooltipWrapper) tooltipWrapper.style.display = "none";
      addToCartBtn.style.display = "none";
      quantityControls.style.display = "flex";
      qtyDisplay.textContent = displayQty;
      // Only the clicked control stays locked while its request is in flight
      minusBtn.disabled = displayQty <= 0 || updatingAction === "minus";
      minusBtn.classList.toggle(
        "disabled",
        displayQty <= 0 || updatingAction === "minus",
      );
      plusBtn.disabled = updatingAction === "plus" || displayQty >= maxQty;
      plusBtn.classList.toggle(
        "disabled",
        updatingAction === "plus" || displayQty >= maxQty,
      );
      return;
    }

    wrapper.dataset.currentQuantity = "0";
    bumpCachedVariantQty(wrapper.dataset.variantId, 0);
    if (tooltipWrapper) tooltipWrapper.style.display = "";
    addToCartBtn.style.display = "";
    quantityControls.style.display = "none";
    qtyDisplay.textContent = "1";
    minusBtn.disabled = true;
    minusBtn.classList.add("disabled");
    plusBtn.disabled = updatingAction === "plus";
    plusBtn.classList.toggle("disabled", updatingAction === "plus");
  }

  /** Instant paint from SSR / sessionStorage — do not wait for cart.js */
  function paintWrapperFromLocalQty(wrapper) {
    if (!wrapper || wrapper.dataset.soldOut === "true") return;
    const ssrQty = parseInt(wrapper.dataset.currentQuantity, 10) || 0;
    const cachedQty = getCachedVariantQty(wrapper.dataset.variantId);
    const qty = Math.max(ssrQty, cachedQty);
    if (qty > 0) {
      applyWrapperQtyUi(wrapper, qty);
    }
  }

  /** Sync one wrapper from cart (or cached cart) using live data-variant-id */
  function syncQtyControlsWrapper(wrapper, cart) {
    if (!wrapper) return;
    if (!initializedWrappers.has(wrapper)) {
      initQuantityControls(wrapper, cart || cachedCart);
      return;
    }
    const variantId = wrapper.dataset.variantId;
    if (!variantId) return;
    // Read the live variant id — it may change again before an async cart resolves
    const applyFromCart = (cartData) => {
      applyWrapperQtyUi(
        wrapper,
        getCartItemQuantity(cartData, wrapper.dataset.variantId),
      );
    };
    if (cart && cart.items) {
      applyFromCart(cart);
      return;
    }
    if (cachedCart && cachedCart.items) {
      applyFromCart(cachedCart);
      return;
    }
    // No cart yet: paint from the per-variant session cache, then reconcile
    applyWrapperQtyUi(wrapper, getCachedVariantQty(variantId));
    getCart()
      .then(applyFromCart)
      .catch(() => {});
  }

  window.syncQtyControlsWrapper = syncQtyControlsWrapper;

  function updateAllQuantityControls(cart) {
    if (!cart || !cart.items || !Array.isArray(cart.items)) return;
    persistCartQtyCache(cart);

    document.querySelectorAll(".hdt-qty-controls-wrapper").forEach((wrapper) => {
      if (!initializedWrappers.has(wrapper)) return;

      const variantId = wrapper.dataset.variantId;
      if (!variantId) return;

      applyWrapperQtyUi(wrapper, getCartItemQuantity(cart, variantId));
    });
  }

  function showProductCardQtyStepper(wrapper, qty) {
    if (!wrapper) return;
    if (!initializedWrappers.has(wrapper)) {
      initQuantityControls(wrapper, cachedCart);
    }
    applyWrapperQtyUi(wrapper, qty);
  }

  window.showProductCardQtyStepper = showProductCardQtyStepper;
  window.updateProductCardQtyControlsFromCart = updateAllQuantityControls;

  // Debounced refresh for noisy cart updates (kwikcart sync, section re-renders)
  const debouncedUpdateAllQuantityControls = debounceCartUpdate(
    updateAllQuantityControls,
    200,
  );

  // Single shared event listener for all quantity controls
  let cartChangeListenerAttached = false;
  if (!cartChangeListenerAttached) {
    cartChangeListenerAttached = true;
    document.addEventListener("variant:add", function (event) {
      const cart = event.detail && event.detail.cart;
      if (cart) {
        cachedCart = cart;
        updateAllQuantityControls(cart);
      }
    });
    document.addEventListener("cart:change", function (event) {
      if (event.detail && event.detail.cart) {
        cachedCart = event.detail.cart;
        const baseEvent = event.detail.baseEvent;
        if (
          baseEvent === "variant:add" ||
          baseEvent === "line-item:change" ||
          baseEvent === "kwikcart-sync"
        ) {
          updateAllQuantityControls(event.detail.cart);
        } else {
          debouncedUpdateAllQuantityControls(event.detail.cart);
        }
      }
    });
    document.addEventListener("cart:refresh", function (event) {
      const cart = event?.detail?.cart;
      if (cart && typeof cart === "object" && Array.isArray(cart.items)) {
        cachedCart = cart;
        debouncedUpdateAllQuantityControls(cart);
      }
    });
  }

  // Initialize quantity controls for a single wrapper
  function initQuantityControls(wrapper, cartData) {
    if (initializedWrappers.has(wrapper)) return;
    initializedWrappers.add(wrapper);

    const getVariantId = () => wrapper.dataset.variantId;
    const productId = wrapper.dataset.productId;
    if (!getVariantId()) return;

    const addToCartBtn =
      wrapper.querySelector(".hdt-add-to-cart-btn") ||
      wrapper.querySelector(
        ".hdt-sticky-atc__submit:not(.hdt-sticky-atc__submit--notifyme)",
      );
    const tooltipWrapper = addToCartBtn
      ? addToCartBtn.closest("hdt-tooltip")
      : null;
    const quantityControls = wrapper.querySelector(
      ".hdt-card-product__quantity-controls",
    );
    const qtyDisplay = wrapper.querySelector(".hdt-quantity-control-qty");
    const minusBtn = wrapper.querySelector(".hdt-quantity-control-btn--minus");
    const plusBtn = wrapper.querySelector(".hdt-quantity-control-btn--plus");
    const form = wrapper.querySelector("form");
    const quantityInput = wrapper.querySelector('input[name="quantity"]');

    if (!quantityControls || !qtyDisplay || !minusBtn || !plusBtn) return;

    let currentQuantity = 1;
    let isUpdating = false;
    let updatingAction = null; // "plus" | "minus" | null
    let updatingVariantId = null; // variant the in-flight request belongs to

    function showQuantityControls(qty) {
      applyWrapperQtyUi(wrapper, qty);
      currentQuantity = parseInt(wrapper.dataset.currentQuantity, 10) || 1;
      updateButtonStates();
    }

    function hideQuantityControls() {
      applyWrapperQtyUi(wrapper, 0);
      currentQuantity = 1;
      updateButtonStates();
    }

    function updateButtonStates() {
      const maxQty = getMaxAddToCartQty(wrapper);
      const lockActive = updatingVariantId === getVariantId();
      const minusLocked = lockActive && updatingAction === "minus";
      const plusLocked = lockActive && updatingAction === "plus";
      minusBtn.disabled = currentQuantity <= 0 || minusLocked;
      minusBtn.classList.toggle("disabled", currentQuantity <= 0 || minusLocked);
      plusBtn.disabled = plusLocked || currentQuantity >= maxQty;
      plusBtn.classList.toggle("disabled", plusLocked || currentQuantity >= maxQty);
    }

    function checkCartAndUpdate(cart) {
      if (!cart || !cart.items || !Array.isArray(cart.items)) return;
      const variantId = getVariantId();
      if (!variantId) return;

      const cartQty = getCartItemQuantity(cart, variantId);
      if (cartQty > 0) {
        showQuantityControls(cartQty);
      } else {
        hideQuantityControls();
      }
    }

    function updateQuantity(newQuantity, action) {
      const variantId = getVariantId();
      if (!variantId) return;

      // Block duplicate clicks on the same control; allow the opposite control
      if (isUpdating && updatingAction === action && updatingVariantId === variantId) return;

      const maxQty = getMaxAddToCartQty(wrapper);
      if (newQuantity > maxQty) {
        newQuantity = maxQty;
      }

      const previousQty =
        parseInt(wrapper.dataset.currentQuantity, 10) ||
        getCartItemQuantity(cachedCart, variantId) ||
        0;

      isUpdating = true;
      updatingAction = action;
      updatingVariantId = variantId;
      wrapper.dataset.qtyUpdating = action;
      wrapper.dataset.qtyUpdatingVariant = variantId;
      updateButtonStates();

      // So only the latest response wins when multiple removals happen (avoids card=0 but View Cart=1)
      const mySeq = ++cartUpdateSequence;

      const cartLoaderScope =
        window.HdtCartLoader && typeof window.HdtCartLoader.getScope === "function"
          ? window.HdtCartLoader.getScope(wrapper)
          : document.getElementById("CartDrawer")?.hasAttribute("open")
            ? "cart-drawer"
            : document.getElementById("hdt-page-cart")
              ? "cart-page"
              : null;

      document.dispatchEvent(
        new CustomEvent("theme:loading:doing", {
          bubbles: true,
          detail: { scope: cartLoaderScope, fromElement: wrapper },
        }),
      );

      const sectionIds = collectCartSectionIds();

      // Use variant id directly — avoids a forced cart.js round-trip before change.js
      fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: newQuantity,
          sections: sectionIds.join(","),
        }),
      })
        .then((res) => {
          if (!res.ok) {
            return res.json().then((errBody) => {
              throw new Error(
                errBody?.description || errBody?.message || "Failed to update cart",
              );
            });
          }
          return res.json();
        })
        .then((cart) => {
          if (!cart || typeof cart !== "object") {
            throw new Error("Invalid cart response");
          }
          if (cart.status && cart.status !== 200) {
            throw new Error(cart.description || cart.message || "Cart update failed");
          }

          document.dispatchEvent(
            new CustomEvent("theme:loading:done", {
              bubbles: true,
              detail: { scope: cartLoaderScope, fromElement: wrapper },
            }),
          );

          // Only apply cart state globally if this response is still the latest (avoids stale overwrite)
          if (mySeq !== cartUpdateSequence) return;

          cachedCart = cart;
          const actualQty = getCartItemQuantity(cart, variantId);

          // Card variant switched while this request was in flight — paint the live variant, not this one
          if (getVariantId() !== String(variantId)) {
            applyWrapperQtyUi(wrapper, getCartItemQuantity(cart, getVariantId()));
          } else if (actualQty > 0) {
            showQuantityControls(actualQty);
          } else {
            hideQuantityControls();
          }

          // Sticky / card qty + — same addToCart analytics as ATC button
          if (action === "plus" && actualQty > previousQty) {
            const qtyAdded = actualQty - previousQty;
            const cartLine =
              cart.items &&
              cart.items.find(function (item) {
                return (
                  String(item.variant_id) === String(variantId) ||
                  String(item.id) === String(variantId)
                );
              });
            if (cartLine) {
              document.dispatchEvent(
                new CustomEvent("qty_control:add", {
                  bubbles: true,
                  detail: {
                    cart: cart,
                    items: [
                      Object.assign({}, cartLine, { quantity: qtyAdded }),
                    ],
                    contextEl: plusBtn,
                  },
                }),
              );
            }
            if (typeof Shopify.cartNotification === "function") {
              Shopify.cartNotification();
            }
          }

          if (cart.item_count !== undefined) {
            document.dispatchEvent(
              new CustomEvent("cart:change", {
                bubbles: true,
                detail: { baseEvent: "line-item:change", cart: cart },
              }),
            );
          }
        })
        .catch((err) => {
          console.error("Error updating quantity:", err);
          document.dispatchEvent(
            new CustomEvent("theme:loading:done", {
              bubbles: true,
              detail: { scope: cartLoaderScope, fromElement: wrapper },
            }),
          );
          if (mySeq !== cartUpdateSequence) return;
          getCart(true)
            .then(checkCartAndUpdate)
            .catch(() => {});
        })
        .finally(() => {
          // Don't clear lock if a newer request superseded this one
          if (mySeq !== cartUpdateSequence) return;
          isUpdating = false;
          updatingAction = null;
          updatingVariantId = null;
          delete wrapper.dataset.qtyUpdating;
          delete wrapper.dataset.qtyUpdatingVariant;
          updateButtonStates();
        });
    }

    // Event listeners for +/- buttons
    // Read current quantity from display to stay in sync with external updates
    minusBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isUpdating && updatingAction === "minus" && updatingVariantId === getVariantId()) return;

      // Read current quantity from display (handles sync from kwikcart)
      const displayedQty = parseInt(qtyDisplay.textContent, 10) || 1;
      if (displayedQty > 0) {
        currentQuantity = displayedQty; // Update local variable
        updateQuantity(currentQuantity - 1, "minus");
      }
    });

    plusBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (isUpdating && updatingAction === "plus" && updatingVariantId === getVariantId()) return;

      // Read current quantity from display (handles sync from kwikcart)
      const displayedQty = parseInt(qtyDisplay.textContent, 10) || 1;
      currentQuantity = displayedQty; // Update local variable

      if (currentQuantity >= getMaxAddToCartQty(wrapper)) {
        return;
      }

      updateQuantity(currentQuantity + 1, "plus");
    });

    // A sold-out size selected on the card (card variant selector) must never be added to cart.
    // Capture phase on the wrapper runs before the form's own submit handlers.
    wrapper.addEventListener(
      "submit",
      function (e) {
        if (wrapper.dataset.soldOut !== "true") return;
        e.preventDefault();
        e.stopPropagation();
      },
      true,
    );

    // Form submission validation - prevent adding more than max
    if (form) {
      form.addEventListener("submit", function (e) {
        const variantId = getVariantId();
        let qtyToAdd = 1;

        // Check if there's a visible quantity input
        if (quantityInput && quantityInput.type === "number") {
          qtyToAdd = parseInt(quantityInput.value, 10) || 1;
        }

        const maxQty = getMaxAddToCartQty(wrapper);
        // First check: validate input quantity immediately (synchronous)
        if (qtyToAdd > maxQty) {
          e.preventDefault();
          e.stopPropagation();
          alert("Maximum quantity allowed is " + maxQty);
          return false;
        }

        // Second check: validate total quantity including cart (using cached cart)
        if (
          variantId &&
          cachedCart &&
          cachedCart.items &&
          Array.isArray(cachedCart.items)
        ) {
          const currentCartQty = getCartItemQuantity(cachedCart, variantId);
          const totalQty = currentCartQty + qtyToAdd;

          if (totalQty > maxQty) {
            e.preventDefault();
            e.stopPropagation();
            alert(
              "Maximum quantity allowed is " +
                maxQty +
                ". You already have " +
                currentCartQty +
                " in your cart.",
            );
            return false;
          }
        }
      });
    }

    // Instant paint from SSR / sessionStorage — remove cart.js wait for UX
    paintWrapperFromLocalQty(wrapper);

    // Reconcile with live cart (cached, theme in-flight, or fetch)
    if (cartData) {
      checkCartAndUpdate(cartData);
    } else {
      getCart()
        .then(checkCartAndUpdate)
        .catch(() => {});
    }
  }

  // Initialize quantity control wrappers (optionally scoped to a lazyload slot)
  function initAllQuantityControls(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const wrappers = scope.querySelectorAll(".hdt-qty-controls-wrapper");
    if (wrappers.length === 0) return;

    // Wire + paint immediately (SSR / sessionStorage); reconcile cart in parallel
    wrappers.forEach((wrapper) => initQuantityControls(wrapper, cachedCart));
    if (!cachedCart) {
      getCart()
        .then((cart) => {
          wrappers.forEach((wrapper) => {
            if (!initializedWrappers.has(wrapper)) {
              initQuantityControls(wrapper, cart);
            } else {
              const variantId = wrapper.dataset.variantId;
              if (!variantId) return;
              applyWrapperQtyUi(wrapper, getCartItemQuantity(cart, variantId));
            }
          });
        })
        .catch(() => {});
    }
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllQuantityControls);
  } else {
    initAllQuantityControls();
  }

  // Re-initialize when lazy content is added - run immediately
  document.addEventListener("lazyhtml:added", initAllQuantityControls);
  document.addEventListener("products:update", initAllQuantityControls);
  document.addEventListener("lazyload:complete", initAllQuantityControls);
  document.addEventListener("lazyload:section-loaded", function (event) {
    if (event.detail && event.detail.slot) {
      initAllQuantityControls(event.detail.slot);
    }
  });

  // Watch for dynamically added content - initialize immediately with cached cart
  const qtyObserver = new MutationObserver(function (mutations) {
    const newWrappers = [];
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (
            node.classList &&
            node.classList.contains("hdt-qty-controls-wrapper")
          ) {
            newWrappers.push(node);
          }
          if (node.querySelectorAll) {
            const nested = node.querySelectorAll(".hdt-qty-controls-wrapper");
            nested.forEach((w) => newWrappers.push(w));
          }
        }
      });
    });

    if (newWrappers.length > 0) {
      // Instant paint; cart reconcile in background
      newWrappers.forEach((wrapper) =>
        initQuantityControls(wrapper, cachedCart),
      );
      if (!cachedCart) {
        getCart()
          .then((cart) => {
            newWrappers.forEach((wrapper) => {
              const variantId = wrapper.dataset.variantId;
              if (!variantId) return;
              applyWrapperQtyUi(wrapper, getCartItemQuantity(cart, variantId));
            });
          })
          .catch(() => {});
      }
    }
  });

  if (document.body) {
    qtyObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Listen for kwikcart quantity change events and sync product cards
  function syncCardQuantityFromKwikcart(variantId, newQuantity) {
    // Invalidate cart cache to force refresh
    cachedCart = null;
    cartFetchPromise = null;

    const wrappers = document.querySelectorAll(".hdt-qty-controls-wrapper");
    const numericVariantId = parseInt(variantId, 10);

    wrappers.forEach((wrapper) => {
      const wrapperVariantId = wrapper.dataset.variantId;
      if (!wrapperVariantId) return;

      const wrapperNumericId = parseInt(wrapperVariantId, 10);
      const matches =
        wrapperNumericId === numericVariantId ||
        String(wrapperVariantId) === String(variantId);

      if (!matches) return;

      const quantityControls = wrapper.querySelector(
        ".hdt-card-product__quantity-controls",
      );
      const qtyDisplay = wrapper.querySelector(".hdt-quantity-control-qty");
      const addToCartBtn = wrapper.querySelector(".hdt-add-to-cart-btn");
      const tooltipWrapper = addToCartBtn
        ? addToCartBtn.closest("hdt-tooltip")
        : null;
      const minusBtn = wrapper.querySelector(
        ".hdt-quantity-control-btn--minus",
      );
      const plusBtn = wrapper.querySelector(".hdt-quantity-control-btn--plus");

      if (!quantityControls || !qtyDisplay) return;

      const wrapperMax = getMaxAddToCartQty(wrapper);
      const displayQty = Math.min(newQuantity, wrapperMax);

      if (displayQty > 0) {
        // Show quantity controls
        if (tooltipWrapper) tooltipWrapper.style.display = "none";
        if (addToCartBtn) addToCartBtn.style.display = "none";
        quantityControls.style.display = "flex";
        qtyDisplay.textContent = displayQty;

        // Store quantity on wrapper for reference
        wrapper.dataset.currentQuantity = displayQty;

        // Update button states (preserve in-flight lock on the clicked control only)
        const updatingAction = wrapper.dataset.qtyUpdating;
        if (minusBtn) {
          minusBtn.disabled = displayQty <= 0 || updatingAction === "minus";
          minusBtn.classList.toggle(
            "disabled",
            displayQty <= 0 || updatingAction === "minus",
          );
        }
        if (plusBtn) {
          plusBtn.disabled = updatingAction === "plus" || displayQty >= wrapperMax;
          plusBtn.classList.toggle(
            "disabled",
            updatingAction === "plus" || displayQty >= wrapperMax,
          );
        }
      } else {
        // Hide quantity controls and show add to cart button
        if (tooltipWrapper) tooltipWrapper.style.display = "";
        if (addToCartBtn) addToCartBtn.style.display = "";
        quantityControls.style.display = "none";
        if (qtyDisplay) qtyDisplay.textContent = "1";
        wrapper.dataset.currentQuantity = "0";
      }
    });

    // Fetch actual cart and dispatch cart:change to update sticky cart and cart count
    getCart(true)
      .then((cart) => {
        if (cart && typeof cart === "object" && cart.item_count !== undefined) {
          document.dispatchEvent(
            new CustomEvent("cart:change", {
              bubbles: true,
              detail: { baseEvent: "kwikcart-sync", cart: cart },
            }),
          );
        }
      })
      .catch((err) => {
        console.error("Error fetching cart after kwikcart sync:", err);
      });
  }

  // Listen for kwikcart quantity increase event
  window.addEventListener("message", function (e) {
    if (e.data?.name === "quantity_increase_sc" && e.data?.body) {
      const { id: variantId, quantity } = e.data.body;
      if (variantId && quantity !== undefined) {
        syncCardQuantityFromKwikcart(variantId, quantity);
      }
    }
  });

  // Listen for kwikcart quantity reduce event
  window.addEventListener("message", function (e) {
    if (e.data?.name === "quantity_reduce_sc" && e.data?.body) {
      const { id: variantId, quantity } = e.data.body;
      if (variantId && quantity !== undefined) {
        syncCardQuantityFromKwikcart(variantId, quantity);
      }
    }
  });

  // Expose globally for manual initialization if needed
  window.initProductQuantityControls = initAllQuantityControls;
})();

// =====================================
// Product card variant selector (snippets/card-variant-selector.liquid)
// Swaps the variant inside the card; ATC / qty state stays with the quantity controller above,
// which is keyed by the wrapper's live data-variant-id.
// =====================================
(function () {
  if (typeof customElements === "undefined" || customElements.get("hdt-card-variant-selector")) return;

  /**
   * A/B gate for the card variant pills (same pattern as the other experiment flags, e.g.
   * show_contextual_offer_popup). The value is always a string and only "true" enables the feature — missing,
   * "false" or anything else keeps it off. Re-read on every check so a flag that lands after boot takes effect on
   * the next card render (lazyload section, infinite scroll, facets re-render).
   * card-variant-selector.css keeps the selector hidden unless <html> has CARD_VARIANTS_CLASS.
   */
  const CARD_VARIANTS_CLASS = "hdt-show-card-variants";

  function isCardVariantsEnabledByExperiment() {
    const flag = window.Shopify?.abExperimentData?.show_card_variants;
    return flag === "true";
  }

  function syncCardVariantsExperiment() {
    document.documentElement.classList.toggle(CARD_VARIANTS_CLASS, isCardVariantsEnabledByExperiment());
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncCardVariantsExperiment, { once: true });
  } else {
    syncCardVariantsExperiment();
  }

  // hdt-slider (Embla) blocks the click that ends a slider drag with a capture-phase listener on its container.
  // When that drag ends without a click (touch, or mouse released outside the slider) the block stays armed and
  // swallows the next real tap — which would be the first tap on a pill. Pills are therefore activated from a
  // document capture listener, which runs before Embla's. Only genuine taps (pointerdown on the same pill, little
  // movement) or keyboard presses count, so releasing a drag over a pill does not select it. The click is not
  // stopped here, so Embla still consumes its block.
  const PILL_SELECTOR = ".hdt-card-variant-pill";
  const TAP_MAX_MOVE_PX = 10;
  let pillTap = null;

  document.addEventListener(
    "pointerdown",
    (e) => {
      const pill = e.target.closest?.(PILL_SELECTOR);
      pillTap = pill ? { pill, x: e.clientX, y: e.clientY } : null;
    },
    true,
  );

  document.addEventListener(
    "click",
    (e) => {
      const pill = e.target.closest?.(PILL_SELECTOR);
      const selector = pill?.closest("hdt-card-variant-selector");
      if (!selector || typeof selector.onPillActivate !== "function") return;
      const isKeyboard = e.detail === 0; // Enter/Space on a <button>, or element.click()
      const isTap =
        pillTap !== null &&
        pillTap.pill === pill &&
        Math.hypot(e.clientX - pillTap.x, e.clientY - pillTap.y) < TAP_MAX_MOVE_PX;
      pillTap = null;
      selector.onPillActivate(pill, isTap || isKeyboard);
    },
    true,
  );

  class CardVariantSelector extends HTMLElement {
    connectedCallback() {
      // Re-check the A/B flag whenever cards render, so a flag set after boot applies to newly rendered cards
      syncCardVariantsExperiment();
      if (this._bound) return;
      this._bound = true;
      this.strip = this.querySelector(".hdt-card-variants");
      this.addEventListener("click", (e) => this.onClick(e));
      if (this.strip) {
        // Keep the carousel (hdt-slider) from dragging while the pill strip is scrolled
        ["pointerdown", "mousedown", "touchstart"].forEach((type) =>
          this.strip.addEventListener(type, (e) => e.stopPropagation(), { passive: true }),
        );
        this.bindDragScroll(this.strip);
      }
      const selected = this.querySelector(".hdt-card-variant-pill--selected");
      if (selected && selected.previousElementSibling) this.scrollPillIntoView(selected);
    }

    // A mouse needs drag-to-scroll everywhere. Touch scrolls natively, except inside hdt-slider, whose
    // container sets touch-action: pan-y — there the strip is pan-y too and horizontal touch drag is handled here.
    bindDragScroll(strip) {
      let startX = 0;
      let startScroll = 0;
      let pointerDown = false;
      const touchInSlider = Boolean(this.closest("hdt-slider"));

      strip.addEventListener("pointerdown", (e) => {
        if (e.button !== 0) return;
        if (e.pointerType !== "mouse" && !touchInSlider) return;
        if (strip.scrollWidth <= strip.clientWidth) return;
        pointerDown = true;
        this._dragMoved = false;
        startX = e.clientX;
        startScroll = strip.scrollLeft;
      });

      strip.addEventListener("pointermove", (e) => {
        if (!pointerDown) return;
        const dx = e.clientX - startX;
        if (!this._dragMoved) {
          if (Math.abs(dx) < 5) return; // small movement still counts as a click
          this._dragMoved = true;
          strip.classList.add("is-dragging");
          try {
            strip.setPointerCapture(e.pointerId);
          } catch (_) {}
        }
        strip.scrollLeft = startScroll - dx;
      });

      const endDrag = (e) => {
        if (!pointerDown) return;
        pointerDown = false;
        strip.classList.remove("is-dragging");
        try {
          strip.releasePointerCapture(e.pointerId);
        } catch (_) {}
      };
      strip.addEventListener("pointerup", endDrag);
      strip.addEventListener("pointercancel", endDrag);
    }

    get variants() {
      if (!this._variants) {
        try {
          const el = this.querySelector("script[data-variant-json]");
          this._variants = el ? JSON.parse(el.textContent) : [];
        } catch (_) {
          this._variants = [];
        }
      }
      return this._variants;
    }

    // Called from the document capture click listener above (before hdt-slider can swallow the click)
    onPillActivate(pill, isTapOrKeyboard) {
      // The click that ends a strip drag-scroll must not select a pill
      if (this._dragMoved) {
        this._dragMoved = false;
        return;
      }
      // Sold-out sizes are selectable (to view details); updateCard makes them non-purchasable
      if (!isTapOrKeyboard || pill.classList.contains("hdt-card-variant-pill--selected")) return;
      this.select(pill.dataset.productId);
    }

    // Selection happens in onPillActivate; this only keeps pill / strip clicks from reaching the card
    onClick(e) {
      if (this._dragMoved) {
        // Click retargeted to the strip after pointer capture ended a drag-scroll
        this._dragMoved = false;
      } else if (!e.target.closest(".hdt-card-variant-pill")) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
    }

    scrollPillIntoView(pill) {
      const strip = this.strip;
      if (!strip) return;
      // Scroll only the strip — scrollIntoView would also move the page / slider
      const s = strip.getBoundingClientRect();
      const p = pill.getBoundingClientRect();
      if (p.left < s.left) strip.scrollLeft += p.left - s.left;
      else if (p.right > s.right) strip.scrollLeft += p.right - s.right;
    }

    // Pills are linked sibling products (custom.variants metafield), each with a single variant
    select(productId) {
      const variant = this.variants.find((v) => String(v.productId) === String(productId));
      if (!variant) return;

      const allPills = [...this.querySelectorAll(".hdt-card-variant-pill")];
      const clickedPill = allPills.find((pill) => pill.dataset.productId === String(variant.productId));

      allPills.forEach((pill) => {
        const on = pill.dataset.productId === String(variant.productId);
        // Not `is-selected`: hdt-slider strips that class from elements inside slides
        pill.classList.toggle("hdt-card-variant-pill--selected", on);
        pill.setAttribute("aria-checked", on ? "true" : "false");
        if (on) this.scrollPillIntoView(pill);
      });

      const card = this.closest(".hdt-card-product");
      if (card) this.updateCard(card, variant);

      this.dispatchEvent(
        new CustomEvent("card:variant:change", {
          bubbles: true,
          detail: {
            cardProductId: this.dataset.productId,
            productId: variant.productId,
            variantId: variant.variantId,
            variant,
            label: clickedPill ? clickedPill.textContent.trim() : "",
          },
        }),
      );
    }

    // Rebuilds the price list with the same elements card-price.liquid renders (sale, compare-at, % off).
    // Texts arrive pre-formatted from Liquid, so currency formatting and the discount metafield math stay server-side.
    applyPrice(card, variant) {
      const list = card.querySelector("[data-card-price] .hdt-price__list");
      if (!list || !variant.price) return;
      if (!this._priceLabels) {
        this._priceLabels = {
          sale: list.querySelector("hdt-price .sr-only")?.textContent.trim() || "Sale price",
          regular: list.querySelector("hdt-compare-at-price .sr-only")?.textContent.trim() || "Regular price",
        };
      }
      // Children are joined with " " to match the whitespace Liquid leaves between these inline elements
      const make = (tag, className, children) => {
        const el = document.createElement(tag);
        el.className = className;
        children.forEach((child, i) => {
          if (i > 0) el.append(" ");
          el.append(child);
        });
        return el;
      };
      const srOnly = (text) => make("span", "sr-only sr-only--inline", [text]);
      const money = (text) => make("span", "hdt-card-money", [text]);

      const nodes = [make("hdt-price", "hdt-price", [srOnly(this._priceLabels.sale), money(variant.price)])];
      if (variant.compare) {
        nodes.push(
          make("hdt-compare-at-price", "hdt-compare-at-price", [srOnly(this._priceLabels.regular), money(variant.compare)]),
          make("hdt-discount", "hdt-discount", [make("span", "hdt-money-discount", [`${variant.discount}% OFF`])]),
        );
      }
      list.replaceChildren(...nodes.flatMap((node, i) => (i > 0 ? [" ", node] : [node])));
    }

    applyDesc(card, variant) {
      const wrap = card.querySelector(".small-description-subtitle");
      if (!wrap) return;
      let el = wrap.querySelector(".small-description");
      if (!el) {
        el = document.createElement("div");
        el.className = "small-description";
        wrap.append(el);
      }
      el.textContent = variant.desc || "";
      el.style.display = variant.desc ? "" : "none";
    }

    // Fills the data-rating-* hooks in star-ratings.liquid markup. If the card's own product had no rating,
    // the snippet emits one <template data-rating-template> to clone.
    applyRating(card, variant) {
      const row = card.querySelector("[data-card-rating]");
      if (!row) return;
      const rating = Number(variant.rating) || 0;
      const hasRating = rating > 0;
      const blockSelector = ".star-rating, .product-star-rating";

      let block = row.querySelector(blockSelector);
      if (!block && hasRating) {
        const tpl = this.querySelector("template[data-rating-template]");
        if (tpl) {
          row.append(tpl.content.cloneNode(true));
          block = row.querySelector(blockSelector);
        }
      }
      if (row.classList.contains("new-hp-design__rating-row")) {
        row.classList.toggle("new-hp-design__rating-row--placeholder", !hasRating);
      }
      if (!block) return;
      block.style.display = hasRating ? "" : "none";
      if (!hasRating) return;

      const value = rating.toFixed(1);
      const count = parseInt(variant.ratingCount, 10) || 0;
      const setText = (selector, text) => {
        block.querySelectorAll(selector).forEach((el) => {
          el.textContent = text;
        });
      };
      setText("[data-rating-value]", value);
      setText("[data-rating-count]", String(count));
      setText("[data-rating-a11y-count]", String(count));
      setText("[data-rating-word]", count < 2 ? " Review" : " Reviews");
      const ratingImg = block.querySelector('.rating[role="img"]');
      if (ratingImg) {
        ratingImg.setAttribute("aria-label", (ratingImg.getAttribute("aria-label") || "").replace(/^[\d.]+/, value));
      }
    }

    // The sold-out look follows the selected size: the theme's .hdt-pr-sold_out card class (image overlay, centred
    // badge; theme.css) plus the Sold out badge. Liquid only renders that badge when the card's own product is sold
    // out, so it is created here when needed (and only if the theme's sold-out badge setting is on).
    applySoldOutState(card, variant) {
      const soldOut = !variant.available;
      card.classList.toggle("hdt-pr-sold_out", soldOut);

      const wrapp = card.querySelector(".hdt-badge__wrapp");
      if (!wrapp) return;
      let badge = wrapp.querySelector(".hdt-badge__sold_out");
      if (!badge && soldOut && this.dataset.soldoutBadge === "true") {
        badge = document.createElement("span");
        badge.className = "hdt-badge hdt-badge__sold_out";
        const label = document.createElement("span");
        label.textContent = window.themeHDN?.extras?.soldOut || "Sold out";
        badge.append(label);
        wrapp.append(badge);
      }
      if (badge) badge.style.display = soldOut ? "" : "none";
    }

    // One CDN URL is sent per size; the Shopify CDN resizes via ?width=
    buildSrcset(src) {
      try {
        return [360, 533, 720, 940, 1066]
          .map((w) => {
            const url = new URL(src, window.location.href);
            url.searchParams.set("width", String(w));
            return `${url.href} ${w}w`;
          })
          .join(", ");
      } catch (_) {
        return "";
      }
    }

    updateCard(card, variant) {
      this.applyPrice(card, variant);

      if (variant.title) {
        card.querySelectorAll(".hdt-card-product__title").forEach((el) => {
          el.textContent = variant.title;
        });
      }

      this.applyDesc(card, variant);
      this.applyRating(card, variant);
      this.applySoldOutState(card, variant);

      const net = card.querySelector("[data-card-net-content]");
      if (net) {
        const raw = variant.netContent || "";
        const text = net.dataset.cardNetContent === "split" ? raw.split("(")[0] : raw;
        net.textContent = text;
        const volume = net.closest(".new-hp-design__volume");
        if (volume) volume.classList.toggle("new-hp-design__volume--placeholder", !text);
      }

      if (variant.url) {
        card.querySelectorAll("a[data-pr-url]").forEach((a) => {
          a.href = variant.url;
        });
      }

      const img = card.querySelector(".hdt-card-product__media--main");
      if (img) {
        if (!this._originalImage) {
          this._originalImage = { src: img.getAttribute("src"), srcset: img.getAttribute("srcset") };
        }
        // Back on the card's own product (or no image): restore the SSR image instead of loading a resized copy
        const useOriginal = !variant.image || String(variant.productId) === this.dataset.productId;
        const src = useOriginal ? this._originalImage.src : variant.image;
        const srcset = useOriginal ? this._originalImage.srcset : this.buildSrcset(variant.image);
        if (src && img.getAttribute("src") !== src) {
          if (srcset) img.setAttribute("srcset", srcset);
          else img.removeAttribute("srcset");
          img.setAttribute("src", src);
        }
        const hover = card.querySelector(".hdt-card-product__media--hover");
        if (hover) hover.style.display = useOriginal ? "" : "none";
      }

      const wrapper = card.querySelector(".hdt-qty-controls-wrapper");
      if (!wrapper) return;

      wrapper.dataset.variantId = String(variant.variantId);
      wrapper.dataset.productId = String(variant.productId);
      // Sold-out size: syncQtyControlsWrapper shows View product (href follows the size via data-pr-url above)
      // and submit is blocked
      wrapper.dataset.soldOut = variant.available ? "false" : "true";
      const atcMax = parseInt(variant.atcMax, 10);
      if (atcMax > 0) wrapper.setAttribute("data-atc-max", String(atcMax));

      const idInput = wrapper.querySelector('input[name="id"]');
      if (idInput) idInput.value = variant.variantId;
      const productIdInput = wrapper.querySelector('input[name="product-id"]');
      if (productIdInput) productIdInput.value = variant.productId;

      const qtyInput = wrapper.querySelector('input[name="quantity"][type="number"]');
      if (qtyInput && atcMax > 0) qtyInput.max = String(atcMax);

      const atcBtn = wrapper.querySelector(".hdt-add-to-cart-btn");
      if (atcBtn) {
        atcBtn.setAttribute("cardselectedvarid", variant.variantId);
        atcBtn.setAttribute("cardselectedprodid", variant.productId);
        atcBtn.setAttribute("cardselectedprodname", variant.title || "");
        atcBtn.setAttribute("cardselectsku", variant.sku || "");
        atcBtn.setAttribute("cardselectedvarprice", variant.atcPrice);
      }

      // ATC vs qty stepper for the newly selected variant, from the shared cart state
      if (typeof window.syncQtyControlsWrapper === "function") {
        window.syncQtyControlsWrapper(wrapper);
      }
    }
  }

  customElements.define("hdt-card-variant-selector", CardVariantSelector);
})();

// Categories scrollspy (hdt-categories-scrollspy)
(function () {
  if (typeof customElements === "undefined" || customElements.get("hdt-categories-scrollspy")) return;
  function qTargets(handle) {
    if (!handle) return null;
    return document.querySelector(
      '[data-hdt-scrollspy-target="' +
        handle.replace(/\\/g, "\\\\").replace(/"/g, '\\"') +
        '"]',
    );
  }
  class HdtCategoriesScrollspy extends HTMLElement {
    connectedCallback() {
      ((this._onScroll = this._onScroll.bind(this)),
        (this._onClick = this._onClick.bind(this)),
        (this._raf = 0),
        (this._tabsResizeObs = null),
        (this._tabsMo = null),
        (this._activeHandle = null),
        (this._stickyFixed = !1),
        this._initDynamicOffset(),
        this.addEventListener("click", this._onClick),
        window.addEventListener("scroll", this._onScroll, { passive: !0 }),
        window.addEventListener("resize", this._onScroll, { passive: !0 }),
        this._bindTabsObservers(),
        this._syncStickyTopAndCompact(),
        this._syncFixedNav(),
        this._scheduleSync());
    }
    disconnectedCallback() {
      (window.removeEventListener("scroll", this._onScroll),
        window.removeEventListener("resize", this._onScroll),
        this.removeEventListener("click", this._onClick),
        this._raf && cancelAnimationFrame(this._raf),
        this._tabsResizeObs &&
          (this._tabsResizeObs.disconnect(), (this._tabsResizeObs = null)),
        this._tabsMo && (this._tabsMo.disconnect(), (this._tabsMo = null)));
    }
    _initDynamicOffset() {
      var t = parseInt(this.getAttribute("data-scroll-offset") || "0", 10);
      this._dynamicOffset = isNaN(t) ? 0 : t;
    }
    _fallbackStickyTopPx() {
      var t = parseInt(this.getAttribute("data-sticky-top-fallback") || "", 10);
      if (!isNaN(t) && t > 0) return t;
      var e = parseInt(this.getAttribute("data-scroll-offset") || "", 10);
      return !isNaN(e) && e > 0 ? e : 104;
    }
    _bindTabsObservers() {
      var t = this,
        e = document.querySelector(".hdt-tabs-head-v2");
      if (!e || typeof ResizeObserver === "undefined") return;
      ((this._tabsResizeObs = new ResizeObserver(function () {
        t._scheduleSync();
      })),
        this._tabsResizeObs.observe(e),
        typeof MutationObserver < "u" &&
          ((this._tabsMo = new MutationObserver(function () {
            t._scheduleSync();
          })),
          this._tabsMo.observe(e, {
            attributes: !0,
            attributeFilter: ["class"],
          })));
    }
    _syncStickyTopAndCompact() {
      var t = this.closest(".shopify-section"),
        e = this.querySelector(".hdt-categories-scrollspy__sticky");
      if (!t || !e) return;
      var i = document.querySelector(".hdt-tabs-head-v2"),
        n = this._fallbackStickyTopPx();
      if (i && i.classList.contains("sticky")) {
        var s = Math.round(i.getBoundingClientRect().height);
        (e.style.setProperty("--categories-scrollspy-sticky-top", s + "px"),
          t.classList.add("categories-scrollspy--compact-tabs"),
          (this._dynamicOffset = s));
      } else
        (e.style.setProperty("--categories-scrollspy-sticky-top", n + "px"),
          t.classList.remove("categories-scrollspy--compact-tabs"),
          (this._dynamicOffset = n));
      this._refreshSpacerIfFixed();
    }
    _refreshSpacerIfFixed() {
      if (!this._stickyFixed) return;
      var t = this.querySelector(".hdt-categories-scrollspy__sticky"),
        e = this.querySelector(".hdt-categories-scrollspy__spacer");
      t && e && (e.style.height = t.offsetHeight + "px");
    }
    _syncFixedNav() {
      // Sticky pin/unpin is temporarily disabled.
      // Keep this function as a no-op so callers remain unchanged.
      return;
    }
    _navButtons() {
      return Array.prototype.slice.call(
        this.querySelectorAll("[data-scrollspy-nav][data-collection-handle]"),
      );
    }
    _offset() {
      if (
        typeof this._dynamicOffset == "number" &&
        !isNaN(this._dynamicOffset)
      )
        return this._dynamicOffset;
      var t = parseInt(this.getAttribute("data-scroll-offset") || "0", 10);
      return isNaN(t) ? 0 : t;
    }
    _scrollOffset() {
      var t = this.querySelector(".hdt-categories-scrollspy__sticky"),
        e = t ? Math.round(t.getBoundingClientRect().height) : 0;
      var buffer = window.innerWidth < 768 ? 4 : 40;
      return this._offset() + e + buffer;
    }
    _scheduleSync() {
      var t = this;
      t._raf ||
        (t._raf = requestAnimationFrame(function () {
          ((t._raf = 0),
            t._syncStickyTopAndCompact(),
            t._syncFixedNav(),
            t._syncActive());
        }));
    }
    _onScroll() {
      this._scheduleSync();
    }
    _onClick(t) {
      var e = t.target.closest("[data-scrollspy-nav]");
      if (!e || !this.contains(e)) return;
      t.preventDefault();
      var i = e.getAttribute("data-collection-handle");
      if (!i) return;
      var n = qTargets(i);
      if (!n) return;
    
      // Set active first so compact mode triggers
      this._setActive(i);
    
      // Wait one frame for DOM/CSS to update, then measure and scroll
      var self = this;
      requestAnimationFrame(function() {
        var section = self.closest(".shopify-section");
        var tabsHead = document.querySelector(".hdt-tabs-head-v2");
        var wasExpanded = section && !section.classList.contains("categories-scrollspy--compact-tabs");
        
        // Temporarily simulate the compact state to accurately measure the future target position
        if (wasExpanded) {
          section.classList.add("categories-scrollspy--compact-tabs");
          if (tabsHead) tabsHead.classList.add("sticky");
          self._syncStickyTopAndCompact();
        }
        var s = n.getBoundingClientRect().top + window.scrollY - self._scrollOffset();
        console.log('scroll s-----', s, n.getBoundingClientRect().top, window.scrollY, self._scrollOffset());
        
        // Revert immediately to avoid visual flicker
        if (wasExpanded) {
          section.classList.remove("categories-scrollspy--compact-tabs");
          if (tabsHead) tabsHead.classList.remove("sticky");
          self._syncStickyTopAndCompact();
        }
        window.scrollTo({ top: Math.max(0, s), behavior: "smooth" });
      });
    }
    _scrollActiveTabIntoView(t) {
      var e = this._navButtons().find(function (i) {
        return i.getAttribute("data-collection-handle") === t;
      });
      if (!e) return;
      var i = e.closest(".hdt-slider__slide") || e,
        n =
          e.closest(".hdt-slider__container") ||
          e.closest(".hdt-slider__viewport");
      if (!n || typeof n.scrollTo !== "function") {
        i.scrollIntoView &&
          i.scrollIntoView({
            behavior: "smooth",
            block: "nearest",
            inline: "center",
          });
        return;
      }
      var s = i.getBoundingClientRect(),
        o = n.getBoundingClientRect(),
        r = 16;
      if (s.left >= o.left + r && s.right <= o.right - r) return;
      var a =
          n.scrollLeft + s.left - o.left - (n.clientWidth - s.width) / 2,
        l = Math.max(0, Math.min(a, n.scrollWidth - n.clientWidth));
      n.scrollTo({ left: l, behavior: "smooth" });
    }
    _setActive(t) {
      var n = this._activeHandle !== t;
      this._activeHandle = t;
      this.querySelectorAll("[data-scrollspy-nav]").forEach(function (e) {
        var i = e.getAttribute("data-collection-handle") === t;
        (e.classList.toggle("is-active", i),
          e.setAttribute("aria-current", i ? "true" : "false"));
      });
      n && this._scrollActiveTabIntoView(t);
    }
    _syncActive() {
      var t = this._navButtons();
      if (!t.length) return;
      var e = {},
        i = [],
        n = {};
      if (
        (t.forEach(function (s) {
          var o = s.getAttribute("data-collection-handle");
          o && (e[o] = !0);
        }),
        document.querySelectorAll("[data-hdt-scrollspy-target]").forEach(
          function (s) {
            var o = s.getAttribute("data-hdt-scrollspy-target");
            !o || !e[o] || n[o] || ((n[o] = !0), i.push(s));
          },
        ),
        !i.length)
      )
        return;
      var s,
        o = this._scrollOffset() + 12,
        r = null;
      for (s = i.length - 1; s >= 0; s--)
        if (i[s].getBoundingClientRect().top <= o) {
          r = i[s].getAttribute("data-hdt-scrollspy-target");
          break;
        }
      (r ||
        (i[0].getBoundingClientRect().top > o
          ? (r = i[0].getAttribute("data-hdt-scrollspy-target"))
          : (r = i[i.length - 1].getAttribute("data-hdt-scrollspy-target"))),
        r && this._setActive(r));
    }
  }
  customElements.define("hdt-categories-scrollspy", HdtCategoriesScrollspy);
  if (typeof MutationObserver < "u") {
    var t = document.getElementById("MainContent");
    if (t && !t.__hdtCategoriesScrollspyMO) {
      var e = 0;
      ((t.__hdtCategoriesScrollspyMO = new MutationObserver(function () {
        (e && cancelAnimationFrame(e),
          (e = requestAnimationFrame(function () {
            ((e = 0),
              document
                .querySelectorAll("hdt-categories-scrollspy")
                .forEach(function (i) {
                  i._scheduleSync && i._scheduleSync();
                }));
          })));
      })),
        t.__hdtCategoriesScrollspyMO.observe(t, {
          childList: !0,
          subtree: !0,
        }));
    }
  }
  document.addEventListener("tabcontent:loaded", function () {
    document.querySelectorAll("hdt-categories-scrollspy").forEach(function (t) {
      t._scheduleSync && t._scheduleSync();
    });
  });
})();

// Template / header template carousels: fetch tab page HTML into panels.
// Lives in custom.js (not section <script>) so it still runs for content injected via innerHTML —
// browsers do not execute <script> tags inserted through innerHTML, so nested templates-carousel
// on e.g. /pages/concern would never wire clicks if this stayed only in the section file.
(function () {
  if (typeof fetch === "undefined" || !window.Shopify || !window.Shopify.routes) return;

  function syncHeaderTemplateBackground(button) {
    if (!button || !button.closest) return;
    var sectionRoot = button.closest(".hdt-section");
    if (!sectionRoot) return;
    var bgWrap = sectionRoot.querySelector(
      '.hdt-tabs-head-background[data-use-active-tab-bg="true"]',
    );
    if (!bgWrap) return;
    var normalImg = bgWrap.querySelector(".tabs_bg_image");
    var stickyImg = bgWrap.querySelector(".tabs_bg_image_onscroll");
    var nextNormal = button.getAttribute("data-tabs-bg-img");
    var nextSticky = button.getAttribute("data-tabs-bg-img-onscroll");

    if (normalImg && nextNormal) normalImg.src = nextNormal;
    if (stickyImg && nextSticky) stickyImg.src = nextSticky;
  }

  function createTabShimmerHtml() {
    var html = '<div class="tab-shimmer-wrapper hdt-container" style="padding-top: 24px;">';
    for (var i = 0; i < 6; i++) {
      html +=
        '<div class="tab-shimmer-card"><div class="tab-shimmer-image"></div><div class="tab-shimmer-line" style="width:80%"></div><div class="tab-shimmer-line" style="width:60%"></div></div>';
    }
    return html + "</div>";
  }

  function hydrateFirstTemplateTabInRoot(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll("hdt-tab").forEach(function (tab) {
      var btn = tab.querySelector(
        'button.hdt-tabs-item-title[aria-current="true"]',
      );
      if (!btn || !btn.getAttribute("data-get")) return;
      var tid = btn.getAttribute("data-id");
      var el = tid ? document.getElementById(tid) : null;
      if (el && el.dataset.loaded !== "true") {
        loadTabTemplateContent(btn);
      }
    });
  }

  function loadTabTemplateContent(button) {
    var targetId = button.getAttribute("data-id");
    var pageUrl = button.getAttribute("data-get");
    if (!targetId || !pageUrl) return;
    var target = document.getElementById(targetId);
    if (!target) return;
    if (target.dataset.loaded === "true") return;

    target.innerHTML = createTabShimmerHtml();

    fetch(window.Shopify.routes.root + pageUrl.replace(/^\/+/, ""))
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        var pageContent = tempDiv.querySelector("#MainContent") || tempDiv;
        window.setTimeout(function () {
          target.innerHTML = pageContent.innerHTML;
          target.dataset.loaded = "true";
          target.classList.add("fade-in");
          if (typeof window.initProductQuantityControls === "function") {
            window.initProductQuantityControls();
          }
          document.dispatchEvent(
            new CustomEvent("tabcontent:loaded", { bubbles: true }),
          );
          hydrateFirstTemplateTabInRoot(target);
        }, 50);
      })
      .catch(function (err) {
        console.error("Error loading tab content:", err);
        target.innerHTML = "<p>Failed to load content.</p>";
      });
  }

  window.hdtLoadTabTemplateContent = loadTabTemplateContent;

  document.addEventListener("click", function (e) {
    var btn =
      e.target.closest &&
      e.target.closest("button.hdt-tabs-item-title[data-get]");
    if (!btn) return;
    syncHeaderTemplateBackground(btn);
    loadTabTemplateContent(btn);
  });

  function initFirstTemplateTabsOnPage() {
    document.querySelectorAll("hdt-tab").forEach(function (tab) {
      var btn = tab.querySelector(
        'button.hdt-tabs-item-title[aria-current="true"]',
      );
      if (!btn || !btn.getAttribute("data-get")) return;
      var tid = btn.getAttribute("data-id");
      var el = tid ? document.getElementById(tid) : null;
      if (el && el.dataset.loaded !== "true") {
        loadTabTemplateContent(btn);
      }
      syncHeaderTemplateBackground(btn);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFirstTemplateTabsOnPage);
  } else {
    initFirstTemplateTabsOnPage();
  }
})();

/** AI chat widget — markup from snippets/Ai-widget.liquid when show_chat_bot */
function initChatbotAiWidget() {
      var SCROLL_THRESHOLD = 0;
      var COPY_REVEAL_DELAY_MS = 2800;
      var MESSAGE_DURATION_MS = 7000;

      var floater = document.getElementById('chatbot-floater');
      var bubble = document.getElementById('chatbot-greeting-bubble');
      var trigger = document.getElementById('chatbot-floater-trigger');
      var bubbleClose = document.getElementById('chatbot-close-bubble');
      var sharedRoot = document.getElementById('chatbot-shared-root');
      var callRoot = document.getElementById('chatbot-call-modal-root');
      var callForm = document.getElementById('chatbot-call-form');
      var callPanelForm = document.getElementById('chatbot-call-panel-form');
      var callPanelSuccess = document.getElementById('chatbot-call-panel-success');
      var callModalDialog = document.getElementById('chatbot-call-modal-dialog');
      var nameInput = document.getElementById('chatbot-call-name');
      var phoneInput = document.getElementById('chatbot-call-phone');
      var nameError = document.getElementById('chatbot-call-name-error');
      var phoneError = document.getElementById('chatbot-call-phone-error');
      var formError = document.getElementById('chatbot-call-form-error');
      var submitBtn = document.getElementById('chatbot-call-submit');
      var callSubmittingOverlay = document.getElementById('chatbot-call-submitting-overlay');
      var callFailureBanner = document.getElementById('chatbot-call-failure-banner');
      var callModalTitle = document.getElementById('chatbot-call-modal-title');

      if (!floater || !bubble || !sharedRoot || !callRoot || !callForm || !callPanelForm || !callPanelSuccess || !callModalDialog || !nameInput || !phoneInput) return;

      var CHATBOT_QUEUE_CALL_URL =
        'https://tdc-custom-api.honasa-dev.net/v1/ivr/queue-call';

      var hasBeenVisible = false;
      var bubbleInitialized = false;
      var chatbotPhoneAddedTracked = false;
      var chatbotNameAddedTracked = false;

      function trackChatbotEvent(eventName, extra) {
        window.dataLayer = window.dataLayer || [];
        var payload = Object.assign(
          {
            event: eventName,
            url: window.location.href
          },
          extra || {}
        );
        window.dataLayer.push(payload);
        if (window.Moengage && typeof window.Moengage.track_event === 'function') {
          window.Moengage.track_event(eventName, Object.assign({ url: window.location.href }, extra || {}));
        }
      }

      function chatbotSubmitCallEventName(name) {
        var n = (name || '').trim();
        if (!n) return 'submit_call';
        return n.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '') + '_call';
      }

      function resetChatbotCallFieldTracking() {
        chatbotPhoneAddedTracked = false;
        chatbotNameAddedTracked = false;
      }

      function readCallPrefillConfig() {
        var el = document.getElementById('chatbot-call-prefill-config');
        if (!el || !el.textContent) {
          return { prefillName: '', prefillPhoneRaw: '' };
        }
        try {
          var o = JSON.parse(el.textContent);
          return {
            prefillName: (o && o.prefillName) || '',
            prefillPhoneRaw: (o && o.prefillPhoneRaw) || ''
          };
        } catch (e) {
          return { prefillName: '', prefillPhoneRaw: '' };
        }
      }

      function formatQueueCallErrorMessage(data, status) {
        var d = data || {};
        if (status === 500 && d.error === 'failed_to_queue') {
          return 'We could not queue your call right now. Please try again in a moment.';
        }
        if (Array.isArray(d.errors) && d.errors.length) {
          var parts = d.errors.map(function (e) {
            if (typeof e === 'string') return e;
            if (e && typeof e.message === 'string') return e.message;
            if (e && typeof e.msg === 'string') return e.msg;
            try {
              return JSON.stringify(e);
            } catch (err) {
              return '';
            }
          });
          var joined = parts.filter(Boolean).join(' ');
          if (joined) return joined;
        }
        if (typeof d.error === 'string' && d.error) return d.error;
        if (typeof d.message === 'string' && d.message) return d.message;
        if (status === 400) {
          return 'Please check your name and phone number and try again.';
        }
        if (status === 500) {
          return 'Something went wrong on our side. Please try again.';
        }
        return 'Something went wrong. Please try again.';
      }

      function refreshBodyScrollLock() {
        var open =
          sharedRoot.classList.contains('is-open') ||
          callRoot.classList.contains('is-open');
        document.body.classList.toggle('chatbot-modal-open', open);
      }

      function isSharedOpen() {
        return sharedRoot.classList.contains('is-open');
      }

      function isCallOpen() {
        return callRoot.classList.contains('is-open');
      }

      function openShared() {
        sharedRoot.classList.add('is-open');
        sharedRoot.setAttribute('aria-hidden', 'false');
        refreshBodyScrollLock();
        window.requestAnimationFrame(function() {
          var closeBtn = document.getElementById('chatbot-shared-close');
          if (closeBtn) closeBtn.focus();
        });
      }

      function closeShared() {
        if (!isSharedOpen()) return;
        sharedRoot.classList.remove('is-open');
        sharedRoot.setAttribute('aria-hidden', 'true');
        refreshBodyScrollLock();
        if (!isCallOpen()) {
          var toolbarTrigger = document.querySelector('[data-chatbot-toolbar-trigger]');
          if (toolbarTrigger) toolbarTrigger.focus();
          else if (trigger) trigger.focus();
        }
      }

      function toggleShared() {
        if (isSharedOpen()) {
          closeShared();
        } else {
          openShared();
        }
      }

      function digitsOnly(str) {
        return String(str || '').replace(/\D/g, '');
      }

      function extractIndia10Digits(raw) {
        var d = digitsOnly(raw);
        if (!d) return '';
        if (d.length >= 12 && d.slice(0, 2) === '91') return d.slice(-10);
        if (d.length === 11 && d.charAt(0) === '0') return d.slice(1);
        if (d.length > 10) return d.slice(-10);
        return d;
      }

      function clearFieldErrors() {
        nameError.textContent = '';
        nameError.hidden = true;
        phoneError.textContent = '';
        phoneError.hidden = true;
        formError.textContent = '';
        formError.hidden = true;
        formError.classList.remove('chatbot-call-modal__error--success');
      }

      function showFieldError(el, message) {
        el.textContent = message;
        el.hidden = false;
      }

      function validateName() {
        var v = (nameInput.value || '').trim();
        if (!v) {
          showFieldError(nameError, 'Please enter your full name.');
          return null;
        }
        if (v.length < 2) {
          showFieldError(nameError, 'Please enter a valid name.');
          return null;
        }
        return v;
      }

      function validatePhone() {
        var d = digitsOnly(phoneInput.value);
        if (!d) {
          showFieldError(phoneError, 'Please enter your mobile number.');
          return null;
        }
        if (d.length !== 10) {
          showFieldError(phoneError, 'Enter a valid 10-digit mobile number.');
          return null;
        }
        if (!/^[6-9]/.test(d)) {
          showFieldError(phoneError, 'Enter a valid Indian mobile number.');
          return null;
        }
        return d;
      }

      function showCallSubmittingPopup() {
        if (callRoot) callRoot.classList.add('is-queue-submitting');
        if (!callSubmittingOverlay) return;
        callSubmittingOverlay.removeAttribute('hidden');
        callSubmittingOverlay.setAttribute('aria-hidden', 'false');
        callSubmittingOverlay.classList.add('is-open');
      }

      function hideCallSubmittingPopup() {
        if (callRoot) callRoot.classList.remove('is-queue-submitting');
        if (!callSubmittingOverlay) return;
        callSubmittingOverlay.classList.remove('is-open');
        callSubmittingOverlay.setAttribute('aria-hidden', 'true');
        callSubmittingOverlay.setAttribute('hidden', '');
      }

      function resetCallFormErrorState() {
        callModalDialog.classList.remove('is-submit-failed');
        callPanelForm.classList.remove('is-submit-failed');
        if (callFailureBanner) {
          callFailureBanner.hidden = true;
        }
        if (callModalTitle) {
          callModalTitle.textContent =
            callModalTitle.getAttribute('data-chatbot-title-default') || 'Get a call';
        }
        if (submitBtn) {
          submitBtn.textContent =
            submitBtn.getAttribute('data-chatbot-submit-default') || 'Submit';
        }
        if (formError) {
          formError.hidden = true;
          formError.textContent = '';
        }
      }

      function showCallFormErrorState() {
        callModalDialog.classList.add('is-submit-failed');
        callPanelForm.classList.add('is-submit-failed');
        if (callFailureBanner) {
          callFailureBanner.hidden = false;
        }
        if (callModalTitle) {
          callModalTitle.textContent =
            callModalTitle.getAttribute('data-chatbot-title-retry') || 'Retry call request';
        }
        if (submitBtn) {
          submitBtn.textContent =
            submitBtn.getAttribute('data-chatbot-submit-retry') || 'Try Again';
        }
        if (formError) {
          formError.hidden = true;
          formError.textContent = '';
        }
      }

      function resetCallModalStep() {
        hideCallSubmittingPopup();
        resetCallFormErrorState();
        callPanelForm.removeAttribute('hidden');
        callPanelSuccess.setAttribute('hidden', '');
        callModalDialog.setAttribute('aria-labelledby', 'chatbot-call-modal-title');
      }

      function showCallModalSuccess() {
        resetCallFormErrorState();
        callPanelForm.setAttribute('hidden', '');
        callPanelSuccess.removeAttribute('hidden');
        callModalDialog.setAttribute('aria-labelledby', 'chatbot-call-success-title');
      }

      function openCallModal() {
        var cfg = readCallPrefillConfig();
        resetChatbotCallFieldTracking();
        resetCallModalStep();
        clearFieldErrors();
        nameInput.value = cfg.prefillName || '';
        phoneInput.value = extractIndia10Digits(cfg.prefillPhoneRaw) || '';
        callRoot.classList.add('is-open');
        callRoot.setAttribute('aria-hidden', 'false');
        refreshBodyScrollLock();
        window.requestAnimationFrame(function() {
          var closeBtn = document.getElementById('chatbot-call-modal-close');
          if (closeBtn) closeBtn.focus();
        });
      }

      function closeCallModal() {
        if (!isCallOpen()) return;
        resetChatbotCallFieldTracking();
        resetCallModalStep();
        clearFieldErrors();
        callRoot.classList.remove('is-open');
        callRoot.setAttribute('aria-hidden', 'true');
        submitBtn.disabled = false;
        refreshBodyScrollLock();
        if (trigger) trigger.focus();
      }

      function onGlobalEscape(ev) {
        if (ev.key !== 'Escape') return;
        if (isCallOpen()) {
          ev.preventDefault();
          closeCallModal();
          return;
        }
        if (isSharedOpen()) {
          ev.preventDefault();
          closeShared();
        }
      }

      document.addEventListener('keydown', onGlobalEscape);

      sharedRoot.addEventListener('click', function(ev) {
        if (ev.target.closest('[data-chatbot-shared-close]')) {
          closeShared();
          return;
        }
        var opt = ev.target.closest('[data-chatbot-action]');
        if (!opt || !sharedRoot.contains(opt)) return;
        var action = opt.getAttribute('data-chatbot-action');
        if (action === 'chat') {
          ev.preventDefault();
          ev.stopPropagation();
          closeShared();
          openChatwootChat();
          return;
        }
        if (action === 'call') {
          ev.preventDefault();
          trackChatbotEvent('Call click');
          closeShared();
          openCallModal();
        }
      });

      callRoot.addEventListener('click', function(ev) {
        if (ev.target.closest('#chatbot-call-success-dismiss')) {
          closeCallModal();
          return;
        }
        if (ev.target.closest('[data-chatbot-call-close]')) {
          closeCallModal();
        }
      });

      nameInput.addEventListener('input', function() {
        if (nameError && !nameError.hidden) {
          nameError.hidden = true;
          nameError.textContent = '';
        }
        if (!chatbotNameAddedTracked && (nameInput.value || '').trim().length > 0) {
          chatbotNameAddedTracked = true;
          trackChatbotEvent('name_Added');
        }
      });

      phoneInput.addEventListener('input', function() {
        var d = digitsOnly(phoneInput.value).slice(0, 10);
        phoneInput.value = d;
        if (phoneError && !phoneError.hidden) {
          phoneError.hidden = true;
          phoneError.textContent = '';
        }
        if (!chatbotPhoneAddedTracked && d.length > 0) {
          chatbotPhoneAddedTracked = true;
          trackChatbotEvent('Phone_number added');
        }
      });

      callForm.addEventListener('submit', function(ev) {
        ev.preventDefault();
        clearFieldErrors();
        trackChatbotEvent(chatbotSubmitCallEventName(nameInput.value));
        var nameVal = validateName();
        var ten = validatePhone();
        if (!nameVal || !ten) return;

        var payload = {
          phone: '+91' + ten,
          name: nameVal
        };

        submitBtn.disabled = true;
        showCallSubmittingPopup();

        fetch(CHATBOT_QUEUE_CALL_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        })
          .then(function(res) {
            return res.text().then(function(text) {
              var data;
              try {
                data = text ? JSON.parse(text) : {};
              } catch (e) {
                data = { raw: text };
              }
              return { ok: res.ok, status: res.status, data: data };
            });
          })
          .then(function(result) {
            hideCallSubmittingPopup();
            submitBtn.disabled = false;
            var data = result.data || {};
            var status = result.status;
            var apiOk = status === 200 && data && data.success === true;

            if (apiOk) {
              callForm.reset();
              nameInput.value = '';
              phoneInput.value = '';
              clearFieldErrors();
              showCallModalSuccess();
              window.requestAnimationFrame(function() {
                var okBtn = document.getElementById('chatbot-call-success-dismiss');
                if (okBtn) okBtn.focus();
              });
              return;
            }

            showCallFormErrorState();
          })
          .catch(function() {
            hideCallSubmittingPopup();
            submitBtn.disabled = false;
            showCallFormErrorState();
          });
      });

      function updateVisibility() {
        if (window.scrollY >= SCROLL_THRESHOLD) {
          hasBeenVisible = true;
          if (!bubbleInitialized) {
            bubbleInitialized = true;
            initSessionBubble();
          }
        }
        var show = hasBeenVisible;
        floater.classList.toggle('is-visible', show);
        floater.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      function hideBubble() {
        bubble.classList.add('is-hidden');
        bubble.setAttribute('aria-hidden', 'true');
      }

      function showBubble() {
        bubble.classList.remove('is-hidden');
        bubble.setAttribute('aria-hidden', 'false');
      }

      function scheduleBubbleHide() {
        window.clearTimeout(window._chatbotBubbleTimeout);
        window._chatbotBubbleTimeout = window.setTimeout(hideBubble, MESSAGE_DURATION_MS);
      }

      function initSessionBubble() {
        hideBubble();
        window.clearTimeout(window._chatbotCopyRevealTimeout);
        window._chatbotCopyRevealTimeout = window.setTimeout(function() {
          showBubble();
          scheduleBubbleHide();
        }, COPY_REVEAL_DELAY_MS);
      }

      var openChatDirectly = floater.getAttribute('data-open-chat-directly') === 'true';

      function openChatwootChat() {
        trackChatbotEvent('Chat click');
        // Main site uses LimeChat concierge (see limeChat.liquid), not $chatwoot.
        var conciergeBtn = document.querySelector('#concierge-chatbot button');
        if (conciergeBtn) {
          conciergeBtn.click();
          return;
        }
        if (window.$chatwoot && typeof window.$chatwoot.toggle === 'function') {
          window.$chatwoot.toggle();
        }
      }

      if (trigger) {
        trigger.addEventListener('click', function() {
          trackChatbotEvent('Ask AI click');
          if (openChatDirectly) {
            openChatwootChat();
            return;
          }
          toggleShared();
        });
      }

      var toolbarChatTriggers = document.querySelectorAll('[data-chatbot-toolbar-trigger]');
      if (toolbarChatTriggers.length) {
        floater.classList.add('is-toolbar-embedded');
        floater.setAttribute('aria-hidden', 'true');
        toolbarChatTriggers.forEach(function(btn) {
          btn.addEventListener('click', function(ev) {
            ev.preventDefault();
            trackChatbotEvent('Ask AI click');
            if (openChatDirectly) {
              openChatwootChat();
              return;
            }
            toggleShared();
          });
        });
      }

      if (bubbleClose) {
        bubbleClose.addEventListener('click', function(ev) {
          ev.preventDefault();
          ev.stopPropagation();
          window.clearTimeout(window._chatbotBubbleTimeout);
          hideBubble();
        });
      }

      if (!toolbarChatTriggers.length) {
        window.addEventListener('scroll', function() {
          updateVisibility();
        }, { passive: true });

        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', function() {
            updateVisibility();
          });
        } else {
          updateVisibility();
        }
      }

}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initChatbotAiWidget);
  } else {
    initChatbotAiWidget();
  }
}

Shopify._cartBtnAnimationTimer = null;
Shopify._cartBtnAnimationManyTimer = null;
Shopify._cartBtnAnimationSeq = 0;

Shopify.cartBtnAnimation = function (cart) {
  const toolbars = document.querySelectorAll(".hdt-section-toolbar-mobile-cart");
  if (!toolbars.length) return;

  const headerCountEl = document.querySelector(
    "#cart-icon-bubble hdt-cart-count, .hdt-site-nav_cart hdt-cart-count",
  );
  const fromHeader = Number.parseInt(
    headerCountEl && headerCountEl.textContent,
    10,
  );
  const fromCart = cart && Number(cart.item_count);
  const itemCount = Number.isFinite(fromHeader)
    ? fromHeader
    : Number.isFinite(fromCart)
      ? fromCart
      : 0;

  const seq = ++Shopify._cartBtnAnimationSeq;
  clearTimeout(Shopify._cartBtnAnimationTimer);
  clearTimeout(Shopify._cartBtnAnimationManyTimer);

  toolbars.forEach(function (toolbar) {
    toolbar.classList.remove("hdt-cart-count-one", "hdt-cart-count-many");
  });

  Shopify._cartBtnAnimationTimer = setTimeout(function () {
    if (seq !== Shopify._cartBtnAnimationSeq) return;

    toolbars.forEach(function (toolbar) {
      const activeIcon = toolbar.querySelector(".cart-active-state-icon");
      const normalIcon = toolbar.querySelector(".cart-normal-state-icon");
      const countEl = toolbar.querySelector("hdt-cart-count");
      if (!activeIcon || !normalIcon || !countEl) return;

      if (itemCount < 1) {
        activeIcon.classList.add("hide-active-icon");
        activeIcon.classList.remove("show-active-icon");
        normalIcon.classList.add("show-active-icon");
        normalIcon.classList.remove("hide-active-icon");
        countEl.classList.add("hide-cart-counter");
      } else {
        activeIcon.classList.add("show-active-icon");
        activeIcon.classList.remove("hide-active-icon");
        normalIcon.classList.add("hide-active-icon");
        normalIcon.classList.remove("show-active-icon");
        countEl.classList.remove("hide-cart-counter");
        toolbar.classList.add("hdt-cart-count-one");
      }
    });

    if (itemCount >= 1) {
      Shopify._cartBtnAnimationManyTimer = setTimeout(function () {
        if (seq !== Shopify._cartBtnAnimationSeq) return;
        toolbars.forEach(function (toolbar) {
          toolbar.classList.add("hdt-cart-count-many");
        });
      }, 800);
    }
  }, 300);
};

Shopify._on_cart_change = function () {
  fetch("/cart.js?t=" + Date.now(), { cache: "no-store" })
    .then((response) => response.json())
    .then((cartData) => {
      if (typeof window.paintAllCartCounts === "function") {
        window.paintAllCartCounts(cartData.item_count);
      }
      Shopify?.cartStickyHydrate?.(cartData);
      Shopify?.cartBtnAnimation?.(cartData);
      if (document.querySelector(".cart-progressBar")) {
        Shopify?.cartContractual?.(cartData);
      }
    })
    .catch((error) => console.error("Failed to fetch cart:", error));
};

document.addEventListener("cart:refresh", function () {
  Shopify._on_cart_change();
});

function lockPdpCartButtonToHeader() {
  const headerCount = document.querySelector("#cart-icon-bubble hdt-cart-count");
  if (!headerCount) return;

  const apply = function () {
    const n = headerCount.textContent.trim();
    document
      .querySelectorAll(".hdt-section-toolbar-mobile-cart hdt-cart-count")
      .forEach(function (el) {
        if (el === headerCount) return;
        if (el.textContent.trim() !== n) el.textContent = n;
        const count = Number.parseInt(n, 10) || 0;
        el.classList.toggle("hide-cart-counter", count < 1);
      });
  };

  apply();
  const observer = new MutationObserver(apply);
  observer.observe(headerCount, {
    characterData: true,
    childList: true,
    subtree: true,
  });
  document
    .querySelectorAll(".hdt-section-toolbar-mobile-cart hdt-cart-count")
    .forEach(function (el) {
      observer.observe(el, { characterData: true, childList: true, subtree: true });
    });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", lockPdpCartButtonToHeader);
} else {
  lockPdpCartButtonToHeader();
}

window.Shopify = window.Shopify || {};

Shopify.radioFilter = function (checkbox) {
  if (!checkbox || !checkbox.name) return;
  document.getElementsByName(checkbox.name).forEach(function (item) {
    if (item !== checkbox) item.checked = false;
  });
};

Shopify.scrollToCenter = function (container, items) {
  if (!container || !items || !items.length) return;

  function centerItem(el) {
    var containerRect = container.getBoundingClientRect();
    var itemRect = el.getBoundingClientRect();
    var offset =
      (itemRect.left + itemRect.right) / 2 - (containerRect.left + containerRect.right) / 2;

    container.scrollBy({
      left: offset,
      behavior: "smooth",
    });
  }

  function scrollToEndForLastItem(el) {
    var containerWidth = container.offsetWidth;
    var itemOffsetLeft = el.offsetLeft;
    var itemWidth = el.offsetWidth;
    var scrollAmount = itemOffsetLeft - (containerWidth - itemWidth);

    container.scrollTo({
      left: scrollAmount,
      behavior: "smooth",
    });
  }

  items.forEach(function (item) {
    if (item.dataset.scrollCenterInit) return;
    item.dataset.scrollCenterInit = "true";
    item.addEventListener("click", function (e) {
      centerItem(e.currentTarget);
    });
  });

  var checkedItem = Array.from(items).find(function (item) {
    return (
      item.querySelector("input[type='checkbox']:checked") ||
      item.classList.contains("is-selected")
    );
  });

  if (checkedItem) {
    var lastItem = items[items.length - 1];
    setTimeout(function () {
      if (checkedItem === lastItem) {
        scrollToEndForLastItem(checkedItem);
      } else {
        centerItem(checkedItem);
      }
    }, 50);
  }
};

(function initLightningSaleCountdown() {
  if (window.__lightningSaleTimerBooted) return;
  window.__lightningSaleTimerBooted = true;

  var MS_THRESHOLD = 1e12;

  function getEndTimeMs(timer) {
    var raw = timer.getAttribute("data-sale-timestamp");
    if (raw) {
      var n = Number(raw);
      if (!Number.isNaN(n) && n > 0) {
        return n < MS_THRESHOLD ? n * 1000 : n;
      }
    }
    var saleData = timer.getAttribute("saletimerdata");
    if (saleData) {
      var parsed = Date.parse(saleData);
      if (!Number.isNaN(parsed)) return parsed;
    }
    return 0;
  }

  function formatTime(distance, timer) {
    var totalSeconds = Math.floor(distance / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;
    var compact =
      timer.closest(".lightingsale_forproductvarient") ||
      timer.closest(".st-lightning-sale-wrapper") ||
      timer.getAttribute("data-timer-format") === "colon";
    if (compact) {
      return hours + "h:" + minutes + "m:" + seconds + "s";
    }
    return hours + "h : " + minutes + "m : " + seconds + "s";
  }

  function hideExpired(timer) {
    var searchWrapper = timer.closest(".st-lightning-sale-wrapper");
    if (searchWrapper) {
      searchWrapper.remove();
      return;
    }
    var variantWrap = timer.closest(".lightingsale_forproductvarient");
    if (variantWrap) {
      variantWrap.style.display = "none";
      return;
    }
    timer.style.display = "none";
  }

  window.initLightningSaleTimers = function () {
    document.querySelectorAll(".lightingsale").forEach(function (timer) {
      if (timer.getAttribute("data-timer-initialized") === "true") return;

      var timerElement = timer.querySelector(".lightingsaletimer");
      var endTime = getEndTimeMs(timer);
      if (!timerElement || !endTime) return;

      timer.setAttribute("data-timer-initialized", "true");

      function updateTimer() {
        var distance = endTime - Date.now();
        if (distance <= 0) {
          hideExpired(timer);
          return false;
        }
        timerElement.textContent = formatTime(distance, timer);
        return true;
      }

      if (updateTimer()) {
        var interval = setInterval(function () {
          if (!updateTimer()) clearInterval(interval);
        }, 1000);
      }
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      window.initLightningSaleTimers,
    );
  } else {
    window.initLightningSaleTimers();
  }

  if (typeof MutationObserver === "undefined") return;

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (mutation.type !== "childList" || !mutation.addedNodes.length) continue;
      for (var j = 0; j < mutation.addedNodes.length; j++) {
        var node = mutation.addedNodes[j];
        if (node.nodeType !== 1) continue;
        if (
          (node.classList && node.classList.contains("lightingsale")) ||
          (node.querySelector && node.querySelector(".lightingsale"))
        ) {
          window.initLightningSaleTimers();
          return;
        }
      }
    }
  });

  function startObserve() {
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.body) startObserve();
  else document.addEventListener("DOMContentLoaded", startObserve);
})();
